(function () {
  // Locale lookup. Strings come from locales/*.json via snippets/tsv-i18n-concierge.liquid.
  // Only display text is routed through here — intent matchers, brand patterns and the
  // moderation word list stay in English on purpose.
  function T(key, fallback) { return (window.TSV_T && window.TSV_T[key]) || fallback; }

  // ==== Chip intents ======================================================
  // A chip is either a plain string (label doubles as the message sent) or an
  // object { label, intent, query }. The intent id is what routing keys off, so
  // a translated label no longer breaks the fast local handlers. `query` keeps
  // the English phrasing for handlers that echo it back.
  function chipT(intent, key, english) {
    return { label: T(key, english), intent: intent, query: english };
  }
  function chipLabel(c) { return typeof c === 'string' ? c : String((c && c.label) || ''); }
  function chipIntent(c) { return (c && typeof c === 'object' && c.intent) ? String(c.intent) : ''; }
  function chipQuery(c) { return typeof c === 'string' ? c : String((c && (c.query || c.label)) || ''); }

  // Binds the handler for a known intent. Returns false when the intent is
  // unknown, so callers fall back to the legacy English text matching (which
  // still covers chips the AI writes itself).
  function bindChipIntent(btn, intent, label, query) {
    switch (intent) {
      case 'signin':
        btn.classList.add('tsv-chip--signin');
        btn.addEventListener('click', function () { showLoginForm(); });
        return true;
      case 'register':
        btn.classList.add('tsv-chip--register');
        btn.addEventListener('click', function () {
          var returnUrl = CFG.returnUrl || window.location.pathname;
          window.location.href = '/account/register?return_url=' + encodeURIComponent(returnUrl);
        });
        return true;
      case 'latest_order':
      case 'orders':
        btn.addEventListener('click', function () { handleOrderLookupChip(query); });
        return true;
      case 'points':
        btn.addEventListener('click', function () { handleLoyaltyChip(query); });
        return true;
      case 'bestsellers':
        btn.addEventListener('click', function () { handleBestsellersChip(query, {}); });
        return true;
      case 'on_sale':
        btn.addEventListener('click', function () { handleBestsellersChip(query, { on_sale: true }); });
        return true;
      case 'contact':
        btn.classList.add('tsv-chip--contact');
        btn.addEventListener('click', function () { showContactForm(query); });
        return true;
      case 'track':
        btn.addEventListener('click', function () { handleTrackChip(query); });
        return true;
      case 'shortlist':
        btn.classList.add('tsv-chip--emailpicks');
        btn.classList.add('tsv-chip--primary');
        btn.addEventListener('click', function () { showEmailPicksForm(query); });
        return true;
      case 'newsletter':
        btn.classList.add('tsv-chip--newsletter');
        btn.classList.add('tsv-chip--primary');
        btn.addEventListener('click', function () { showNewsletterForm(query); });
        return true;
      case 'keep_chatting':
        btn.addEventListener('click', function () { tsvKeepChatting(); });
        return true;
      case 'past_chats':
        btn.addEventListener('click', function () { handlePastChatsChip(query); });
        return true;
      case 'scan_another':
        btn.addEventListener('click', function () { removeChips(); tsvOpenBarcodeScanner(); });
        return true;
      default:
        return false;
    }
  }

  var CFG = window.__TSV_CONFIG || {};
  var widget = document.getElementById('tsvConcierge');
  if (!widget) return;
  // Feature-flag helper. Defaults to TRUE for any flag not present so any
  // shipped feature stays live if the theme setting has not been added yet.
  // Explicit false in CFG.features turns the feature off.
  var TSV_F = CFG.features || {};
  function tsvFeatOn(name) {
    return TSV_F[name] !== false;
  }

  // Safety net: after every response cycle we check whether the tail of
  // the conversation ends with a chip strip. If not, we inject a smart
  // default set so the customer always has a next step to tap.
  function tsvEnsureFollowUpChips() {
    try {
      if (!messagesEl) return;
      var children = messagesEl.children;
      if (!children.length) return;
      // Look at the last 3 nodes. If any is a chip strip, we are fine.
      for (var i = children.length - 1; i >= Math.max(0, children.length - 3); i--) {
        var el = children[i];
        if (el && el.classList && (
          el.classList.contains('tsv-chips') ||
          el.classList.contains('tsv-recs__refine')
        )) {
          return;
        }
        // Any user bubble or contact form means we are still mid-flow.
        if (el && el.classList && (
          el.classList.contains('tsv-msg--user') ||
          el.classList.contains('tsv-concierge__contact')
        )) {
          return;
        }
      }
      // No chips detected. Inject a smart default set.
      var signedIn = !!(CFG.customer && (CFG.customer.email || CFG.customer.id));
      var defaults;
      if (signedIn) {
        defaults = [chipT('bestsellers','cg_chip_pick_new','Pick something new for me'), chipT('','cg_chip_wear_today','What should I wear today'), chipT('on_sale','cg_chip_on_sale','What is on sale this week'), chipT('latest_order','cg_chip_latest_order','My latest order')];
        if (tsvFeatOn('giftingMode')) defaults.push(chipT('','cg_chip_buy_gift','Help me buy a gift'));
      } else {
        defaults = [chipT('bestsellers','cg_chip_pick_new','Pick something new for me'), chipT('','cg_chip_wear_today','What should I wear today'), chipT('on_sale','cg_chip_on_sale','What is on sale this week'), chipT('signin','cg_chip_signin',T('cg_chip_signin_picks', 'Sign in for personalised picks'))];
        if (tsvFeatOn('giftingMode')) defaults.push(chipT('','cg_chip_buy_gift','Help me buy a gift'));
      }
      appendChips(defaults, true);
    } catch (_) {}
  }

  // ==== Feature 15: voice input (Web Speech Recognition) ====================
  // iOS restriction: every iOS browser (Chrome, Firefox, Edge, Brave) uses
  // Apple's WKWebView engine, which does NOT implement SpeechRecognition.
  // Only Safari on iOS exposes it, and even then with quirks. We hard-hide
  // the mic button on any iOS non-Safari browser and try-instantiate as a
  // final safety net where the API is exposed as a stub that will fail.
  function tsvIsIos() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent || '')
      || (navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1);
  }
  function tsvIsIosNonSafari() {
    if (!tsvIsIos()) return false;
    var ua = navigator.userAgent || '';
    // Chrome iOS is 'CriOS', Firefox iOS is 'FxiOS', Edge iOS is 'EdgiOS'.
    return /CriOS|FxiOS|EdgiOS|OPT\//.test(ua);
  }
  function tsvSetupVoiceInput() {
    if (!tsvFeatOn('voiceInput')) return;
    var micBtn = document.getElementById('tsvMicBtn');
    if (!micBtn) return;
    var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) {
      try { console.warn('[tsv] SpeechRecognition unsupported in this browser'); } catch (_) {}
      micBtn.style.display = 'none';
      return;
    }
    // iOS non-Safari: SR may be exposed as a stub but never actually works.
    if (tsvIsIosNonSafari()) {
      try { console.warn('[tsv] Voice input unavailable on iOS non-Safari browsers (Apple platform restriction). Try Safari on this device.'); } catch (_) {}
      micBtn.style.display = 'none';
      return;
    }
    // Sanity-instantiate. If constructor throws, hide the button.
    try { var _probe = new SR(); _probe = null; }
    catch (probeErr) {
      try { console.warn('[tsv] SpeechRecognition instantiate failed', probeErr); } catch (_) {}
      micBtn.style.display = 'none';
      return;
    }
    micBtn.style.display = 'inline-flex';
    var recog = null;
    var listening = false;
    var micGrantedBefore = false;

    function startRecog() {
      try {
        recog = new SR();
        recog.lang = (CFG.locale && CFG.locale.length >= 2) ? CFG.locale : 'en-IE';
        recog.interimResults = false;
        recog.maxAlternatives = 1;
        recog.continuous = false;
        recog.onstart = function () { listening = true; micBtn.classList.add('is-listening'); };
        recog.onresult = function (e) {
          try {
            var transcript = e.results[0][0].transcript || '';
            if (transcript && inputEl) {
              inputEl.value = transcript;
              setTimeout(function () {
                if (form && form.requestSubmit) form.requestSubmit();
                else if (form) form.dispatchEvent(new Event('submit', { cancelable: true }));
              }, 250);
            }
          } catch (_) {}
        };
        recog.onerror = function (ev) {
          try { console.warn('[tsv] SpeechRecognition error', ev && ev.error); } catch (_) {}
          listening = false;
          micBtn.classList.remove('is-listening');
          // Common iOS error: not-allowed. Prompt the customer to try again after granting mic.
          if (ev && ev.error === 'not-allowed') {
            try {
              inputEl && (inputEl.placeholder = T('cg_voice_permission','Voice needs microphone permission'));
              setTimeout(function () { if (inputEl) inputEl.placeholder = T('cg_input_placeholder','Ask about a scent, mood, or gift'); }, 3000);
            } catch (_) {}
          }
        };
        recog.onend = function () { listening = false; micBtn.classList.remove('is-listening'); };
        recog.start();
      } catch (err) {
        try { console.warn('[tsv] SpeechRecognition failed to start', err); } catch (_) {}
        listening = false;
        micBtn.classList.remove('is-listening');
      }
    }

    micBtn.addEventListener('click', function () {
      if (listening) { try { recog && recog.stop(); } catch (_) {} return; }
      // On iOS, prime microphone permission via getUserMedia BEFORE calling
      // recog.start(). Without this, iOS never surfaces the permission
      // prompt and SpeechRecognition fires an immediate not-allowed.
      var needsMicPermPrime = !micGrantedBefore
        && navigator.mediaDevices
        && typeof navigator.mediaDevices.getUserMedia === 'function';
      if (needsMicPermPrime) {
        try {
          navigator.mediaDevices.getUserMedia({ audio: true }).then(function (stream) {
            micGrantedBefore = true;
            // Immediately stop the stream — we only used it to trigger the
            // permission prompt. SpeechRecognition will re-open its own.
            try { stream.getTracks().forEach(function (t) { t.stop(); }); } catch (_) {}
            startRecog();
          }).catch(function (err) {
            try { console.warn('[tsv] mic permission denied', err); } catch (_) {}
            try {
              inputEl && (inputEl.placeholder = T('cg_voice_permission','Voice needs microphone permission'));
              setTimeout(function () { if (inputEl) inputEl.placeholder = T('cg_input_placeholder','Ask about a scent, mood, or gift'); }, 3000);
            } catch (_) {}
          });
        } catch (err) {
          // Older browsers with no mediaDevices — just try recog directly.
          startRecog();
        }
      } else {
        startRecog();
      }
    });
  }

  // ==== Feature 16: voice output (Web Speech Synthesis) =====================
  // iOS Safari requires the FIRST speechSynthesis.speak() to happen from
  // a user-gesture handler, else it silently drops. So on toggle-on we
  // speak a short warm-up phrase immediately. That unlocks the API for
  // the rest of the session.
  var _tsvVoiceOn = false;
  var _tsvVoicePrimed = false;
  var _tsvVoiceBtn = null;
  function _tsvMarkSpeaking(u) {
    if (!_tsvVoiceBtn) return;
    _tsvVoiceBtn.classList.add('is-speaking');
    u.onend = u.onerror = function () {
      if (_tsvVoiceBtn) _tsvVoiceBtn.classList.remove('is-speaking');
    };
  }
  function tsvSetupVoiceOutput() {
    if (!tsvFeatOn('voiceOutput')) return;
    if (!window.speechSynthesis) return;
    var btn = document.getElementById('tsvVoiceBtn');
    if (!btn) return;
    _tsvVoiceBtn = btn;
    btn.style.display = 'inline-flex';
    try { _tsvVoiceOn = window.localStorage.getItem('tsv_voice_out') === '1'; } catch (_) {}
    if (_tsvVoiceOn) btn.classList.add('is-on');
    // Cache: chosen English voice. Populated by _tsvPickEnglishVoice.
    var _tsvVoice = null;
    function _tsvPickEnglishVoice() {
      if (_tsvVoice) return _tsvVoice;
      try {
        var voices = window.speechSynthesis.getVoices() || [];
        try { console.warn('[tsv] Available voices:', voices.map(function (v) { return v.name + ' (' + v.lang + ')'; }).join(', ')); } catch (_) {}
        // Prefer Irish English if present, then any English voice.
        _tsvVoice = voices.find(function (v) { return /^en-IE/i.test(v.lang); })
          || voices.find(function (v) { return /^en/i.test(v.lang); })
          || voices[0]
          || null;
        return _tsvVoice;
      } catch (_) { return null; }
    }
    // Voices load async on iOS; register the change event to pick when ready.
    try {
      if (typeof window.speechSynthesis.onvoiceschanged !== 'undefined') {
        window.speechSynthesis.onvoiceschanged = function () { _tsvVoice = null; _tsvPickEnglishVoice(); };
      }
      _tsvPickEnglishVoice();
    } catch (_) {}

    // Helper: fire an utterance with logging + speaking indicator.
    function _tsvFireUtterance(text) {
      try {
        var u = new SpeechSynthesisUtterance(text);
        var v = _tsvPickEnglishVoice();
        if (v) { u.voice = v; u.lang = v.lang; }
        else { u.lang = (CFG.locale && CFG.locale.length >= 2) ? CFG.locale : 'en-US'; }
        u.rate = 1.0; u.pitch = 1.0; u.volume = 1.0;
        u.onstart = function () {
          try { console.warn('[tsv] utterance start:', text.slice(0, 40)); } catch (_) {}
          if (_tsvVoiceBtn) _tsvVoiceBtn.classList.add('is-speaking');
        };
        u.onend = function () {
          try { console.warn('[tsv] utterance end'); } catch (_) {}
          if (_tsvVoiceBtn) _tsvVoiceBtn.classList.remove('is-speaking');
        };
        u.onerror = function (e) {
          try { console.warn('[tsv] utterance error', e && e.error); } catch (_) {}
          if (_tsvVoiceBtn) _tsvVoiceBtn.classList.remove('is-speaking');
        };
        try { window.speechSynthesis.resume(); } catch (_) {}
        window.speechSynthesis.speak(u);
        return true;
      } catch (err) {
        try { console.warn('[tsv] fireUtterance threw', err); } catch (_) {}
        return false;
      }
    }

    // Helper: turn voice ON. Speaks warm-up synchronously so iOS can
    // validate the user-gesture unlock. Never called from setTimeout.
    function _tsvActivateVoice() {
      _tsvVoiceOn = true;
      btn.classList.add('is-on');
      try { window.localStorage.setItem('tsv_voice_out', '1'); } catch (_) {}
      _tsvFireUtterance(T('cg_voice_on','Voice replies are on'));
      _tsvVoicePrimed = true;
      // Follow up with a chat message so the customer sees clear feedback
      // + the silent-switch hint on iOS. This message is chat-native, not
      // just a placeholder swap that vanishes.
      try {
        setTimeout(function () {
          var hint = tsvIsIos()
            ? T('cg_voice_replies_on', 'Voice replies are on. If you can see the speaker icon pulse but do not hear anything, check the silent switch on the side of your iPhone is flipped UP (no orange showing).')
            : T('cg_voice_on_long','Voice replies are on. AI responses will be read aloud from here.');
          appendConcierge(hint, true);
        }, 30);
      } catch (_) {}
    }

    btn.addEventListener('click', function () {
      // Turning OFF — always allowed, no confirmation.
      if (_tsvVoiceOn) {
        _tsvVoiceOn = false;
        btn.classList.remove('is-on');
        btn.classList.remove('is-speaking');
        try { window.localStorage.setItem('tsv_voice_out', '0'); } catch (_) {}
        try { window.speechSynthesis.cancel(); } catch (_) {}
        return;
      }
      // Turning ON — first time in the session shows a confirmation card
      // whose Yes button fires the unlock (so we keep the user-gesture
      // chain that iOS requires). Subsequent toggle-ons skip the confirm.
      var confirmedOnceKey = 'tsv_voice_confirmed_once';
      var already = false;
      try { already = window.localStorage.getItem(confirmedOnceKey) === '1'; } catch (_) {}
      if (already) { _tsvActivateVoice(); return; }
      // Build and mount the confirmation card. Must be inserted right now
      // so the Yes button lives inside the current tap flow's DOM tree.
      var wrap = document.createElement('div');
      wrap.className = 'tsv-msg tsv-msg--concierge';
      wrap.style.borderLeftColor = 'var(--tsv-ivory)';
      wrap.innerHTML = '<div style="font-size:13px;line-height:1.55;margin-bottom:10px">Turn on voice replies? I will read the AI responses aloud. You can turn it off any time.</div>' +
                       '<div style="display:flex;gap:8px;flex-wrap:wrap">' +
                         '<button type="button" class="tsv-chip tsv-chip--primary" data-tsv-voice-yes style="padding:8px 14px;padding-left:14px">Yes, turn on</button>' +
                         '<button type="button" class="tsv-chip" data-tsv-voice-no>No thanks</button>' +
                       '</div>';
      messagesEl.appendChild(wrap);
      try { messagesEl.scrollTop = messagesEl.scrollHeight; } catch (_) {}
      var yesBtn = wrap.querySelector('[data-tsv-voice-yes]');
      var noBtn = wrap.querySelector('[data-tsv-voice-no]');
      if (yesBtn) {
        yesBtn.addEventListener('click', function () {
          _tsvActivateVoice();
          try { window.localStorage.setItem(confirmedOnceKey, '1'); } catch (_) {}
          try { wrap.parentNode && wrap.parentNode.removeChild(wrap); } catch (_) {}
        });
      }
      if (noBtn) {
        noBtn.addEventListener('click', function () {
          try { wrap.parentNode && wrap.parentNode.removeChild(wrap); } catch (_) {}
        });
      }
    });
  }
  // Widget-scope voice cache reused by tsvSpeak — populated by
  // tsvSetupVoiceOutput but read here.
  var _tsvSpeakVoiceCache = null;
  function _tsvPickVoiceForSpeak() {
    if (_tsvSpeakVoiceCache) return _tsvSpeakVoiceCache;
    try {
      var voices = window.speechSynthesis.getVoices() || [];
      _tsvSpeakVoiceCache = voices.find(function (v) { return /^en-IE/i.test(v.lang); })
        || voices.find(function (v) { return /^en/i.test(v.lang); })
        || voices[0] || null;
      return _tsvSpeakVoiceCache;
    } catch (_) { return null; }
  }
  function tsvSpeak(text) {
    if (!_tsvVoiceOn || !window.speechSynthesis) return;
    if (!text) return;
    var clean = String(text).replace(/\[(REC|CHIP)[^\]]*\]/g, '').replace(/\s+/g, ' ').trim();
    if (!clean) return;
    try {
      // iOS: resume as insurance (silently-paused queue after idle).
      try { window.speechSynthesis.resume(); } catch (_) {}
      // Only cancel if we are actually still speaking, otherwise cancel
      // on iOS breaks the pipeline for all subsequent speak() calls.
      if (window.speechSynthesis.speaking) {
        try { window.speechSynthesis.cancel(); } catch (_) {}
      }
      var u = new SpeechSynthesisUtterance(clean);
      var v = _tsvPickVoiceForSpeak();
      if (v) { u.voice = v; u.lang = v.lang; }
      else { u.lang = (CFG.locale && CFG.locale.length >= 2) ? CFG.locale : 'en-US'; }
      u.rate = 1.0; u.pitch = 1.0; u.volume = 1.0;
      u.onstart = function () {
        try { console.warn('[tsv] AI reply speech start'); } catch (_) {}
        if (_tsvVoiceBtn) _tsvVoiceBtn.classList.add('is-speaking');
      };
      u.onend = function () {
        try { console.warn('[tsv] AI reply speech end'); } catch (_) {}
        if (_tsvVoiceBtn) _tsvVoiceBtn.classList.remove('is-speaking');
      };
      u.onerror = function (e) {
        try { console.warn('[tsv] AI reply speech error', e && e.error); } catch (_) {}
        if (_tsvVoiceBtn) _tsvVoiceBtn.classList.remove('is-speaking');
      };
      window.speechSynthesis.speak(u);
    } catch (err) {
      try { console.warn('[tsv] tsvSpeak failed', err); } catch (_) {}
    }
  }
  function tsvSpeak(text) {
    if (!_tsvVoiceOn || !window.speechSynthesis) return;
    if (!text) return;
    var clean = String(text).replace(/\[(REC|CHIP)[^\]]*\]/g, '').replace(/\s+/g, ' ').trim();
    if (!clean) return;
    try {
      var u = new SpeechSynthesisUtterance(clean);
      u.lang = (CFG.locale && CFG.locale.length >= 2) ? CFG.locale : 'en-IE';
      u.rate = 1.0; u.pitch = 1.0;
      window.speechSynthesis.speak(u);
    } catch (_) {}
  }

  var messagesEl = document.getElementById('tsvMessages');
  var inputEl = document.getElementById('tsvInput');
  var form = widget.querySelector('[data-tsv-form]');
  var toggleBtn = widget.querySelector('[data-tsv-toggle]');
  var closeBtn = widget.querySelector('[data-tsv-close]');
  var backdropEl = widget.querySelector('[data-tsv-backdrop]');
  if (backdropEl && backdropEl.parentNode !== document.body) {
    document.body.appendChild(backdropEl);
  }
  var sendBtn = form ? form.querySelector('.tsv-concierge__send') : null;

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia && window.matchMedia('(max-width: 500px)').matches;
  var hasGreeted = false;
  // Clear the Liquid-provided static placeholder before the typewriter
  // starts, so the customer doesn't see a static line flash then get replaced.
  try { if (inputEl) inputEl.placeholder = ''; } catch (_) {}
  // NOTE: full-width text bubbles are styled in tsv-concierge.css via the
  // .tsv-msg--text marker class (added in typeConcierge / appendConcierge).

  // Session ID persists across page loads so conversations continue
  var SESSION_KEY = 'tsv_concierge_session';
  function makeId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'sess-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }
  var sessionId;
  try {
    sessionId = window.localStorage.getItem(SESSION_KEY);
    if (!sessionId) {
      sessionId = makeId();
      window.localStorage.setItem(SESSION_KEY, sessionId);
    }
  } catch (e) {
    sessionId = makeId();
  }

  // Shopping bag awareness (feature #629). Cached snapshot of Shopify's
  // /cart.js so /chat calls can send it to the worker for the AI to
  // reason over ("what layers with the Jo Malone you have", "your bag
  // total is €X, this fits your budget"). Refreshed on widget open, on
  // Shopify's cart:update events, and best-effort right before send so
  // the AI always sees the latest.
  var _tsvShoppingBag = { items: [], count: 0, subtotal_cents: 0, currency: 'EUR', last_fetched: 0 };
  // Normalise ANY cart shape into the payload the worker expects. Accepts
  // both Shopify-style cart JSON (product_id, product_title, price in
  // cents, item_count, total_price) and a lighter custom-cart shape
  // (title, vendor, price string, count/total).
  function tsvNormaliseShoppingBag(raw) {
    if (!raw) return null;
    // Accept: array of items, or object with items/lines/entries/products.
    var itemsRaw;
    if (Array.isArray(raw)) {
      itemsRaw = raw;
      raw = { items: raw };
    } else if (typeof raw === 'object') {
      itemsRaw = raw.items || raw.lines || raw.entries || raw.products || raw.cart_items || [];
    } else {
      return null;
    }
    if (!Array.isArray(itemsRaw)) itemsRaw = [];
    // Price detection: some carts store cents (integer 11390), some store
    // euros as float (113.90), some as strings ("€113.90" or "113,90").
    function toCents(v) {
      if (v == null || v === '') return 0;
      if (typeof v === 'number') {
        // Shopify /cart.js, the Ajax API and the Storefront API all use INTEGER
        // CENTS (4640 means EUR 46.40). Bespoke theme stores usually hold euro
        // floats (46.4). So a whole number is already cents, a fractional one
        // is euros. The previous rule multiplied 4640 by 100 and told the AI
        // the bottle cost EUR 4,640.
        if (Math.floor(v) !== v) return Math.round(v * 100);
        return Math.round(v);
      }
      var s = String(v).replace(/[^0-9.,-]/g, '').replace(',', '.');
      var n = parseFloat(s);
      if (isNaN(n)) return 0;
      // Same rule for strings: "46.40" / "46,40" is euros, "4640" is cents.
      return /\./.test(s) ? Math.round(n * 100) : Math.round(n);
    }
    var normItems = itemsRaw.slice(0, 12).map(function (it) {
      if (!it || typeof it !== 'object') return null;
      var priceRaw = it.price != null ? it.price : (it.unit_price != null ? it.unit_price : (it.final_price != null ? it.final_price : (it.original_price != null ? it.original_price : 0)));
      var priceCents = toCents(priceRaw);
      var qty = Number(it.quantity || it.qty || 1);
      var lineRaw = it.line_price != null ? it.line_price : (it.final_line_price != null ? it.final_line_price : (it.total != null ? it.total : (priceCents * qty)));
      var lineCents = toCents(lineRaw);
      var title = String(it.product_title || it.title || it.name || it.product_name || '');
      var vendor = String(it.vendor || it.brand || it.brand_name || '');
      var priceStr = it.price_eur || (priceCents ? '€' + (priceCents / 100).toFixed(2) : '');
      var lineStr = it.line_price_eur || (lineCents ? '€' + (lineCents / 100).toFixed(2) : '');
      return {
        product_id: String(it.product_id || it.id || it.productId || ''),
        variant_id: String(it.variant_id || it.variantId || ''),
        title: title,
        vendor: vendor,
        quantity: qty,
        price_eur: priceStr,
        line_price_eur: lineStr,
        url: String(it.url || it.link || '')
      };
    }).filter(function (it) { return it && it.title; });
    var count = Number(
      raw.item_count != null ? raw.item_count :
      (raw.count != null ? raw.count :
      (raw.total_items != null ? raw.total_items :
      (raw.itemCount != null ? raw.itemCount :
      normItems.length)))
    );
    var totalRaw = raw.total_price != null ? raw.total_price : (raw.subtotal != null ? raw.subtotal : (raw.total != null ? raw.total : 0));
    var totalCents = toCents(totalRaw);
    // If no total but we have items, compute from lines.
    if (!totalCents && normItems.length) {
      totalCents = normItems.reduce(function (sum, it) {
        var s = String(it.line_price_eur || '').replace(/[^0-9.,-]/g, '').replace(',', '.');
        var n = parseFloat(s);
        return sum + (isNaN(n) ? 0 : Math.round(n * 100));
      }, 0);
    }
    var subtotalStr = raw.subtotal_eur || (totalCents ? '€' + (totalCents / 100).toFixed(2) : '');
    return {
      items: normItems,
      count: count || normItems.length,
      subtotal_cents: totalCents,
      subtotal_eur: subtotalStr,
      currency: String(raw.currency || 'EUR'),
      last_fetched: Date.now()
    };
  }
  // Auto-discover the customer's shopping bag from any custom cart shape
  // the theme uses. Bespoke Shopify themes often store their real cart
  // state in observable stores (MobX-style Store.state.cart, custom
  // window.TSV_CART_CONFIG, etc.) and only sync back to /cart.js on
  // page load or checkout — meaning /cart.js can be stale even when
  // the visible cart drawer has items. This function tries all the
  // common patterns and returns the first one that has items.
  function tsvAutoDetectCart() {
    var probes = [];
    try { if (typeof window.tsvGetShoppingBag === 'function') probes.push({ name: 'window.tsvGetShoppingBag', get: function(){ return window.tsvGetShoppingBag(); } }); } catch (_) {}
    try { if (window.Store && window.Store.state && window.Store.state.cart) probes.push({ name: 'window.Store.state.cart', get: function(){ return window.Store.state.cart; } }); } catch (_) {}
    try { if (window.TSV_CART_CONFIG && window.TSV_CART_CONFIG.cart) probes.push({ name: 'window.TSV_CART_CONFIG.cart', get: function(){ return window.TSV_CART_CONFIG.cart; } }); } catch (_) {}
    try { if (window.tsvCart && (window.tsvCart.items || window.tsvCart.item_count)) probes.push({ name: 'window.tsvCart', get: function(){ return window.tsvCart; } }); } catch (_) {}
    try { if (window.Shopify && window.Shopify.cart) probes.push({ name: 'window.Shopify.cart', get: function(){ return window.Shopify.cart; } }); } catch (_) {}
    try { if (window.CartJS && window.CartJS.cart) probes.push({ name: 'window.CartJS.cart', get: function(){ return window.CartJS.cart; } }); } catch (_) {}
    try { if (window.theme && window.theme.cart) probes.push({ name: 'window.theme.cart', get: function(){ return window.theme.cart; } }); } catch (_) {}
    for (var i = 0; i < probes.length; i++) {
      try {
        var raw = probes[i].get();
        var norm = tsvNormaliseShoppingBag(raw);
        if (norm && norm.count > 0 && (norm.items || []).length > 0) {
          try { window.console && window.console.log && window.console.log('[tsv:bag] auto-detected via ' + probes[i].name + ':', norm.count, 'items'); } catch (_) {}
          return { source: probes[i].name, bag: norm };
        }
      } catch (_) {}
    }
    return null;
  }

  // THROTTLE: cart:refresh / cart:updated events can fire in a tight loop when
  // the theme re-dispatches a cart event on every /cart.js response. Cap the
  // bag refresh so we never hammer /cart.js. 12s was far too long: the customer
  // taps Add to bag on a card and asks to check out two seconds later, and the
  // widget then sends the worker the pre-add snapshot, which is how the AI came
  // to announce an empty bag while the cart badge showed 2 items.
  var TSV_BAG_STALE_MS = 2000;
  var _tsvBagLastFetch = 0;
  var _tsvBagInFlight = null;
  // Only fetch the live bag when the message is genuinely about the cart/bag.
  function tsvIsCartQuery(text) {
    return /\b(cart|bag|basket|checkout|what(?:'s| is| have i)? (?:in|got)|layer(?:s|ing)? with|added|my order|whats in)\b/i.test(String(text || ''));
  }
  function tsvRefreshShoppingBag() {
    var now = Date.now();
    if (_tsvBagInFlight) return _tsvBagInFlight;
    if ((now - _tsvBagLastFetch) < TSV_BAG_STALE_MS && _tsvShoppingBag) {
      return Promise.resolve(_tsvShoppingBag);
    }
    _tsvBagLastFetch = now;
    _tsvBagInFlight = _tsvRefreshShoppingBagImpl();
    Promise.resolve(_tsvBagInFlight).then(function () { _tsvBagInFlight = null; }, function () { _tsvBagInFlight = null; });
    return _tsvBagInFlight;
  }
  function _tsvRefreshShoppingBagImpl() {
    // 1) Explicit theme hook (window.tsvGetShoppingBag). Preferred if defined.
    try {
      if (typeof window.tsvGetShoppingBag === 'function') {
        var custom = window.tsvGetShoppingBag();
        return Promise.resolve(custom).then(function (r) {
          var norm = tsvNormaliseShoppingBag(r);
          if (norm && norm.count > 0) { _tsvShoppingBag = norm; return norm; }
          // Explicit hook returned nothing useful — fall through to auto-detect.
        }).catch(function () { return null; }).then(function () { return _tsvRefreshFallback(); });
      }
    } catch (_) {}
    return _tsvRefreshFallback();
  }

  function _tsvRefreshFallback() {
    // 2) Auto-detect. Walks Store.state.cart / TSV_CART_CONFIG / Shopify.cart
    //    / CartJS / theme.cart — whatever the theme actually populates.
    try {
      var detected = tsvAutoDetectCart();
      if (detected && detected.bag) {
        _tsvShoppingBag = detected.bag;
        return Promise.resolve(detected.bag);
      }
    } catch (_) {}
    // 3) Last-resort: Shopify's /cart.js Ajax endpoint. Only reliable when
    //    the theme actually syncs to it (many bespoke carts don't).
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var norm = tsvNormaliseShoppingBag(cart);
        if (norm) {
          _tsvShoppingBag = norm;
          try { window.console && window.console.log && window.console.log('[tsv:bag] fetched via /cart.js:', norm.count, 'items'); } catch (_) {}
        }
        return norm;
      }).catch(function () { return null; });
  }
  function tsvGetShoppingBag() {
    // Always return whatever snapshot we have so the worker can distinguish
    // "bag genuinely empty" from "bag not yet fetched". The old version
    // returned null on empty which meant the worker treated a legitimately
    // empty bag the same as "no data", and the AI kept refusing to answer
    // shopping-bag questions when the cache hadn't populated yet. The
    // worker's empty-state block already knows how to phrase an empty bag.
    var bag;
    if (!_tsvShoppingBag || !_tsvShoppingBag.items) {
      bag = { items: [], count: 0, subtotal_cents: 0, currency: 'EUR', last_fetched: 0, _fresh: false };
    } else {
      _tsvShoppingBag._fresh = _tsvShoppingBag.last_fetched > 0;
      bag = _tsvShoppingBag;
    }
    // Diagnostic: log the exact payload we're about to send. Open dev tools
    // (Cmd/Ctrl+Shift+I → Console tab) and look for [tsv:bag] to see what
    // the AI is receiving. If the count is 0 but you can see items in your
    // cart drawer, your custom cart isn't syncing to /cart.js — expose
    // window.tsvGetShoppingBag = () => Store.state.cart in your theme.
    try {
      if (window && window.console && window.console.log) {
        window.console.log('[tsv:bag] payload sent to worker:', {
          count: bag.count,
          items_len: (bag.items || []).length,
          subtotal_cents: bag.subtotal_cents,
          fresh: bag._fresh,
          first_title: (bag.items && bag.items[0] && bag.items[0].title) || null
        });
      }
    } catch (_) {}
    return bag;
  }
  // Refresh on relevant Shopify + browser events.
  // Cart event listeners removed: the widget no longer auto-fetches /cart.js on
  // every cart event (that caused a request storm). It fetches the bag ONLY when
  // the customer's message is actually about their cart (see tsvIsCartQuery).
  // window focus listener removed (was an extra /cart.js trigger on every tab focus).

  // Recently viewed products. Captures product info from any Shopify PDP
  // the customer lands on and stores it in localStorage so the /chat call
  // can send it to the worker. The worker injects it into the AI system
  // prompt so replies can reference what the customer was just browsing.
  // SHARED source of truth with the storefront Recently Viewed rail. This writer
  // stores rich product OBJECTS (each has a .handle); the rail reads the .handle
  // and the chat reads the full object. The rail's own string-recorder is disabled
  // so only ONE writer owns this key (no more shape collisions).
  var TSV_RECENT_KEY = 'tsv_recently_viewed';
  function tsvGetRecentlyViewed() {
    if (!tsvFeatOn('recentlyViewed')) return [];
    try {
      var list = JSON.parse(window.localStorage.getItem(TSV_RECENT_KEY) || '[]');
      return Array.isArray(list) ? list.slice(0, 8) : [];
    } catch (_) { return []; }
  }
  function tsvCaptureCurrentProduct() {
    try {
      var path = window.location.pathname || '';
      if (!/^\/products\//.test(path)) return;
      var meta = { url: path };
      meta.handle = (path.split('/products/')[1] || '').split(/[\/?#]/)[0];
      // Shopify usually exposes the product on ShopifyAnalytics.
      try {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
          var p = window.ShopifyAnalytics.meta.product;
          if (p.id) meta.product_id = String(p.id);
          if (p.type) meta.type = String(p.type);
          if (p.vendor) meta.vendor = String(p.vendor);
          if (p.variants && p.variants[0] && p.variants[0].price) {
            meta.price = '€' + (Number(p.variants[0].price) / 100).toFixed(2);
          }
        }
      } catch (_) {}
      // Fill from meta tags where needed.
      var titleEl = document.querySelector('meta[property="og:title"]');
      var imgEl = document.querySelector('meta[property="og:image"]');
      var vendorEl = document.querySelector('meta[property="product:brand"]');
      if (!meta.title) meta.title = titleEl ? String(titleEl.getAttribute('content') || '') : document.title;
      if (!meta.image) meta.image = imgEl ? String(imgEl.getAttribute('content') || '') : '';
      if (!meta.vendor && vendorEl) meta.vendor = String(vendorEl.getAttribute('content') || '');
      // Guard: need at least a title.
      if (!meta.title) return;
      meta.title = String(meta.title).slice(0, 120);
      meta.vendor = String(meta.vendor || '').slice(0, 60);
      var list = tsvGetRecentlyViewed();
      // Dedupe by product_id if present, otherwise by url.
      list = list.filter(function (x) {
        if (meta.product_id && x.product_id) return String(x.product_id) !== String(meta.product_id);
        return String(x.url || '') !== String(meta.url || '');
      });
      list.unshift(meta);
      if (list.length > 20) list = list.slice(0, 20);
      try { window.localStorage.setItem(TSV_RECENT_KEY, JSON.stringify(list)); } catch (_) {}
    } catch (_) {}
  }
  // Fire once on page load. Safe on non-product pages (returns early).
  try { tsvCaptureCurrentProduct(); } catch (_) {}

  // Placeholder typewriter. Continuously rotates through a set of prompts
  // in the chat input so the customer sees ideas of what to ask. Stops
  // instantly on focus (matches the header search overlay's behaviour).
  var TSV_PROMPTS = [
    T('cg_input_placeholder','Ask about a scent, mood, or gift'),
    T('cg_pr_summer','Recommend a fresh summer fragrance'),
    T('cg_pr_smells_like','What smells like Baccarat Rouge 540'),
    T('cg_pr_gift_sister','Gift for my sister who loves florals'),
    T('cg_pr_warm_cosy','Something warm and cosy for evenings'),
    T('cg_pr_on_sale','Show me what is on sale this week'),
    T('cg_pr_niche_under','Suggest a niche pick under 120 euro'),
    T('cg_chip_track_order','Track my order'),
    T('cg_pr_discovery','What is in the Discovery Collection')
  ];
  var tsvTypeTimer = null;
  var tsvTypeStopped = false;
  function tsvStopTypewriter() {
    tsvTypeStopped = true;
    if (tsvTypeTimer) { clearTimeout(tsvTypeTimer); tsvTypeTimer = null; }
    if (inputEl) inputEl.placeholder = '';
  }
  function tsvStartTypewriter() {
    if (!inputEl) return;
    tsvTypeStopped = false;
    var i = 0;   // index into TSV_PROMPTS
    var j = 0;   // index into the current prompt string
    var forward = true;
    var HOLD_FULL = 1800; // pause at end of a phrase
    var HOLD_EMPTY = 320; // pause before the next phrase starts
    var TYPE_MS = 45;
    var DELETE_MS = 22;
    function step() {
      if (tsvTypeStopped) return;
      var phrase = TSV_PROMPTS[i % TSV_PROMPTS.length];
      if (forward) {
        j++;
        inputEl.placeholder = phrase.slice(0, j);
        if (j >= phrase.length) {
          forward = false;
          tsvTypeTimer = setTimeout(step, HOLD_FULL);
          return;
        }
        tsvTypeTimer = setTimeout(step, TYPE_MS);
      } else {
        j--;
        inputEl.placeholder = phrase.slice(0, j);
        if (j <= 0) {
          forward = true;
          i++;
          tsvTypeTimer = setTimeout(step, HOLD_EMPTY);
          return;
        }
        tsvTypeTimer = setTimeout(step, DELETE_MS);
      }
    }
    step();
  }
  if (inputEl) {
    // Kick off the cycle after the widget mounts.
    setTimeout(tsvStartTypewriter, 700);
    // Clear placeholder on focus / click. Restart on blur if the customer
    // did not actually type anything.
    var onEnterInput = function () { tsvStopTypewriter(); };
    inputEl.addEventListener('focus', onEnterInput);
    inputEl.addEventListener('click', onEnterInput);
    inputEl.addEventListener('input', onEnterInput);
    inputEl.addEventListener('blur', function () {
      if (!inputEl.value || !inputEl.value.trim()) {
        // Small delay so a click on the send button lands first.
        setTimeout(tsvStartTypewriter, 200);
      }
    });
  }

  // Local snapshot key + preload state. SNAPSHOT_ID_KEY tags the snapshot
  // with the customer fingerprint at save time so we can invalidate the
  // cached chat if the sign-in state has flipped since (e.g. the user
  // signed out from the header dropdown).
  var SNAPSHOT_KEY = 'tsv_concierge_snapshot_' + sessionId;
  var SNAPSHOT_ID_KEY = 'tsv_concierge_snapshot_id_' + sessionId;
  var historyPromise = null;
  var historyLoaded = false;

  function customerFingerprint() {
    var c = CFG && CFG.customer;
    if (c && (c.email || c.id)) return String(c.email || c.id).toLowerCase();
    return 'anon';
  }

  function saveSnapshot() {
    try {
      if (!messagesEl) return;
      // Clone the message list and strip transient nodes (the "Signed in as X /
      // Updating your session" login card, the typing indicator) so they never
      // get frozen into the snapshot and replayed as stale UI after a reload.
      var clone = messagesEl.cloneNode(true);
      var junk = clone.querySelectorAll('.tsv-login, .tsv-typing, .tsv-login--done');
      for (var i = 0; i < junk.length; i++) {
        if (junk[i] && junk[i].parentNode) junk[i].parentNode.removeChild(junk[i]);
      }
      var html = clone.innerHTML || '';
      if (html) {
        window.localStorage.setItem(SNAPSHOT_KEY, html);
        window.localStorage.setItem(SNAPSHOT_ID_KEY, customerFingerprint());
      }
    } catch (_) {}
  }
  function loadSnapshot() {
    try {
      var savedFp = window.localStorage.getItem(SNAPSHOT_ID_KEY) || '';
      var nowFp = customerFingerprint();
      var raw = window.localStorage.getItem(SNAPSHOT_KEY) || '';
      // A) Explicit fingerprint mismatch (different customer signed in).
      if (savedFp && savedFp !== nowFp) {
        window.localStorage.removeItem(SNAPSHOT_KEY);
        window.localStorage.removeItem(SNAPSHOT_ID_KEY);
        return '';
      }
      // B) Currently anonymous but the cached chat is a signed-in
      // conversation. Catches legacy snapshots without a fingerprint AND
      // sign-out from the header dropdown without a full page reload.
      // Only invalidate the cached chat if we can positively see child
      // elements that ONLY exist inside signed-in cards. Using child-class
      // markers (tsv-order__ / tsv-vault__ / tsv-login__doneTitle) is
      // whitespace-safe unlike matching against the class attribute prefix.
      if (nowFp === 'anon' && raw &&
        /tsv-order__|tsv-vault__|tsv-login__doneTitle/.test(raw)) {
        window.localStorage.removeItem(SNAPSHOT_KEY);
        window.localStorage.removeItem(SNAPSHOT_ID_KEY);
        return '';
      }
      return raw;
    } catch (_) { return ''; }
  }
  function clearSnapshot() {
    try {
      window.localStorage.removeItem(SNAPSHOT_KEY);
      window.localStorage.removeItem(SNAPSHOT_ID_KEY);
    } catch (_) {}
  }

  function renderSkeleton() {
    if (!messagesEl) return;
    messagesEl.innerHTML =
      '<div class="tsv-skeleton">' +
        '<div class="tsv-skeleton__line" style="width:82%"></div>' +
        '<div class="tsv-skeleton__line" style="width:66%"></div>' +
        '<div class="tsv-skeleton__line" style="width:74%"></div>' +
      '</div>';
  }

  // Live authentication state watcher. Polls /account periodically and on
  // tab focus so that if the customer signs out from the header dropdown
  // (or in another tab), the chat notices within seconds and offers a
  // one-click return path. Also handles sign-in-in-another-tab.
  var authWatcherStarted = false;
  var authLastKnown = null;   // 'in' | 'out' | null (unknown)
  function currentAuthGuess() {
    var c = CFG.customer || {};
    return (c.id || c.email) ? 'in' : 'out';
  }
  function startAuthWatcher() {
    if (authWatcherStarted) return;
    authWatcherStarted = true;
    authLastKnown = currentAuthGuess();
    var pendingFlipCount = 0;
    var probe = function () {
      if (!widget.classList.contains('is-open')) return;
      fetch('/account', { method: 'GET', credentials: 'same-origin', redirect: 'follow', cache: 'no-store' })
        .then(function (r) {
          var vPath = '';
          try { vPath = new URL(r.url).pathname; } catch (_) { vPath = r.url; }
          var loggedIn = /^\/account(\/|$)/.test(vPath) && !/\/login/.test(vPath) && !/\/register/.test(vPath);
          var nowState = loggedIn ? 'in' : 'out';
          if (authLastKnown && nowState !== authLastKnown) {
            // Debounce: require two consecutive different probes before
            // acting. Prevents a transient 302/network blip from wiping a
            // valid signed-in session.
            pendingFlipCount++;
            if (pendingFlipCount >= 2) {
              handleAuthTransition(authLastKnown, nowState);
              authLastKnown = nowState;
              pendingFlipCount = 0;
            }
          } else {
            pendingFlipCount = 0;
            authLastKnown = nowState;
          }
        })
        .catch(function () {});
    };
    // Poll every 30 s while the widget is open. Cheap HEAD-style probe.
    setInterval(probe, 30000);
    // Also probe on focus / visibility return so it feels immediate.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) setTimeout(probe, 200);
    });
    window.addEventListener('focus', function () { setTimeout(probe, 200); });
  }
  function handleAuthTransition(prev, next) {
    if (prev === 'in' && next === 'out') {
      // Signed out somewhere else. Clear in-memory identity and cached chat
      // (which was tagged with the signed-in customer's fingerprint).
      CFG.customer = null;
      clearSnapshot();
      appendConcierge(T('cg_signed_out_notice', 'Looks like you have signed out. Sign back in to see your orders and rewards, or keep chatting anonymously.'), true);
      appendChips([chipT('signin','cg_chip_signin',chipT('signin','cg_chip_signin',T('cg_chip_signin_picks', 'Sign in for personalised picks'))), chipT('register','cg_chip_create_account',chipT('register','cg_chip_create_account','Create account')), chipT('keep_chatting','cg_chip_keep_chatting',chipT('keep_chatting','cg_chip_keep_chatting','Keep chatting with you'))], true);
      saveSnapshotWhenIdle();
    } else if (prev === 'out' && next === 'in') {
      // Signed in somewhere else. Kindest UX is to reload so Liquid re-emits
      // the full customer object into CFG. The snapshot rehydration will
      // reopen the widget instantly on the next page load.
      try { window.sessionStorage.setItem('tsv_concierge_reopen', '1'); } catch (_) {}
      appendConcierge(T('cg_signed_in_other_tab','You are signed in on another tab. Refreshing so I can see your account.'), true);
      setTimeout(function () { try { window.location.reload(); } catch (_) {} }, 1500);
    }
  }

  function preloadHistory() {
    if (historyPromise) return historyPromise;
    var endpoint = CFG.endpoint;
    if (!endpoint) { historyPromise = Promise.resolve(null); return historyPromise; }
    var historyUrl = endpoint.replace(/\/chat\/?$/, '/history');
    if (historyUrl === endpoint) historyUrl = endpoint + '/history';
    historyPromise = fetch(historyUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ session_id: sessionId })
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .catch(function () { return null; })
      .then(function (data) { historyLoaded = true; return data; });
    return historyPromise;
  }

  // Remember the vertical scroll position when we lock the page, so we can
  // restore it exactly when the chat closes.
  var lockedScrollY = 0;

  function lockPageScroll() {
    try {
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.top = '-' + lockedScrollY + 'px';
    } catch (_) {}
  }
  function unlockPageScroll() {
    try {
      document.body.style.top = '';
      if (lockedScrollY) window.scrollTo(0, lockedScrollY);
      lockedScrollY = 0;
    } catch (_) {}
  }

  // Keyboard-inset tracker. Sets --tsv-kb CSS variable to the current
  // keyboard height (0 when closed). CSS uses this as padding-bottom on
  // the panel so the input is always pushed above the keyboard. Does
  // NOT set inline height on the panel (that broke iOS's coordinate
  // system last time) — only pushes the CSS variable so layout stays
  // declarative.
  var _tsvKbHandler = null;
  function tsvAttachKeyboardTracker() {
    if (_tsvKbHandler || !window.visualViewport) return;
    _tsvKbHandler = function () {
      try {
        // Keyboard inset = window height minus visible viewport height.
        // Positive when keyboard is open, zero when closed.
        var kb = Math.max(0, (window.innerHeight || 0) - window.visualViewport.height);
        document.documentElement.style.setProperty('--tsv-kb', kb + 'px');
      } catch (_) {}
    };
    _tsvKbHandler();
    window.visualViewport.addEventListener('resize', _tsvKbHandler);
    window.visualViewport.addEventListener('scroll', _tsvKbHandler);
  }
  function tsvDetachKeyboardTracker() {
    if (!_tsvKbHandler) return;
    try {
      window.visualViewport.removeEventListener('resize', _tsvKbHandler);
      window.visualViewport.removeEventListener('scroll', _tsvKbHandler);
    } catch (_) {}
    _tsvKbHandler = null;
    try { document.documentElement.style.removeProperty('--tsv-kb'); } catch (_) {}
  }

  // ==== First-time onboarding tour (feature #528) =======================
  // Renders a 3-slide overlay INSIDE the messages area on a customer's
  // first widget open. Persists dismissal via localStorage so it never
  // shows again on the same browser. When the customer finishes or
  // skips, the callback runs the normal greeting flow.
  function showOnboardingTour(onDone) {
    if (!messagesEl) { if (typeof onDone === 'function') onDone(); return; }
    messagesEl.innerHTML = '';
    var overlay = document.createElement('div');
    overlay.className = 'tsv-onb';

    // Minimal editorial line-drawn SVG icons, one per slide. Ivory
    // stroke only, no fills, so they match the concierge palette.
    // Editorial line-drawn SVG icons. Each one reads instantly at a
    // glance so the customer knows what the slide is about without
    // needing the copy.
    // Slide 1: EXACT same fragrance-bottle silhouette used elsewhere in
    // the widget (see fallbackIcon() around line 2503). Keeps the
    // onboarding visually consistent with the product-card fallback.
    var iconBottle =
      '<svg class="tsv-onb__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M9 3 h6 v2 h1 v3 c3 1 4 4 4 7 v6 c0 1-1 2-2 2 h-10 c-1 0-2-1-2-2 v-6 c0-3 1-6 4-7 v-3 h1 z"/>' +
      '</svg>';
    // Slide 2: proper shopping bag — rectangular bag body with two
    // curved handles at the top, corner fold detail so it reads as
    // paper/tote rather than a briefcase.
    var iconShoppingBag =
      '<svg class="tsv-onb__icon" viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">' +
        // Left handle
        '<path d="M22 22V16a6 6 0 0 1 6-6"/>' +
        // Right handle
        '<path d="M42 22V16a6 6 0 0 0-6-6"/>' +
        // Bag body
        '<path d="M14 22h36l-3 34a4 4 0 0 1-4 4H21a4 4 0 0 1-4-4z"/>' +
        // Fold across the top for a paper-bag feel
        '<path d="M14 22l3 4h30l3-4"/>' +
      '</svg>';
    // Slide 3: simple question mark. Matches the slide question
    // T('cg_not_sure',"Not sure what to ask yet?") — reads instantly, no
    // ambiguity, universal symbol for "help / not sure / ask a
    // question". Editorial line drawing, ivory stroke.
    var iconQuestion =
      '<svg class="tsv-onb__icon" viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">' +
        // Outer circle
        '<circle cx="32" cy="32" r="24"/>' +
        // Question mark curve (top hook)
        '<path d="M24 24a8 8 0 0 1 16 0c0 5-4 6-6 9-1.5 2-2 3-2 5"/>' +
        // Question mark dot
        '<circle cx="32" cy="45" r="1.8" fill="currentColor" stroke="none"/>' +
      '</svg>';

    var slides = [
      {
        eyebrow: T('cg_ob_welcome','Welcome'),
        title: T('cg_i_find','I find fragrances for you.'),
        body: T('cg_ob_body_1','Describe a mood, an occasion, or a fragrance you already love. I will pick a small shortlist you can act on.'),
        icon: iconBottle,
        chips: [
          T('cg_ob_chip_moody','Something moody for winter evenings'),
          T('cg_ob_chip_mum','A gift for my mum, budget €80'),
          T('cg_ob_chip_smells','What smells like Baccarat Rouge?')
        ]
      },
      {
        eyebrow: T('cg_more_than_search','More than search'),
        title: T('cg_see_your_bag','I see your shopping bag, too.'),
        body: T('cg_ob_body_2','See what is in your bag, your last order, or your points. Ask what layers with a bottle, compare two picks, or email your shortlist.'),
        icon: iconShoppingBag,
        chips: [
          T('cg_ob_chip_layers','What layers with what I have added?'),
          T('cg_ob_chip_last_order','Track my last order'),
          T('cg_ob_chip_points','What are my Member’s Vault points?')
        ]
      },
      {
        eyebrow: T('cg_you_in_control','You are in control'),
        title: T('cg_not_sure','Not sure what to ask yet?'),
        body: T('cg_ob_body_3','No problem. Have a browse of the store. The Scent Expert bubble stays with you on every page, ready whenever you are.'),
        icon: iconQuestion
      }
    ];

    var current = 0;
    function render() {
      var slide = slides[current];
      var chipsHtml = '';
      if (slide.chips && slide.chips.length) {
        chipsHtml = '<div class="tsv-onb__chips">';
        slide.chips.forEach(function (c) {
          chipsHtml += '<button type="button" class="tsv-onb__chip" data-prompt="' + escapeHtml(c) + '">' + escapeHtml(c) + '</button>';
        });
        chipsHtml += '</div>';
      }
      var dotsHtml = '<div class="tsv-onb__dots">';
      for (var i = 0; i < slides.length; i++) {
        dotsHtml += '<span class="tsv-onb__dot' + (i === current ? ' is-active' : '') + '"></span>';
      }
      dotsHtml += '</div>';
      var isLast = current === slides.length - 1;
      var primaryLabel = isLast ? T('cg_explore_store','Explore the store') : 'Next';
      var secondaryLabel = current === 0 ? 'Skip' : 'Back';
      var storeUrl = (window.tsvStoreUrl || 'https://thescentvault.ie').replace(/\/+$/, '');
      overlay.innerHTML =
        '<div class="tsv-onb__card">' +
          (slide.icon ? '<div class="tsv-onb__iconWrap">' + slide.icon + '</div>' : '') +
          '<div class="tsv-onb__eyebrow">' + escapeHtml(slide.eyebrow) + '</div>' +
          '<div class="tsv-onb__title">' + escapeHtml(slide.title) + '</div>' +
          '<div class="tsv-onb__body">' + escapeHtml(slide.body) + '</div>' +
          chipsHtml +
          dotsHtml +
          '<div class="tsv-onb__actions">' +
            '<button type="button" class="tsv-onb__secondary" data-action="' + (current === 0 ? 'skip' : 'back') + '">' + secondaryLabel + '</button>' +
            '<button type="button" class="tsv-onb__primary" data-action="' + (isLast ? 'explore' : 'next') + '">' + primaryLabel + '</button>' +
          '</div>' +
        '</div>';
      wireSlide(storeUrl);
    }
    function wireSlide(storeUrl) {
      // Chip taps: dismiss the tour AND send the prompt as if the
      // customer typed it. Straight to first pick, zero friction.
      overlay.querySelectorAll('.tsv-onb__chip').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var prompt = btn.getAttribute('data-prompt') || '';
          finish(function () {
            try { inputEl.value = prompt; } catch (_) {}
            try { form.dispatchEvent(new Event('submit', { cancelable: true })); } catch (_) {}
          });
        });
      });
      overlay.querySelectorAll('[data-action]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var act = btn.getAttribute('data-action');
          if (act === 'next') { current += 1; render(); return; }
          if (act === 'back') { current -= 1; render(); return; }
          if (act === 'skip' || act === 'stay') { finish(); return; }
          if (act === 'explore') {
            // Close the widget and send the customer to the store home.
            finish(function () {
              try { close(); } catch (_) {}
              window.location.href = storeUrl;
            });
            return;
          }
        });
      });
    }
    function finish(after) {
      try { overlay.parentNode && overlay.parentNode.removeChild(overlay); } catch (_) {}
      if (typeof onDone === 'function') onDone();
      if (typeof after === 'function') { try { after(); } catch (_) {} }
    }
    render();
    messagesEl.appendChild(overlay);
  }

  // If the customer types a message while the first-visit tour is still on
  // screen, the tour must be cleared BEFORE we append their message, otherwise
  // the whole conversation renders underneath a ~500px tour block and looks
  // like it "won't scroll". Marks the tour as seen so it does not reappear.
  function tsvDismissOnboarding() {
    try {
      var onb = messagesEl && messagesEl.querySelector('.tsv-onb');
      if (onb && onb.parentNode) onb.parentNode.removeChild(onb);
    } catch (_) {}
    try { window.localStorage.setItem('tsv-onboarding-v1', '1'); } catch (_) {}
  }

  function open() {
    // Undo any minimised state and clear stale end-chat cards on re-open.
    widget.classList.remove('is-minimised');
    try {
      var stale = messagesEl && messagesEl.querySelector('.tsv-endchat');
      if (stale) { stale.parentNode.removeChild(stale); saveSnapshot(); }
    } catch (_) {}
    lockPageScroll();
    widget.classList.add('is-open');
    document.documentElement.classList.add('tsv-concierge-open');
    tsvAttachKeyboardTracker();
    startAuthWatcher();
    // Refresh the shopping bag snapshot when the widget opens so the
    // AI has current cart context on the customer's first send.
    try { tsvRefreshShoppingBag(); } catch (_) {}
    // Focus timing: on desktop we can wait for the panel entrance to settle.
    // On mobile (iOS Safari + Android Chrome) the soft keyboard will ONLY
    // open if focus() runs synchronously inside the user gesture that opened
    // the widget, or on a very short setTimeout that browsers still treat as
    // gesture-adjacent. 560ms broke the gesture chain, so tapping the bubble
    // opened the panel but not the keyboard, and the user had to tap the
    // input a second time (which was landing on a resizing panel — bad).
    // Detect mobile by pointer type and use an immediate focus there.
    var _isMobileWidget = window.matchMedia && window.matchMedia('(pointer:coarse), (max-width:500px)').matches;
    if (_isMobileWidget) {
      // MOBILE: do NOT auto-focus the input. Auto-focus on tap makes the
      // keyboard open the moment the widget starts animating in, which
      // means the panel positions itself against a viewport that's about
      // to shrink, and ends up underneath the keyboard. The user taps
      // the input when they want to type — that's the platform-native
      // pattern (Instagram DM, iMessage, WhatsApp all do this).
      // Nothing to do here.
    } else {
      // DESKTOP: safe to autofocus after the entrance animation settles.
      setTimeout(function () { if (inputEl) inputEl.focus({ preventScroll: true }); }, 560);
    }

    if (!hasGreeted && !messagesEl.hasChildNodes()) {
      hasGreeted = true;

      // First-time onboarding tour (feature #528). Shown once per browser
      // to new visitors, then never again. If they've seen it (or opted
      // to skip), we fall through to the normal greeting/snapshot flow.
      // Signed-in customers with an existing snapshot also skip (they've
      // used the widget before).
      var cachedSnapshotForOnboard = loadSnapshot();
      var onboardingKey = 'tsv-onboarding-v1';
      var alreadyOnboarded = false;
      try { alreadyOnboarded = window.localStorage.getItem(onboardingKey) === '1'; } catch (_) {}
      if (!alreadyOnboarded && !cachedSnapshotForOnboard) {
        showOnboardingTour(function () {
          try { window.localStorage.setItem(onboardingKey, '1'); } catch (_) {}
          // Run the same greeting sequence used below.
          renderSkeleton();
          preloadHistory().then(function (data) {
            messagesEl.innerHTML = '';
            if (data && data.ok && data.messages && data.messages.length) {
              replayHistory(data.messages);
              saveSnapshotWhenIdle();
            } else {
              greet();
            }
          });
        });
        return;
      }

      var cached = cachedSnapshotForOnboard;
      if (cached) {
        // Local snapshot is authoritative for what the customer sees.
        // Do NOT overwrite it with the server /history reply — the
        // /history endpoint only stores text/products/chips, not the
        // account cards (Vault, Order, Tracking), so replaying it here
        // would wipe those cards on every refresh and leave the customer
        // looking at just their own questions.
        //
        // We still preload /history in the background so the AI has warm
        // conversation context on the next message, but we do NOT render
        // it — the DOM stays exactly as the customer left it.
        messagesEl.innerHTML = cached;
        rewireCachedProductButtons();
        scrollBottom();
        preloadHistory();
        return;
      }

      renderSkeleton();
      preloadHistory().then(function (data) {
        messagesEl.innerHTML = '';
        if (data && data.ok && data.messages && data.messages.length) {
          replayHistory(data.messages);
          saveSnapshotWhenIdle();
        } else {
          greet();
        }
      });
    }
  }

  function rewireCachedProductButtons() {
    var addBtns = messagesEl.querySelectorAll('.tsv-rec__action--add');
    addBtns.forEach(function (b) {
      var vid = b.getAttribute('data-variant');
      if (!vid) return;
      b.addEventListener('click', function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        addToCart(vid, b);
      });
    });
    var buyBtns = messagesEl.querySelectorAll('.tsv-rec__action--buy');
    buyBtns.forEach(function (b) {
      var vid = b.getAttribute('data-buy-variant');
      if (!vid) return;
      b.addEventListener('click', function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        b.disabled = true;
        var origText = b.textContent;
        b.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            window.location.href = '/checkout';
          })
          .catch(function () {
            b.disabled = false;
            b.textContent = origText;
            appendConcierge(T('cg_checkout_failed', 'Could not start checkout just now. Please try again or open the product page.'));
          });
      });
    });
    var chips = messagesEl.querySelectorAll('.tsv-chip');
    chips.forEach(function (c) {
      // Chips built with an intent were routed at build time; leave them alone.
      if (c.getAttribute && c.getAttribute('data-tsv-intent')) return;
      var text = c.textContent.trim();
      if (/^(sign ?in|log ?in|sign me in|sign in for personalised picks)\b/i.test(text) || /\bsign ?in\b|\blog ?in\b/i.test(text) && text.length <= 30 || c.classList.contains('tsv-chip--signin')) {
        c.classList.add('tsv-chip--signin');
        c.addEventListener('click', function () { showLoginForm(); });
        return;
      }
      if (/^create account$/i.test(text) || c.classList.contains('tsv-chip--register')) {
        c.classList.add('tsv-chip--register');
        var returnUrl = CFG.returnUrl || window.location.pathname;
        c.addEventListener('click', function () {
          window.location.href = '/account/register?return_url=' + encodeURIComponent(returnUrl);
        });
        return;
      }
      if (/^similar to\s+/i.test(text)) {
        c.addEventListener('click', function () { handleSimilarChip(text); });
        return;
      }
      if (/^compare\s+/i.test(text)) {
        c.addEventListener('click', function () { handleCompareChip(text); });
        return;
      }
      if (/^my latest order$/i.test(text)) {
        c.addEventListener('click', function () { handleOrderLookupChip(text); });
        return;
      }
      if (/^my points balance$/i.test(text)) {
        c.addEventListener('click', function () { handleLoyaltyChip(text); });
        return;
      }
      if (/^pick something new for me$/i.test(text)) {
        c.addEventListener('click', function () { handleBestsellersChip(text, {}); });
        return;
      }
      if (/^what is on sale this week$/i.test(text)) {
        c.addEventListener('click', function () { handleBestsellersChip(text, { on_sale: true }); });
        return;
      }
      if (/^(speak to the team|contact the team|message the team|contact support)$/i.test(text)) {
        c.addEventListener('click', function () { showContactForm(text); });
        return;
      }
      if (/^(track my order|track order|where is my parcel|where is my order)$/i.test(text)) {
        c.addEventListener('click', function () { handleTrackChip(text); });
        return;
      }
      // "Send me the shortlist" (primary conversion action after a
      // product recommendation). Also matches the older "email me these
      // picks" label for back-compat with any cached snapshots.
      if (/^(send me the shortlist|email me these picks|email me the shortlist|send the shortlist)$/i.test(text)) {
        c.classList.add('tsv-chip--emailpicks');
        c.classList.add('tsv-chip--primary');
        c.addEventListener('click', function () { showEmailPicksForm(text); });
        return;
      }
      // Newsletter signup for anonymous customers. Also primary tier.
      if (/^(send me drops [+&] sale alerts|get sale [+&] drop alerts|join the newsletter|sign up for the newsletter)$/i.test(text)) {
        c.classList.add('tsv-chip--newsletter');
        c.classList.add('tsv-chip--primary');
        c.addEventListener('click', function () { showNewsletterForm(text); });
        return;
      }
      if (/^(view my orders?|show my orders?|order history|my orders?|order details)$/i.test(text)) {
        c.addEventListener('click', function () { handleOrderLookupChip(text); });
        return;
      }
      if (/^keep chatting with you$/i.test(text)) {
        c.addEventListener('click', function () { tsvKeepChatting(); });
        return;
      }
      c.addEventListener('click', function () {
        if (text && inputEl) {
          inputEl.value = text;
          if (form) form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      });
    });

    // Restored cards are plain HTML with no live handlers. Reconstruct a
    // product object from each card's DOM so the Shortlist toggle and the
    // Explain More panel work again after a refresh.
    function _productFromCard(card) {
      if (!card) return null;
      function txt(sel) { var e = card.querySelector(sel); return e ? String(e.textContent || '').trim() : ''; }
      var slBtn = card.querySelector('.tsv-rec__shortlistBtn');
      var addBtn = card.querySelector('.tsv-rec__action--add') || card.querySelector('.tsv-rec__action--buy');
      var img = card.querySelector('.tsv-rec__img img');
      var topLink = card.querySelector('a.tsv-rec__top');
      var name = txt('.tsv-rec__title');
      var sub = txt('.tsv-rec__subtitle');
      return {
        id: slBtn ? (slBtn.getAttribute('data-sl-id') || '') : '',
        variant_id: addBtn ? (addBtn.getAttribute('data-variant') || addBtn.getAttribute('data-buy-variant') || '') : '',
        title: (name + (sub ? ' ' + sub : '')).trim(),
        vendor: txt('.tsv-rec__vendor'),
        price: txt('.tsv-rec__price'),
        compare_at_price: txt('.tsv-rec__compare'),
        image: img ? (img.getAttribute('src') || '') : '',
        url: topLink ? (topLink.getAttribute('href') || '') : '',
        reason: ''
      };
    }

    // Re-wire the T('cg_add_shortlist',"Add to shortlist") toggle on every restored card.
    var slBtns = messagesEl.querySelectorAll('.tsv-rec__shortlistBtn');
    slBtns.forEach(function (btn) {
      if (btn.dataset.tsvWired === '1') return;
      btn.dataset.tsvWired = '1';
      var card = btn.closest ? btn.closest('.tsv-rec') : null;
      // Paint current state from the persisted shortlist.
      var on0 = shortlistHas(btn.getAttribute('data-sl-id'));
      btn.classList.toggle('is-in', on0);
      btn.innerHTML = _shortlistBtnHtml(on0);
      btn.addEventListener('click', function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        var prod = _productFromCard(card);
        var key = (prod && (prod.id || prod.variant_id)) || btn.getAttribute('data-sl-id');
        if (shortlistHas(key)) shortlistRemove(key);
        else if (prod) shortlistAdd(prod);
        var on = shortlistHas(key);
        btn.classList.toggle('is-in', on);
        btn.innerHTML = _shortlistBtnHtml(on);
      });
    });

    // Re-wire the T('cg_explain_more',"Explain more") toggle (and lazy community-perception load).
    var explainBtns = messagesEl.querySelectorAll('.tsv-rec__explainBtn');
    explainBtns.forEach(function (btn) {
      if (btn.dataset.tsvWired === '1') return;
      btn.dataset.tsvWired = '1';
      var card = btn.closest ? btn.closest('.tsv-rec') : null;
      var panel = card ? card.querySelector('.tsv-rec__explain') : null;
      var slot = panel ? panel.querySelector('.tsv-rec__perception') : null;
      var loaded = false;
      btn.addEventListener('click', function () {
        if (!panel) return;
        var open = panel.classList.toggle('is-open');
        btn.classList.toggle('is-open', open);
        if (open && !loaded && slot && !slot.innerHTML.trim()) {
          loaded = true;
          try { tsvLoadPerception(_productFromCard(card), slot); } catch (_) {}
        }
      });
    });

    // Re-wire the shelf bookmark (Owned / Sampled / Want next) on restored cards.
    var bmBtns = messagesEl.querySelectorAll('.tsv-rec__bookmark');
    bmBtns.forEach(function (btn) {
      if (btn.dataset.tsvWired === '1') return;
      btn.dataset.tsvWired = '1';
      var card = btn.closest ? btn.closest('.tsv-rec') : null;
      var pop = card ? card.querySelector('.tsv-rec__bookmarkPop') : null;
      btn.addEventListener('click', function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        if (pop) pop.style.display = (pop.style.display === 'none' || !pop.style.display) ? 'flex' : 'none';
      });
      if (pop) {
        pop.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function (ev) {
            ev.preventDefault(); ev.stopPropagation();
            var status = b.getAttribute('data-tsv-shelf') || 'owned';
            try { tsvAddToWardrobe(_productFromCard(card), status); } catch (_) {}
            pop.style.display = 'none';
          });
        });
      }
    });

    // Re-wire the back-in-stock T('cg_notify_me',"Notify me") button on restored OOS cards.
    // Rebuilds the same inline email mini-form the live render attaches, so
    // an out-of-stock card recovered from a snapshot is not a dead button.
    var notifyBtns = messagesEl.querySelectorAll('.tsv-rec__action--notify');
    notifyBtns.forEach(function (notifyBtn) {
      if (notifyBtn.dataset.tsvWired === '1') return;
      notifyBtn.dataset.tsvWired = '1';
      var card = notifyBtn.closest ? notifyBtn.closest('.tsv-rec') : null;
      notifyBtn.addEventListener('click', function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        var p = _productFromCard(card) || {};
        // The notify button stamps its own product id; trust that first since
        // an OOS card may not carry a shortlist button to read the id from.
        if (notifyBtn.getAttribute('data-product')) { p.id = notifyBtn.getAttribute('data-product'); }
        var actionsRow = notifyBtn.parentNode;
        if (!actionsRow) return;
        var prefill = (window.tsvCurrentCustomer && window.tsvCurrentCustomer.email) || '';
        actionsRow.innerHTML =
          '<form class="tsv-notify" novalidate>' +
            '<input type="email" required autocomplete="email" placeholder="Your email" value="' + escapeHtml(prefill) + '" class="tsv-notify__input" />' +
            '<button type="submit" class="tsv-notify__btn">Notify me</button>' +
          '</form>' +
          '<div class="tsv-notify__err" hidden></div>';
        var frm = actionsRow.querySelector('.tsv-notify');
        var input = actionsRow.querySelector('.tsv-notify__input');
        var errEl = actionsRow.querySelector('.tsv-notify__err');
        setTimeout(function () { try { input.focus(); } catch (_) {} }, 60);
        frm.addEventListener('submit', function (subEv) {
          subEv.preventDefault();
          var email = (input.value || '').trim();
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            errEl.textContent = T('cg_valid_email','Give me a valid email.');
            errEl.hidden = false;
            return;
          }
          errEl.hidden = true;
          var btn = frm.querySelector('.tsv-notify__btn');
          btn.disabled = true;
          btn.textContent = T('cg_locking_in','Locking in…');
          fetch(TSV_WORKER_URL + '/back-in-stock/subscribe', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email: email,
              product_id: p.id,
              session_id: window.tsvSessionId || '',
              source: 'widget'
            })
          }).then(function (r) { return r.json().catch(function () { return {}; }); })
            .then(function (data) {
              if (data && data.ok && data.already_in_stock) {
                actionsRow.innerHTML = '<div class="tsv-notify__done tsv-notify__done--now">Already in stock! <a href="' + escapeHtml(data.product && data.product.url || p.url || '#') + '">Have a look</a>.</div>';
              } else if (data && data.ok) {
                actionsRow.innerHTML = '<div class="tsv-notify__done">You will hear the moment it lands.</div>';
              } else {
                errEl.textContent = (data && data.message) || T('cg_save_failed','Could not save that. Try again.');
                errEl.hidden = false;
                btn.disabled = false;
                btn.textContent = T('cg_notify_me','Notify me');
              }
            }).catch(function () {
              errEl.textContent = T('cg_network_hiccup','Network hiccup. Try again in a moment.');
              errEl.hidden = false;
              btn.disabled = false;
              btn.textContent = T('cg_notify_me','Notify me');
            });
        });
      });
    });
  }

  function restoreOrGreet() {
    preloadHistory().then(function (data) {
      if (data && data.ok && data.messages && data.messages.length) {
        replayHistory(data.messages);
        saveSnapshotWhenIdle();
      } else {
        greet();
      }
    });
  }

  function replayHistory(messages) {
    for (var i = 0; i < messages.length; i++) {
      var m = messages[i];
      if (!m) continue;
      if (m.type === 'user') { appendUser(m.text); continue; }
      if (m.type === 'text' && m.text) { appendConcierge(m.text); continue; }
      if (m.type === 'products' && m.items) {
        // Comparison mode routing (#525): if the worker attached layout
        // hint + attrs, mount all cards in one grid call. Otherwise the
        // standard single-column cascade.
        if (m.layout === 'compare' && Array.isArray(m.compare_attrs)) {
          appendProducts(m.items, { layout: 'compare', attrs: m.compare_attrs, showRefine: false });
        } else {
          appendProducts(m.items);
        }
        continue;
      }
      if (m.type === 'upsell' && m.item) { appendUpsell(m); continue; }
      if (m.type === 'chips' && m.items) { appendChips(m.items, false); continue; }
    }
    scrollBottom();
  }
  function close() {
    widget.classList.remove('is-open');
    document.documentElement.classList.remove('tsv-concierge-open');
    tsvDetachKeyboardTracker();
    unlockPageScroll();
  }
  function toggle() {
    if (widget.classList.contains('is-open')) close();
    else open();
  }

  // -------------------------------------------------------------------
  // Phase 3 #14: First-visitor onboarding pulse. Not a modal overlay
  // (those get dismissed reflexively) — just a subtle attention bump on
  // the chat bubble the first three page loads, plus a one-time tooltip
  // that names the two most useful capabilities: fragrance guidance +
  // order/loyalty lookups. Dismissed forever on first widget open OR
  // after 8 seconds. Uses localStorage so it never repeats per browser.
  // Skipped for returning customers who already opened chat once.
  // -------------------------------------------------------------------
  (function tsvOnboarding() {
    if (!tsvFeatOn('onboarding')) return;
    try {
      var KEY_SHOWN = 'tsv_onboard_shown';
      var KEY_OPENED = 'tsv_chat_ever_opened';
      if (window.localStorage.getItem(KEY_SHOWN) === '1') return;
      if (window.localStorage.getItem(KEY_OPENED) === '1') return;
    } catch (_) {}
    // Mark opened once the user interacts with the chat so we never nag again.
    if (toggleBtn) toggleBtn.addEventListener('click', function () {
      try { window.localStorage.setItem('tsv_chat_ever_opened', '1'); } catch (_) {}
    }, { once: true });
    setTimeout(function () {
      if (widget.classList.contains('is-open')) return;
      var tip = document.createElement('div');
      tip.className = 'tsv-onboard';
      tip.style.cssText = 'position:fixed;bottom:100px;right:24px;max-width:280px;padding:14px 16px;background:#0F1720;color:#F3EEE4;border:1px solid rgba(201,179,127,0.4);border-radius:12px;box-shadow:0 6px 22px rgba(0,0,0,0.35);font-family:inherit;font-size:13px;line-height:1.5;z-index:10002;opacity:0;transform:translateY(6px);transition:opacity 320ms ease,transform 320ms cubic-bezier(0.16,1,0.3,1);pointer-events:auto;cursor:default';
      tip.innerHTML =
        '<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px">' +
          '<div>' +
            '<div style="font-size:10px;letter-spacing:1.8px;text-transform:uppercase;color:#c9b37f;margin-bottom:6px">The Scent Expert</div>' +
            '<div style="color:#e5e1d8">Ask me for a fragrance you would love, look up your order, check your Member’s Vault points, or scan a bottle&apos;s barcode.</div>' +
          '</div>' +
          '<button type="button" aria-label="Dismiss" style="background:transparent;border:0;color:#8a94a3;cursor:pointer;font-size:16px;line-height:1;padding:0 0 0 4px">&times;</button>' +
        '</div>' +
        '<button type="button" class="tsv-onboard-cta" style="margin-top:12px;width:100%;padding:8px 14px;background:#F3EEE4;color:#0F1720;border:0;border-radius:6px;font-size:11px;letter-spacing:1.4px;text-transform:uppercase;font-weight:600;cursor:pointer">Start chatting</button>' +
        '<div style="position:absolute;bottom:-6px;right:34px;width:12px;height:12px;background:#0F1720;border-right:1px solid rgba(201,179,127,0.4);border-bottom:1px solid rgba(201,179,127,0.4);transform:rotate(45deg)"></div>';
      document.body.appendChild(tip);
      requestAnimationFrame(function () {
        tip.style.opacity = '1';
        tip.style.transform = 'translateY(0)';
      });
      function dismiss() {
        tip.style.opacity = '0';
        tip.style.transform = 'translateY(6px)';
        setTimeout(function () { if (tip.parentNode) tip.parentNode.removeChild(tip); }, 320);
        try { window.localStorage.setItem('tsv_onboard_shown', '1'); } catch (_) {}
      }
      tip.querySelector('button[aria-label="Dismiss"]').addEventListener('click', dismiss);
      tip.querySelector('.tsv-onboard-cta').addEventListener('click', function () {
        dismiss();
        try { open(); } catch (_) {}
      });
      // Auto-dismiss after 8 seconds so it never becomes clutter.
      setTimeout(dismiss, 8000);
    }, 2500);
  })();

  if (window.requestIdleCallback) {
    window.requestIdleCallback(function () { preloadHistory(); }, { timeout: 2500 });
  } else {
    setTimeout(preloadHistory, 800);
  }

  // Feature 18: barcode scan button. Show only on mobile browsers that
  // support the native BarcodeDetector API + getUserMedia.
  var scanBtn = document.getElementById('tsvScanBtn');
  if (scanBtn && tsvFeatOn('barcodeScanner') && isMobile) {
    // Show the button on ALL mobile browsers when the feature is on. If the
    // native BarcodeDetector API is missing (iOS Chrome via WKWebView is
    // the main culprit), tsvOpenBarcodeScanner will surface a clear
    // 'open in Safari' message instead of silently hiding the button.
    scanBtn.style.display = '';
    scanBtn.addEventListener('click', function () { tsvOpenBarcodeScanner(); });
  }
  // ==== Sticky ATC lift (belt-and-braces) ================================
  // Watch the sticky ATC bar directly. Whenever it becomes visible on a
  // PDP, apply an inline bottom offset to the widget container so the
  // bubble AND panel both clear the sticky bar. Independent of any
  // external CSS class promise. Removes the offset when the sticky bar
  // hides again. Uses MutationObserver on class changes so it fires
  // exactly when the sticky bar toggles is-visible.
  (function tsvStickyAtcWatcher() {
    var stickyEl = document.getElementById('tsv-sticky-atc');
    if (!stickyEl) return;
    var LIFT_DESKTOP = 108;  // px above viewport bottom when sticky is up
    var LIFT_MOBILE  = 102;
    function applyOffset() {
      var isVisible = stickyEl.classList.contains('is-visible');
      var vw = window.innerWidth || document.documentElement.clientWidth || 1200;
      var lift = vw <= 600 ? LIFT_MOBILE : LIFT_DESKTOP;
      // The panel's height is calculated from viewport, so if we lift the
      // widget without also shrinking the panel, the header can push
      // above the visible viewport top. Compute the max-height that keeps
      // the header on-screen with a 16px top gap.
      var panelEl = widget.querySelector('.tsv-concierge__panel');
      var topGap = 16;
      // Use 100dvh so the calculation follows the URL-bar visibility on
      // mobile Safari — 100vh is the LARGE viewport (URL bar hidden) and
      // overshoots when the URL bar is visible, sending the top above
      // the screen. dvh always matches what's actually painted.
      var availablePx = 'calc(100dvh - ' + (lift + topGap) + 'px)';
      if (isVisible) {
        widget.style.setProperty('bottom', lift + 'px', 'important');
        widget.style.setProperty('transition', 'bottom 260ms cubic-bezier(0.22,1,0.36,1)', 'important');
        if (panelEl) {
          panelEl.style.setProperty('max-height', availablePx, 'important');
          // Mobile bottom-sheet uses height + bottom directly (position:fixed
          // at bottom, 100dvh tall). The bottom-sheet media query is
          // (max-width:900px) — everything at or below that width needs
          // the height AND bottom override or the panel top pushes above
          // the visible viewport. Previously this branch was gated at
          // vw <= 500 which missed most modern phones in landscape and
          // tablets in portrait, leaving the header cut off.
          if (vw <= 900) {
            panelEl.style.setProperty('height', availablePx, 'important');
            panelEl.style.setProperty('bottom', lift + 'px', 'important');
          }
        }
      } else {
        widget.style.removeProperty('bottom');
        if (panelEl) {
          panelEl.style.removeProperty('max-height');
          panelEl.style.removeProperty('height');
          panelEl.style.removeProperty('bottom');
        }
        // Keep transition briefly so the reset animates too, then clear.
        setTimeout(function () { widget.style.removeProperty('transition'); }, 400);
      }
    }
    // Initial check in case sticky was already visible on load.
    applyOffset();
    // Watch for class changes on the sticky bar.
    var mo = new MutationObserver(applyOffset);
    mo.observe(stickyEl, { attributes: true, attributeFilter: ['class'] });
    // Also recheck on viewport resize so lift picks the right px for the
    // new width when the customer rotates or resizes. BUT skip the resize
    // when the chat input has focus — mobile soft-keyboard opening fires
    // a resize event, and rewriting panel height/bottom mid-focus makes
    // the panel jump around under the user's finger and can lose the tap.
    // We debounce so a real rotation still gets picked up ~250ms after the
    // final resize event, which is well after the keyboard finished opening.
    var _resizeDebounce = null;
    window.addEventListener('resize', function () {
      var active = document.activeElement;
      var isTypingInWidget = active && active.tagName === 'INPUT' &&
                             widget.contains(active);
      if (isTypingInWidget) return; // soft-keyboard resize — leave panel alone
      clearTimeout(_resizeDebounce);
      _resizeDebounce = setTimeout(applyOffset, 220);
    }, { passive: true });
    // If we ever want to react to real orientation changes even while typing,
    // orientationchange fires separately from the soft-keyboard resize.
    window.addEventListener('orientationchange', function () {
      setTimeout(applyOffset, 300);
    }, { passive: true });
  })();

  if (toggleBtn) toggleBtn.addEventListener('click', toggle);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (backdropEl) backdropEl.addEventListener('click', close);
  if (form) form.addEventListener('submit', onSubmit);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && widget.classList.contains('is-open')) close();
  });

  // HARD SLURS. Always blocked regardless of context.
  var TSV_PROFANITY_HARD = [
    'nigger','niggers','nigga','niggas','coon','coons','jigaboo','jiggaboo',
    'kike','kikes','yid','yids',
    'chink','chinks','gook','gooks','jap','japs',
    'spic','spics','beaner','beaners','wetback','wetbacks',
    'paki','pakis','sandnigger','towelhead','raghead','ragheads','cameljockey',
    'redskin','redskins','injun',
    'faggot','faggots','fag','fags','faggy','dyke','dykes','tranny','trannies','shemale','shemales',
    'retard','retards','retarded','tard','tards','spaz','spazz','spastic',
    'mong','mongoloid','mongoloids',
    'kys','killyourself','killurself','killyou',
    'heilhitler','sieghitler','sighitler','nazi','nazis'
  ];

  // SOFT PROFANITY. Blocked UNLESS the message shows fragrance/shopping
  // context (in which case it's almost certainly a real query, e.g. Tom Ford
  // "Fucking Fabulous", John Varvatos "SEX", "Bad Boy" etc).
  var TSV_PROFANITY_SOFT = [
    'fuck','fucker','fucking','motherfucker','fuckoff','fuckyou','fuckup','fucked','fck','fk','fkyou','fyou',
    'shit','shithead','shitface','shitbag','bullshit','shite','shits',
    'cunt','cunts','twat','twats','pussy','pussies',
    'cock','cocks','cocksucker','dick','dicks','dickhead','dickface','dickwad',
    'prick','pricks','wanker','wankers','wank','tosser','tossers',
    'ballsack','ballsacks','nutsack','bollocks',
    'whore','whores','slut','sluts','slutty','skank','skanks','thot','thots',
    'bitch','bitches','bitchy','bastard','bastards',
    'sex','sexy','sexual','sexi','sexting',
    'jackass','dumbass','dumbfuck','dumbshit','jerkoff','handjob','blowjob','bj','deepthroat',
    'suckmy','suckmydick','eatshit','eatass','rimjob',
    'stfu','gtfo','shutthefuckup','shutup',
    'homo','homos','queer','queers'
  ];

  // Combined list for the strike log and legacy references.
  var TSV_PROFANITY = TSV_PROFANITY_HARD.concat(TSV_PROFANITY_SOFT);

  // Words / phrases that indicate the message is about fragrance, product
  // discovery, an order, or the shop itself. When present, ALL profanity
  // detection is skipped. This is intentional: many real fragrances contain
  // words that trip a naive filter (Tom Ford Fucking Fabulous, John Varvatos
  // SEX, etc), and hostile spam almost never contains these terms.
  var TSV_SAFE_CONTEXT = [
    // Core product vocabulary
    'perfume','fragrance','fragrances','cologne','eau','edp','edt','edc',
    'parfum','extrait','scent','scents','spray','bottle','bottles','notes',
    'note','sillage','longevity','projection','opening','drydown','top',
    'heart','base','musk','oud','vanilla','amber','rose','jasmine','oakmoss',
    'gourmand','floral','woody','fresh','citrus','fruity','spicy','aquatic',
    'aromatic','chypre','fougere','fougère','powdery','sweet','warm','dry',
    'discovery','sample','samples','set','sets','bundle',
    // Shopping / account vocabulary
    'order','orders','tracking','track','delivery','shipping','return',
    'refund','account','loyalty','vault','members','points','reward','rewards',
    'checkout','cart','bag','gift','sale','offer','discount',
    // The store + team
    'scentvault','scent vault','thescentvault','the scent vault','team',
    // Known fragrance / brand tokens (short, distinctive)
    'tom ford','ford','fucking fabulous','fucking','fabulous', // Tom Ford edgy line
    'varjatos','varvatos', // John Varvatos SEX line
    'ysl','yves','saint','laurent',
    'guerlain','dior','chanel','creed','initio','xerjoff','mfk','maison','francis','kurkdjian',
    'baccarat','rouge','aventus','sauvage','oud','satin','mood','sexy','sensual','seduction','seductive','date','night'
  ];

  function tsvNormaliseProfanity(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[013457!@$|+]/g, function (ch) {
        return ({
          '0':'o','1':'i','3':'e','4':'a','5':'s','7':'t',
          '!':'i','@':'a','$':'s','|':'i','+':'t'
        })[ch] || ch;
      })
      // Preserve spaces so the word-boundary regex below finds real
      // slurs surrounded by other words. Stripping non-letters entirely
      // would concatenate "you are a nigger" into "youareanigger" and
      // the boundary check would miss it.
      .replace(/[^a-z]/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/^ | $/g, '');
  }
  function tsvHasSafeContext(text) {
    var lc = String(text || '').toLowerCase();
    for (var i = 0; i < TSV_SAFE_CONTEXT.length; i++) {
      if (lc.indexOf(TSV_SAFE_CONTEXT[i]) !== -1) return true;
    }
    // Also treat any message that name-drops a brand-like Capitalised token
    // ("Fucking Fabulous", "MYSLF", "SEX") as safe. Any 3+ char cap token in
    // the original text counts.
    var caps = String(text || '').match(/\b[A-Z][A-Za-z0-9]{2,}\b/g);
    if (caps && caps.length >= 2) return true;
    return false;
  }
  // Sensitive-data guard. Redacts card numbers (Luhn-checked), phone numbers,
  // IBAN/bank details, and Irish PPS/ID numbers BEFORE anything is shown, stored,
  // or sent to the AI. Emails are intentionally left alone (the chat uses them
  // for shortlist/contact). Returns { clean, redacted, kinds }.
  function tsvLuhnValid(num) {
    var sum = 0, alt = false;
    for (var i = num.length - 1; i >= 0; i--) {
      var d = parseInt(num.charAt(i), 10);
      if (isNaN(d)) return false;
      if (alt) { d *= 2; if (d > 9) d -= 9; }
      sum += d; alt = !alt;
    }
    return sum % 10 === 0;
  }
  function tsvRedactSensitive(text) {
    var s = String(text || '');
    var kinds = [];
    // 1) Card numbers: 13-19 digits with optional spaces/dashes, Luhn-valid.
    s = s.replace(/\b(?:\d[ -]?){13,19}\b/g, function (m) {
      var digits = m.replace(/\D/g, '');
      if (digits.length < 13 || digits.length > 19 || !tsvLuhnValid(digits)) return m;
      kinds.push('card'); return '[card number removed]';
    });
    // 2) IBAN: 2 letters + 2 digits + 11-30 alphanumerics.
    s = s.replace(/\b[A-Za-z]{2}\d{2}(?:[ ]?[A-Za-z0-9]){11,30}\b/g, function () {
      kinds.push('bank'); return '[bank details removed]';
    });
    // 3) Irish PPS number: 7 digits + 1-2 letters.
    s = s.replace(/\b\d{7}[A-Za-z]{1,2}\b/g, function () {
      kinds.push('id'); return '[ID number removed]';
    });
    // 4) Phone numbers: optional +, then 9-15 digits with common separators.
    s = s.replace(/\+?\d[\d\s().-]{7,}\d/g, function (m) {
      var digits = m.replace(/\D/g, '');
      if (digits.length < 9 || digits.length > 15) return m;
      kinds.push('phone'); return '[phone number removed]';
    });
    return { clean: s, redacted: kinds.length > 0, kinds: kinds };
  }

  function tsvDetectProfanity(text) {
    var n = tsvNormaliseProfanity(text);
    if (!n) return null;
    // Word-boundary matcher so 'japanese' does not match 'jap',
    // 'scunthorpe' does not match 'cunt', 'raccoon' does not match 'coon'.
    function _tsvEscapeRe(s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
    function tsvHasWord(w) {
      return new RegExp('(?:^|[^a-z])' + _tsvEscapeRe(w) + '(?:[^a-z]|$)', 'i').test(n);
    }
    // Hard slurs: always block, no context can override.
    for (var i = 0; i < TSV_PROFANITY_HARD.length; i++) {
      if (tsvHasWord(TSV_PROFANITY_HARD[i])) return TSV_PROFANITY_HARD[i];
    }
    // Soft profanity: block ONLY when the message has no fragrance/shopping
    // context. "Fucking Fabulous by Tom Ford" -> passes. Bare "fuck" -> blocked.
    if (tsvHasSafeContext(text)) return null;
    for (var j = 0; j < TSV_PROFANITY_SOFT.length; j++) {
      if (tsvHasWord(TSV_PROFANITY_SOFT[j])) return TSV_PROFANITY_SOFT[j];
    }
    return null;
  }
  function tsvFlashInput(msg) {
    if (!inputEl) return;
    if (!inputEl._origPlaceholder) inputEl._origPlaceholder = inputEl.placeholder || '';
    inputEl.placeholder = msg;
    inputEl.style.borderColor = '#c96b6b';
    setTimeout(function () {
      inputEl.style.borderColor = '';
      inputEl.placeholder = inputEl._origPlaceholder || '';
    }, 2200);
  }

  var PROFANITY_STRIKES_KEY = 'tsv_concierge_profanity_strikes';
  var PROFANITY_LOCK_KEY    = 'tsv_concierge_profanity_lockuntil';
  var STRIKE_WINDOW_MS = 30 * 60 * 1000;
  var STRIKE_LIMIT = 3;
  var LOCK_DURATION_MS = 24 * 60 * 60 * 1000;

  function tsvIsLocked() {
    try {
      var until = Number(window.localStorage.getItem(PROFANITY_LOCK_KEY) || 0);
      return until && Date.now() < until ? until : 0;
    } catch (_) { return 0; }
  }
  function tsvRecordStrike(word) {
    var now = Date.now();
    var strikes = [];
    try {
      strikes = JSON.parse(window.localStorage.getItem(PROFANITY_STRIKES_KEY) || '[]');
    } catch (_) {}
    strikes = strikes.filter(function (t) { return now - t < STRIKE_WINDOW_MS; });
    strikes.push(now);
    try { window.localStorage.setItem(PROFANITY_STRIKES_KEY, JSON.stringify(strikes)); } catch (_) {}
    if (CFG.endpoint) {
      var flagUrl = CFG.endpoint.replace(/\/chat\/?$/, '/flag-attempt');
      try {
        fetch(flagUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId, reason: 'profanity', matched: word })
        }).catch(function () {});
      } catch (_) {}
    }
    if (strikes.length >= STRIKE_LIMIT) {
      var lockUntil = now + LOCK_DURATION_MS;
      try { window.localStorage.setItem(PROFANITY_LOCK_KEY, String(lockUntil)); } catch (_) {}
      return lockUntil;
    }
    return 0;
  }
  function tsvApplyLockUI() {
    if (!inputEl) return;
    inputEl.disabled = true;
    inputEl.placeholder = T('cg_chat_locked','Chat is locked for 24 hours.');
    if (sendBtn) sendBtn.disabled = true;
  }

  function onSubmit(e) {
    e.preventDefault();
    var lockUntil = tsvIsLocked();
    if (lockUntil) { tsvApplyLockUI(); return; }
    var val = (inputEl.value || '').trim();
    if (!val) return;
    var badWord = tsvDetectProfanity(val);
    if (badWord) {
      inputEl.value = '';
      var newLock = tsvRecordStrike(badWord);
      if (newLock) {
        tsvApplyLockUI();
      } else {
        var remaining = STRIKE_LIMIT - (JSON.parse(window.localStorage.getItem(PROFANITY_STRIKES_KEY) || '[]').length);
        tsvFlashInput(remaining > 0 ? 'Please keep it respectful. ' + remaining + T('cg_before_chat_locks',' before the chat locks.') : T('cg_keep_respectful', 'Please keep it respectful.'));
      }
      return;
    }
    inputEl.value = '';
    // Close the soft keyboard on mobile after the customer sends. Feels
    // more like a proper chat app — the reply lands, the keyboard drops,
    // the customer can read the response and tap chips without the
    // keyboard covering half the screen. If they want to type another
    // message they tap the input again.
    try { inputEl.blur(); } catch (_) {}
    submit(val);
  }

  // Reconcile with server-side strike count: if an admin cleared strikes,
  // wipe the local 24-hour lock so the customer can chat again.
  (function tsvReconcileLock() {
    try {
      if (!CFG.endpoint || !sessionId) return;
      var url = CFG.endpoint.replace(/\/chat\/?$/, '/session-status') + '?session_id=' + encodeURIComponent(sessionId);
      fetch(url, { method: 'GET', credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json().catch(function () { return null; }); })
        .then(function (data) {
          if (!data || !data.ok) return;
          if (!data.locked) {
            try {
              window.localStorage.removeItem(PROFANITY_STRIKES_KEY);
              window.localStorage.removeItem(PROFANITY_LOCK_KEY);
              if (inputEl) {
                inputEl.disabled = false;
                inputEl.placeholder = '';
              }
              if (sendBtn) sendBtn.disabled = false;
            } catch (_) {}
          }
        })
        .catch(function () {});
    } catch (_) {}
  })();

  if (tsvIsLocked()) tsvApplyLockUI();

  function greet() {
    var text = CFG.greeting || T('cg_welcome','Welcome to The Scent Vault.');
    var signedIn = !!(CFG.customer && (CFG.customer.id || CFG.customer.email));
    if (signedIn && CFG.customer.first_name) {
      text = 'Welcome back, ' + CFG.customer.first_name + '. ' +
        T('cg_welcome_back_sub','I remember what suits you, tell me what you are after today.');
    }
    var chips;
    if (signedIn) {
      chips = [chipT('latest_order','cg_chip_latest_order','My latest order'), chipT('track','cg_chip_track_order','Track my order'), chipT('points','cg_chip_points','My points balance'), chipT('bestsellers','cg_chip_pick_new','Pick something new for me'), chipT('past_chats','cg_chip_past_chats','Your past chats')];
      if (tsvFeatOn('giftingMode'))     chips.push(chipT('','cg_chip_buy_gift','Help me buy a gift'));
      if (tsvFeatOn('wardrobeView'))    chips.push(chipT('','cg_chip_my_shelf',T('cg_chip_my_shelf2', 'My fragrance shelf')));
      if (tsvFeatOn('signatureFinder')) chips.push(chipT('','cg_chip_signature',T('cg_chip_signature', 'Find my signature scent')));
    } else {
      chips = [T('cg_chip_signin_picks', 'Sign in for personalised picks'), 'Create account']
        .concat((CFG.chips || []).filter(function (c) { return chipLabel(c).length > 0; }));
      if (tsvFeatOn('giftingMode'))     chips.push(chipT('','cg_chip_buy_gift','Help me buy a gift'));
      if (tsvFeatOn('signatureFinder')) chips.push(chipT('','cg_chip_signature',T('cg_chip_signature', 'Find my signature scent')));
    }
    if (prefersReducedMotion) {
      appendConcierge(text);
      if (chips.length) appendChips(chips, true);
      saveSnapshotWhenIdle();
      return;
    }
    typeConcierge(text, function () {
      if (chips.length) appendChips(chips, true);
      saveSnapshotWhenIdle();
    });
  }

  function typeConcierge(text, done) {
    var div = document.createElement('div');
    div.className = 'tsv-msg tsv-msg--concierge tsv-msg--text is-typing';
    messagesEl.appendChild(div);
    scrollBottom();
    var i = 0;
    var stepMs = 22;
    var burstMs = 8;
    function step() {
      if (i >= text.length) {
        div.classList.remove('is-typing');
        if (typeof done === 'function') done();
        return;
      }
      div.textContent += text.charAt(i);
      scrollBottom();
      var next = /\s/.test(text.charAt(i)) ? burstMs : stepMs;
      i += 1;
      setTimeout(step, next);
    }
    step();
  }

  function renderMessageText(text) {
    var safe = String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
    // Markdown links
    safe = safe.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+|\/[^\s)]*)\)/g,
      function (_, label, url) {
        return '<a class="tsv-msg__link" href="' + url + '" target="_blank" rel="noopener">' + label + '</a>';
      });
    // ATX headings: ###, ##, #. Render at the start of a line.
    safe = safe.replace(/(^|\n)###\s*([^\n]+)/g, function (_, pre, label) {
      return pre + '<span class="tsv-msg__h3">' + label.trim() + '</span>';
    });
    safe = safe.replace(/(^|\n)##\s*([^\n]+)/g, function (_, pre, label) {
      return pre + '<span class="tsv-msg__h2">' + label.trim() + '</span>';
    });
    safe = safe.replace(/(^|\n)#\s*([^\n]+)/g, function (_, pre, label) {
      return pre + '<span class="tsv-msg__h1">' + label.trim() + '</span>';
    });
    // Standalone bold on its own line becomes a subhead. Runs BEFORE the
    // inline **bold** so lone bolded headings don't collapse into strong.
    safe = safe.replace(/(^|\n)\*\*([^*\n]+)\*\*(?=\n|$)/g,
      function (_, pre, label) {
        return pre + '<span class="tsv-msg__subhead">' + label + '</span>';
      });
    // Bold LABEL at start of paragraph followed by inline body text
    // becomes a proper heading above the body. Matches Claude's habit of
    // emitting `**Character:** Le Male is warm...` style comparison
    // sections — we want a heading above the paragraph, not asterisks
    // inline. The label may end with ":" (which we drop from the visible
    // heading text but is required for pattern disambiguation from a
    // sentence that happens to start with a bold phrase).
    safe = safe.replace(/(^|\n)\*\*([^*\n:]+):\*\*\s*([^\n]*)/g,
      function (_, pre, label, body) {
        return pre + '<span class="tsv-msg__h3">' + label.trim() + '</span>' +
               (body ? '<br>' + body : '');
      });
    // Inline **bold** anywhere else.
    safe = safe.replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>');
    // Numbered list items ("1. Foo", "2. Bar") — each becomes a
    // structured line so the widget can render them as a proper stack
    // instead of the AI's "1. Foo\n2." collapsing into one text run.
    // We wrap each list item into a div so numbers align and the item's
    // description doesn't run into the next number.
    safe = safe.replace(/(^|\n)(\d+)\.\s+([^\n]+)/g,
      function (_, pre, num, body) {
        return pre + '<div class="tsv-msg__li"><span class="tsv-msg__li-num">' + num + '.</span><span class="tsv-msg__li-body">' + body + '</span></div>';
      });
    // Bullet list items ("- Foo" or "* Foo"), rendered similar to
    // numbered list.
    safe = safe.replace(/(^|\n)[-*]\s+([^\n]+)/g,
      function (_, pre, body) {
        return pre + '<div class="tsv-msg__li"><span class="tsv-msg__li-bullet">&#8226;</span><span class="tsv-msg__li-body">' + body + '</span></div>';
      });
    // Paragraph + line breaks.
    safe = safe.replace(/\n{2,}/g, '<span class="tsv-msg__break"></span>');
    safe = safe.replace(/\n/g, '<br>');
    return safe;
  }
  var conciergeReplyCount = 0;
  // Global animation queue. Every text bubble types out at a steady
  // cadence and every card / chip / product-set that follows waits for
  // the typewriter to finish before mounting. Gives every response the
  // same "type, then reveal" feel whether it's AI-streamed or
  // chip-routed (loyalty, orders, tracking, similar-to, etc).
  var _tsvChain = Promise.resolve();
  function tsvQueue(fn) {
    _tsvChain = _tsvChain.then(function () {
      var out = null;
      try { out = fn(); } catch (_) {}
      return out && typeof out.then === 'function' ? out : Promise.resolve();
    });
    return _tsvChain;
  }
  // Insert a deliberate pause into the animation chain so cards don't
  // pile in one after another. Used between the intro text finishing
  // and the next visual element mounting — gives every step room to
  // breathe. Reduced-motion collapses to a token 60ms so screen readers
  // still see a settled DOM.
  function tsvChainPause(ms) {
    return tsvQueue(function () {
      return new Promise(function (resolve) {
        var d = prefersReducedMotion ? 60 : (ms || 0);
        setTimeout(resolve, d);
      });
    });
  }
  // saveSnapshot() but queued at the end of the animation chain so the
  // localStorage snapshot captures the fully mounted DOM (cards, chips,
  // typed text) instead of firing before the queued animations run.
  function saveSnapshotWhenIdle() {
    return tsvQueue(function () {
      try { tsvEnsureFollowUpChips(); } catch (_) {}
      try { saveSnapshot(); } catch (_) {}
    });
  }
  // --------------------------------------------------------------------
  // tsvHandleChatError: turn a chat-endpoint failure into a specific,
  // customer-friendly message instead of the bland "offline" catch-all.
  // Reads the response status and body when possible so we can tell the
  // customer *why* (rate limit, muted, server error, network), and logs
  // the raw details to console for us to diagnose.
  // Returns a Promise<string> of the message to show.
  // --------------------------------------------------------------------
  function tsvHandleChatError(err, res) {
    return new Promise(function (resolve) {
      try { console.warn('[tsv] chat error', err, res && res.status); } catch (_) {}
      // Network / DNS / offline browser
      if (!res) {
        var online = (typeof navigator !== 'undefined' && 'onLine' in navigator) ? navigator.onLine : true;
        if (!online) return resolve(T('cg_offline','You are offline. Reconnect and try again.'));
        return resolve(T('cg_expert_unreachable', 'The Scent Expert could not be reached. Please try again in a moment.'));
      }
      var status = res.status || 0;
      // Try to read a body for a better message. Some paths already
      // consumed the body, so guard with a try.
      var bodyP;
      try { bodyP = res.clone().json(); } catch (_) { bodyP = Promise.resolve(null); }
      bodyP.then(function (body) {
        try { console.warn('[tsv] chat error body', body); } catch (_) {}
        var reason = (body && (body.reason || body.error || body.message)) || '';
        // Error code + diag_id: shown in the customer-facing message so
        // you can trace the exact failure in Cloudflare logs without
        // asking the customer for a screenshot of DevTools. E3003 =
        // undefined reference bug, E4001 = Anthropic quota, etc.
        var code = (body && body.code) ? body.code : '';
        var label = (body && body.label) ? body.label : '';
        var diagBits = [];
        if (code) diagBits.push(code);
        if (body && body.diag_id) diagBits.push(body.diag_id);
        var diag = diagBits.length ? (' [' + diagBits.join(' · ') + ']') : '';
        if (status === 429) {
          if (/burst/i.test(reason)) return resolve(T('cg_too_fast','You are sending messages too fast. Slow down and try again.'));
          return resolve(T('cg_hourly_limit','You have hit the hourly message limit. Try again shortly.'));
        }
        if (status === 403) {
          if (/muted|locked|strike/i.test(reason)) return resolve('This chat is paused for 24 hours after too many blocked messages. Please email help@thescentvault.ie if this is a mistake.');
          if (/blocked|origin/i.test(reason)) return resolve(T('cg_expert_wrong_page', 'The Scent Expert cannot respond from this page. Please refresh and try again.'));
          return resolve(T('cg_access_blocked', 'Access blocked. Please refresh and try again.'));
        }
        if (status === 400) {
          if (reason) return resolve(T('cg_request_problem','There was a problem with that request: ') + String(reason).slice(0, 140));
          return resolve(T('cg_unprocessable','That message could not be processed. Try rewording it.'));
        }
        // For any 5xx: prefer the specific reason from the body if the
        // server sent one (our _safeChat wrapper does), otherwise fall
        // back to the generic message. Include diag_id when present so
        // we can trace a specific failure in Cloudflare logs.
        if (status >= 500) {
          // Prefer the human-readable label from the worker's error
          // classifier ("Anthropic quota exhausted", "D1 schema mismatch",
          // etc). If missing, fall back to the raw reason. The trailing
          // diag block still gets appended so you can trace it in logs.
          if (label && reason) return resolve('Server error (' + label + '): ' + String(reason).slice(0, 180) + diag);
          if (label) return resolve('Server error (' + label + ')' + diag);
          if (reason) return resolve('Server error: ' + String(reason).slice(0, 200) + diag);
          if (status === 502 || status === 503 || status === 504) {
            return resolve(T('cg_expert_briefly_unavailable', 'The Scent Expert is briefly unavailable. Please try again in a moment.') + diag);
          }
          return resolve('Something went wrong on our side. Please try again, or email help@thescentvault.ie if it keeps happening.' + diag);
        }
        // Body may signal error even on 200
        if (body && body.ok === false) {
          if (/muted/i.test(reason)) return resolve('This chat is paused for 24 hours. Please email help@thescentvault.ie if this is a mistake.');
          if (reason) return resolve(T('cg_expert_trouble','The Scent Expert had trouble: ') + String(reason).slice(0, 200) + diag);
        }
        return resolve(T('cg_expert_offline', 'The Scent Expert is offline right now. Please try again shortly.') + diag);
      }).catch(function () {
        return resolve(T('cg_expert_offline', 'The Scent Expert is offline right now. Please try again shortly.'));
      });
    });
  }
  // --------------------------------------------------------------------
  // Phase 3 #10: Feedback learning loop. Attach a thumbs-up / thumbs-down
  // row under every AI reply. Posts to /feedback which persists to
  // chat_feedback in D1. On thumbs-down, offer a quick reason picker so
  // we can classify why customers weren't happy (wrong price, missing
  // brand, not what I asked, etc). Zero-friction — click and done.
  // Only shown on real prose replies, not on transient system messages
  // (error banners, escape-hatch prompts). Detected by length + first
  // char (system messages start with "Something", "Sorry", etc).
  // --------------------------------------------------------------------
  function tsvAttachFeedback(bubbleDiv, rawText) {
    if (!tsvFeatOn('feedback')) return;
    if (!bubbleDiv || bubbleDiv.dataset.tsvFeedbackAttached === '1') return;
    var txt = String(rawText || '').trim();
    if (!txt || txt.length < 40) return; // don't clutter tiny replies
    if (/^(something went wrong|the scent expert is offline|server error|please keep this respectful)/i.test(txt)) return;
    if (bubbleDiv.querySelector('.tsv-msg__feedback')) return;
    bubbleDiv.dataset.tsvFeedbackAttached = '1';
    var wrap = document.createElement('div');
    wrap.className = 'tsv-msg__feedback';
    wrap.style.cssText = 'display:flex;gap:8px;margin-top:10px;padding-top:8px;opacity:0.55;transition:opacity 200ms ease;font-size:11px;letter-spacing:1px;text-transform:uppercase;color:#8a94a3;align-items:center';
    wrap.innerHTML =
      '<span style="letter-spacing:1.2px">Was this helpful?</span>' +
      '<button type="button" class="tsv-fb-btn" data-vote="up" aria-label="Thumbs up" style="background:transparent;border:1px solid rgba(255,255,255,0.14);color:#c9b37f;width:26px;height:22px;border-radius:5px;cursor:pointer;font-size:12px;padding:0;line-height:1">&#x25B2;</button>' +
      '<button type="button" class="tsv-fb-btn" data-vote="down" aria-label="' + T('cg_thumbs_down',"Thumbs down") + '" style="background:transparent;border:1px solid rgba(255,255,255,0.14);color:#8a94a3;width:26px;height:22px;border-radius:5px;cursor:pointer;font-size:12px;padding:0;line-height:1">&#x25BC;</button>';
    wrap.addEventListener('mouseenter', function () { wrap.style.opacity = '1'; });
    wrap.addEventListener('mouseleave', function () { wrap.style.opacity = '0.55'; });
    var sent = false;
    function sendVote(vote, reason) {
      if (sent) return;
      sent = true;
      var endpoint = CFG.endpoint;
      if (!endpoint) return;
      var url = endpoint.replace(/\/chat\/?$/, '/feedback');
      try {
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId, vote: vote, reason: reason || null })
        }).catch(function () {});
      } catch (_) {}
      wrap.innerHTML = '<span style="letter-spacing:1.2px;color:#c9b37f">Thanks for the feedback.</span>';
      wrap.style.opacity = '1';
    }
    function showReasonPicker() {
      var picker = document.createElement('div');
      picker.style.cssText = 'display:flex;flex-wrap:wrap;gap:6px;margin-top:6px';
      var reasons = [T('cg_fb_not_asked','Not what I asked'), T('cg_fb_wrong_details','Wrong details'), T('cg_fb_too_pushy','Too pushy'), T('cg_fb_not_enough','Not enough options'), 'Other'];
      reasons.forEach(function (r) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = r;
        b.style.cssText = 'background:rgba(220,107,107,0.10);border:1px solid rgba(220,107,107,0.35);color:#F0A0A0;padding:4px 10px;border-radius:12px;cursor:pointer;font-size:11px;letter-spacing:0.5px';
        b.addEventListener('click', function () { sendVote('down', r); });
        picker.appendChild(b);
      });
      wrap.appendChild(picker);
    }
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.tsv-fb-btn');
      if (!btn) return;
      var vote = btn.getAttribute('data-vote');
      if (vote === 'up') sendVote('up', null);
      else if (vote === 'down') {
        // Replace buttons with reason picker in-place
        wrap.querySelectorAll('.tsv-fb-btn').forEach(function (b) { b.remove(); });
        var label = wrap.querySelector('span');
        if (label) label.textContent = T('cg_sorry_what_wrong','Sorry about that. What went wrong?');
        showReasonPicker();
      }
    });
    bubbleDiv.appendChild(wrap);
  }

  function appendConcierge(text, fade) {
    // Counter + escape-hatch fire immediately so escape logic sees the
    // right count even before the queued render runs.
    conciergeReplyCount++;
    maybeShowEscapeHatch();
    return tsvQueue(function () {
      return new Promise(function (resolve) {
        // Create + append the DIV INSIDE the queue task so DOM order
        // always matches queue order. Previously we appended
        // synchronously outside the queue, which meant that if the
        // caller chained appendConcierge + queued card mounts +
        // appendConcierge again, the second text DIV would land in the
        // DOM ABOVE the card (because the sync append ran before the
        // card mount task did). The card would then appear between the
        // first (typed) and second (still empty) text, in the wrong
        // visual order.
        // Blank-gap fix: never render an EMPTY text bubble. When a combined reply
        // (e.g. "points + last order") returns an empty intro for one part, the old
        // code appended a padded .tsv-msg--text div before checking the text, so an
        // empty box showed between the two cards. Skip it entirely.
        if (!String(text || '').trim()) { resolve(); return; }
        var div = document.createElement('div');
        div.className = 'tsv-msg tsv-msg--concierge tsv-msg--text' + (fade ? ' tsv-msg--fadein' : '');
        messagesEl.appendChild(div);
        try { messagesEl.scrollTop = messagesEl.scrollHeight; } catch (_) {}
        var raw = String(text || '');
        // Short strings or reduced-motion: skip the typewriter and just
        // show the rendered text so we don't burn 200ms on a one-word
        // "OK." style reply.
        if (!raw || raw.length < 4 || prefersReducedMotion) {
          div.innerHTML = renderMessageText(raw);
          try { tsvMaybeStickBottom(); } catch (_) {}
          try { tsvSpeak(raw); } catch (_) {}
          try { tsvAttachFeedback(div, raw); } catch (_) {}
          resolve();
          return;
        }
        var i = 0;
        var CHARS_PER_TICK = 2;
        var TICK_MS = 18;
        // iOS SMOOTHNESS: iOS Safari coalesces repaints when you reassign
        // innerHTML on a growing element every tick, so the reveal lurched
        // "line by line" on iPhone instead of typing character by character.
        // Instead we type into a dedicated Text node with white-space:pre-wrap
        // (so \n still shows as line breaks) and APPEND only the new
        // characters each tick — appending to a Text node's value is cheap
        // and iOS repaints it smoothly per character. The fully-formatted
        // markdown HTML is swapped in once, at the end.
        var typeEl = document.createElement('span');
        typeEl.className = 'tsv-msg__typing-text';
        typeEl.style.whiteSpace = 'pre-wrap';
        var textNode = document.createTextNode('');
        typeEl.appendChild(textNode);
        div.appendChild(typeEl);
        var _scrollCtr = 0;
        function tick() {
          if (i >= raw.length) {
            // Final render with links / markdown / subheads formatted
            div.innerHTML = renderMessageText(raw);
            try { tsvMaybeStickBottom(); } catch (_) {}
            try { tsvSpeak(raw); } catch (_) {}
            try { tsvAttachFeedback(div, raw); } catch (_) {}
            resolve();
            return;
          }
          var prevI = i;
          i = Math.min(i + CHARS_PER_TICK, raw.length);
          // Append only the newly-revealed characters (no innerHTML reparse).
          textNode.nodeValue += raw.slice(prevI, i);
          // Throttle the auto-scroll: sticking to the bottom on EVERY tick is
          // what made iOS lurch. Every few ticks stays smooth and still keeps
          // the newest text in view.
          if ((++_scrollCtr % 3) === 0) { try { tsvMaybeStickBottom(); } catch (_) {} }
          setTimeout(tick, TICK_MS);
        }
        tick();
      });
    });
  }
  // Escape hatch: once the customer has been chatting for a while, offer a
  // direct route to a human. Fires after the 6th concierge reply, once per
  // session. Also fired automatically by any negative-sentiment reply.
  function maybeShowEscapeHatch() {
    if (!tsvFeatOn('escapeHatch')) return;
    if (conciergeReplyCount !== 6) return;
    if (widget.dataset.escapeShown === '1') return;
    widget.dataset.escapeShown = '1';
    setTimeout(function () {
      appendConcierge(T('cg_offer_message_form', 'If you would like the team to weigh in directly, I can open a message form for you.'), true);
      appendChips([chipT('contact','cg_speak_to_team','Speak to the team'), chipT('keep_chatting','cg_chip_keep_chatting',chipT('keep_chatting','cg_chip_keep_chatting','Keep chatting with you'))], true);
    }, 800);
  }
  // "Keep chatting with you" reply. Warm, and gives the customer concrete
  // starting points as chips instead of a flat "tell me what you are after".
  function tsvKeepChatting() {
    appendConcierge(T('cg_happy_to_help_gift', 'Happy to. Tell me a scent you already love, an occasion, a budget, or who it is for, and I will find something spot on. Or tap a starting point below.'), true);
    appendChips([chipT('','cg_chip_for_summer',chipT('','cg_chip_for_summer','Something for summer')), chipT('','cg_chip_gift_someone',chipT('','cg_chip_gift_someone','A gift for someone')), chipT('','cg_chip_fresh_clean',chipT('','cg_chip_fresh_clean','Fresh and clean')), chipT('bestsellers','cg_chip_show_bestsellers',chipT('bestsellers','cg_chip_show_bestsellers','Show me bestsellers'))], true);
  }
  function appendUser(text) {
    var div = document.createElement('div');
    div.className = 'tsv-msg tsv-msg--user';
    div.textContent = text;
    messagesEl.appendChild(div);
    // New turn: resume following the conversation down even if the customer
    // had scrolled up while reading the previous reply.
    _tsvUserScrolledUp = false;
    scrollBottom();
    // Persist immediately so the user's own message survives a refresh
    // even if the AI reply fails or is text-only (renders through the
    // streaming path which no longer calls saveSnapshot on every message).
    try { saveSnapshot(); } catch (_) {}
  }
  // Rotating status messages shown under the three dots so the wait feels
  // active and purposeful instead of frozen.
  var TSV_STATUS_SETS = {
    gift:      [T('cg_st_recipient','Thinking about the recipient...'), T('cg_st_crowd_pleaser','Finding a safe crowd-pleaser...'), T('cg_st_budget','Checking it lands in budget...'), T('cg_st_wrapping','Wrapping up your options...'), T('cg_st_almost','Almost there...')],
    compare:   [T('cg_st_lining_two','Lining the two up...'), T('cg_st_both_profiles','Reading both profiles...'), T('cg_st_weighing','Weighing notes and longevity...'), T('cg_st_differences','Settling the differences...'), T('cg_st_almost','Almost there...')],
    similar:   [T('cg_st_profiling','Profiling the scent you named...'), T('cg_st_share_character','Finding fragrances that share its character...'), T('cg_st_closest','Lining up the closest matches...'), T('cg_st_almost','Almost there...')],
    brand:     [T('cg_st_house','Pulling that house...'), T('cg_st_in_stock','Gathering what we have in stock...'), T('cg_st_options','Lining up your options...'), T('cg_st_almost','Almost there...')],
    recommend: [T('cg_st_brief','Reading your brief...'), T('cg_st_shelves','Searching the shelves...'), T('cg_st_matching','Matching notes and families...'), T('cg_st_shortlisting','Shortlisting the best fits...'), T('cg_st_almost','Almost there...')],
    bag:       [T('cg_st_open_bag','Opening your shopping bag...'), T('cg_st_inside','Reading what is inside...'), T('cg_st_almost','Almost there...')],
    order:     [T('cg_st_order','Looking up your order...'), T('cg_st_status','Checking the latest status...'), T('cg_st_tracking','Pulling the tracking...'), T('cg_st_almost','Almost there...')],
    delivery:  [T('cg_st_delivery','Checking delivery for you...'), T('cg_st_shipping','Reading the shipping details...'), T('cg_st_almost','Almost there...')],
    returns:   [T('cg_st_returns','Checking the returns policy...'), T('cg_st_details_right','Getting the details right...'), T('cg_st_almost','Almost there...')],
    points:    [T('cg_st_vault','Opening your Members Vault...'), T('cg_st_points','Tallying your points...'), T('cg_st_almost','Almost there...')],
    education: [T('cg_st_facts','Getting the facts straight...'), T('cg_st_pulling','Pulling the details...'), T('cg_st_plain','Putting it in plain terms...'), T('cg_st_almost','Almost there...')],
    generic:   [T('cg_st_shelves','Searching the shelves...'), T('cg_st_your_notes','Matching your notes...'), T('cg_st_your_picks','Lining up your picks...'), T('cg_st_almost','Almost there...')]
  };
  var _tsvPendingQuery = '';
  function tsvStatusSetFor(q) {
    var t = String(q || '').toLowerCase();
    if (/what.?s in my (bag|cart)|my (bag|cart)\b|in my basket/.test(t)) return TSV_STATUS_SETS.bag;
    if (/\btrack|tracking|where is my|order status|my order|delivered|dispatch/.test(t)) return TSV_STATUS_SETS.order;
    if (/\bdelivery|shipping|postage|how long.*(deliver|ship|arrive)|when will.*(arrive|come)|free (delivery|shipping)/.test(t)) return TSV_STATUS_SETS.delivery;
    if (/\breturn|refund|exchange|send.*back/.test(t)) return TSV_STATUS_SETS.returns;
    if (/\bpoints|balance|vault|reward|\btier\b|loyalty/.test(t)) return TSV_STATUS_SETS.points;
    if (/\bgift|present|birthday|anniversary|for my (mum|mom|dad|sister|brother|wife|husband|partner|friend|girlfriend|boyfriend|son|daughter)\b/.test(t)) return TSV_STATUS_SETS.gift;
    if (/\bcompare|comparison|\bvs\b|versus|difference between\b/.test(t)) return TSV_STATUS_SETS.compare;
    if (/smells? like|similar to|\blike .* but\b|alternative to|\bdupe\b|reminds me of/.test(t)) return TSV_STATUS_SETS.similar;
    if (/what (is|are|s the difference)|difference between|eau de|\bsillage\b|longevity|projection|concentration|how (do|does)|explain|what does .* mean/.test(t)) return TSV_STATUS_SETS.education;
    if (/what .*(do you (have|stock|carry|sell|get)|can i get|have you got)|\boptions\b/.test(t)) return TSV_STATUS_SETS.brand;
    if (/recommend|suggest|\bpick\b|something (for|nice|fresh|warm|sweet)|scent for|perfume for|\bfor (him|her)\b|notes|summer|winter|autumn|spring|office|date|wedding|everyday|daily/.test(t)) return TSV_STATUS_SETS.recommend;
    return TSV_STATUS_SETS.generic;
  }
  var _tsvStatusTimer = null;
  function appendTyping() {
    var STATUS = tsvStatusSetFor(_tsvPendingQuery);
    if (document.getElementById('tsvTyping')) return;
    var div = document.createElement('div');
    div.className = 'tsv-msg tsv-msg--typing';
    div.id = 'tsvTyping';
    // Three dots (kept) + a rotating status line beneath them.
    div.innerHTML =
      '<div class="tsv-typing__dots"><span></span><span></span><span></span></div>' +
      '<div class="tsv-typing__status" id="tsvTypingStatus">' + STATUS[0] + '</div>';
    messagesEl.appendChild(div);
    scrollBottom();
    // Progressive schedule: each contextual line holds a little longer than the
    // last, so the customer actually reads the in-context statuses. The final
    // T('cg_st_almost',"Almost there...") is only reached after all the intermediate lines have
    // had generous time, so it no longer dominates the wait.
    var idx = 0;
    if (_tsvStatusTimer) { clearTimeout(_tsvStatusTimer); _tsvStatusTimer = null; }
    function tsvStatusStep() {
      var el = document.getElementById('tsvTypingStatus');
      if (!el) { _tsvStatusTimer = null; return; }
      if (idx < STATUS.length - 1) {
        idx++;
        el.textContent = STATUS[idx];
      }
      var isLast = idx >= STATUS.length - 1;
      // First intermediate ~1.8s, each subsequent one longer; hold the final
      // line for a long beat before a slow recheck.
      var dur = isLast ? 4000 : (1800 + idx * 500);
      _tsvStatusTimer = setTimeout(tsvStatusStep, dur);
    }
    _tsvStatusTimer = setTimeout(tsvStatusStep, 1800);
  }
  function removeTyping() {
    if (_tsvStatusTimer) { clearTimeout(_tsvStatusTimer); _tsvStatusTimer = null; }
    var t = document.getElementById('tsvTyping');
    if (t) t.remove();
  }
  var scrollSuppressed = false;
  function startScrollSuppression() { scrollSuppressed = true; }
  function stopScrollSuppression()  { scrollSuppressed = false; }
  function scrollBottom() {
    if (scrollSuppressed) return;
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }
  // Natural scroll only. This used to anchor a mounted card/element near the
  // top of the viewport, which the customer disliked (the view jumped to the
  // card on every answer). It is now a deliberate no-op: nothing repositions
  // the scroll when content mounts. Kept as a function so existing callers
  // are harmless.
  function scrollToTopOf(el, offset) {
    return;
  }
  // Streaming typewriter helper: only scroll the messages container to
  // the bottom if the customer is ALREADY near the bottom (within 80px).
  // If they scrolled up to re-read, do not fight them. Batched via
  // requestAnimationFrame so iOS Safari does not layout-thrash on every
  // typewriter tick — that is what causes the "words sliding in" jank.
  var _tsvScrollRafScheduled = false;
  // Streaming-active flag: while the typewriter is actively revealing
  // content, we force-scroll to the bottom on every tick regardless of
  // the 80px threshold. Otherwise, on a long response the growing
  // scrollHeight overshoots the 80px window mid-reveal and typewriter
  // auto-scroll silently stops. When streaming ends we revert to the
  // "only stick if user near bottom" behaviour so card mounts do not
  // fight a customer who has scrolled up to re-read.
  var _tsvTypewriterActive = false;
  // Reveal-follow flag. Set true for the whole duration of a renderResponse
  // reveal so the messages container force-sticks to the bottom as text
  // types and cards/chips mount, i.e. the reply "unrolls" downward and the
  // newest content is always in view. Released at the final settle so the
  // customer can freely scroll up to re-read afterwards.
  var _tsvRevealActive = false;
  // Natural chat scroll. We follow new content down to the bottom as it
  // appears, but ONLY while the customer is already at/near the bottom. The
  // moment they scroll up to re-read, we stop following and leave them alone
  // (no rigid stick, no fighting). We never anchor to the top of a card.
  var _tsvUserScrolledUp = false;
  var _tsvProgScroll = false;
  function _tsvEnsureScrollWatch() {
    if (!messagesEl || messagesEl._tsvScrollBound) return;
    messagesEl._tsvScrollBound = true;
    messagesEl.addEventListener('scroll', function () {
      // Ignore the scroll events WE trigger when following to the bottom.
      // Without this guard, a card mount grows the container, our own
      // scroll-to-bottom fires a scroll event that momentarily reads a large
      // distance-from-bottom, and the flag gets stuck "scrolled up" so the
      // follow silently stops. Only a genuine user drag flips the flag.
      if (_tsvProgScroll) { _tsvProgScroll = false; return; }
      var dist = messagesEl.scrollHeight - messagesEl.scrollTop - messagesEl.clientHeight;
      _tsvUserScrolledUp = dist > 120;
    }, { passive: true });
  }
  function tsvMaybeStickBottom() {
    if (scrollSuppressed) return;
    _tsvEnsureScrollWatch();
    if (_tsvUserScrolledUp) return;
    if (_tsvScrollRafScheduled) return;
    _tsvScrollRafScheduled = true;
    requestAnimationFrame(function () {
      _tsvScrollRafScheduled = false;
      if (!messagesEl || _tsvUserScrolledUp) return;
      _tsvProgScroll = true;
      messagesEl.scrollTop = messagesEl.scrollHeight;
    });
  }
  function removeChips() {
    var chips = messagesEl.querySelector('.tsv-chips');
    if (chips) chips.remove();
  }

  function appendChips(chips, stagger) {
    // Queue behind the typewriter so chips never appear during a text reveal.
    return tsvQueue(function () { return _appendChipsImpl(chips, stagger); });
  }
  function _appendChipsImpl(chips, stagger) {
    // DEDUPE against chips already in the DOM. Bulletproof: no matter
    // which code path calls appendChips, we scan every existing
    // .tsv-chips strip in the messages container and drop any incoming
    // chip whose lowercased label already lives on screen. Fixes the
    // "shortlist + drops repeat 4x" bug where the AI or a rescue path
    // re-emits the same chip after every recommendation card.
    try {
      var existingLabels = {};
      var existingStrips = messagesEl.querySelectorAll('.tsv-chips');
      for (var s = 0; s < existingStrips.length; s++) {
        var btns = existingStrips[s].querySelectorAll('.tsv-chip');
        for (var b = 0; b < btns.length; b++) {
          existingLabels[String(btns[b].textContent || '').trim().toLowerCase()] = true;
        }
      }
      var filtered = [];
      for (var i = 0; i < chips.length; i++) {
        var k = chipLabel(chips[i]).trim().toLowerCase();
        if (!k || existingLabels[k]) continue;
        existingLabels[k] = true; // also dedupe within the incoming batch
        filtered.push(chips[i]);
      }
      chips = filtered;
    } catch (_) {}
    // If nothing survived the dedupe there is nothing to append.
    if (!chips || !chips.length) return Promise.resolve();
    // Build the wrap up-front, insert it into the DOM empty, then drop
    // each chip in one at a time with a real delay between DOM inserts
    // so the customer actually SEES them arriving in sequence. This is
    // slower and more refined than a single flush + CSS animation-delay,
    // which felt instantaneous because all buttons were in the DOM
    // simultaneously and just faded together.
    var wrap = document.createElement('div');
    wrap.className = 'tsv-chips';
    messagesEl.appendChild(wrap);
    tsvMaybeStickBottom();

    // Build all buttons first (with click handlers wired) but keep them
    // in an array — DO NOT append yet.
    var builtBtns = chips.map(function (c) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tsv-chip';
      btn.textContent = chipLabel(c);
      // Force the CSS fade-in animation to always play cleanly since
      // we are inserting them one-by-one from JS.
      btn.style.animation = '';
      btn.style.opacity = '';
      btn.style.transform = '';
      var chipText = chipLabel(c).trim();
      var chipIntentId = chipIntent(c);
      if (chipIntentId) { btn.setAttribute('data-tsv-intent', chipIntentId); }
      if (chipIntentId && bindChipIntent(btn, chipIntentId, chipText, chipQuery(c))) {
        // routed by intent; no text matching needed
      } else if (/^(sign ?in|log ?in|sign me in|sign in for personalised picks)\b/i.test(chipText) || (/\bsign ?in\b|\blog ?in\b/i.test(chipText) && chipText.length <= 30)) {
        btn.classList.add('tsv-chip--signin');
        btn.addEventListener('click', function () { showLoginForm(); });
      } else if (/^create account$/i.test(chipText)) {
        btn.classList.add('tsv-chip--register');
        var returnUrl = CFG.returnUrl || window.location.pathname;
        btn.addEventListener('click', function () {
          window.location.href = '/account/register?return_url=' + encodeURIComponent(returnUrl);
        });
      } else if (/^similar to\s+/i.test(chipText)) {
        btn.addEventListener('click', function () { handleSimilarChip(chipText); });
      } else if (/^compare\s+/i.test(chipText)) {
        btn.addEventListener('click', function () { handleCompareChip(chipText); });
      } else if (/^my latest order$/i.test(chipText)) {
        btn.addEventListener('click', function () { handleOrderLookupChip(chipText); });
      } else if (/^my points balance$/i.test(chipText)) {
        btn.addEventListener('click', function () { handleLoyaltyChip(chipText); });
      } else if (/^pick something new for me$/i.test(chipText)) {
        btn.addEventListener('click', function () { handleBestsellersChip(chipText, {}); });
      } else if (/^what is on sale this week$/i.test(chipText)) {
        btn.addEventListener('click', function () { handleBestsellersChip(chipText, { on_sale: true }); });
      } else if (/^(speak to the team|contact the team|message the team|contact support)$/i.test(chipText)) {
        btn.classList.add('tsv-chip--contact');
        btn.addEventListener('click', function () { showContactForm(chipText); });
      } else if (/^(track my order|track order|where is my parcel|where is my order)$/i.test(chipText)) {
        btn.addEventListener('click', function () { handleTrackChip(chipText); });
      } else if (/^scan another$/i.test(chipText)) {
        btn.addEventListener('click', function () { removeChips(); tsvOpenBarcodeScanner(); });
      } else if (/^(send me the shortlist|email me these picks|email me the shortlist|send the shortlist)$/i.test(chipText)) {
        btn.classList.add('tsv-chip--emailpicks');
        btn.classList.add('tsv-chip--primary');
        btn.addEventListener('click', function () { showEmailPicksForm(chipText); });
      } else if (/^(send me drops [+&] sale alerts|get sale [+&] drop alerts|join the newsletter|sign up for the newsletter)$/i.test(chipText)) {
        btn.classList.add('tsv-chip--newsletter');
        btn.classList.add('tsv-chip--primary');
        btn.addEventListener('click', function () { showNewsletterForm(chipText); });
      } else if (/^(view my orders?|show my orders?|order history|my orders?|order details)$/i.test(chipText)) {
        btn.addEventListener('click', function () { handleOrderLookupChip(chipText); });
      } else if (/^keep chatting with you$/i.test(chipText)) {
        btn.addEventListener('click', function () { tsvKeepChatting(); });
      } else if (/^your past chats$/i.test(chipText)) {
        btn.addEventListener('click', function () { handlePastChatsChip(chipText); });
      } else {
        btn.addEventListener('click', function () { submit(chipLabel(c)); });
      }
      return btn;
    });

    // Reduced-motion: dump them all at once, no staggered inserts.
    if (prefersReducedMotion || !stagger) {
      builtBtns.forEach(function (b) { wrap.appendChild(b); });
      tsvMaybeStickBottom();
      return Promise.resolve();
    }

    // Otherwise: append one at a time with a real delay between each so
    // the customer sees them arrive in sequence. 260ms feels deliberate
    // without dragging. Returns a promise that resolves once every chip
    // has landed, keeping the queue paused so nothing else mounts on top.
    return new Promise(function (resolve) {
      var i = 0;
      function next() {
        if (i >= builtBtns.length) { resolve(); return; }
        wrap.appendChild(builtBtns[i]);
        tsvMaybeStickBottom();
        i += 1;
        setTimeout(next, 260);
      }
      next();
    });
  }

  function showLoginForm() {
    var existing = messagesEl.querySelector('.tsv-login');
    if (existing) {
      var emailInput0 = existing.querySelector('input[name="customer[email]"]');
      if (emailInput0) emailInput0.focus();
      return;
    }
    var wrap = document.createElement('div');
    wrap.className = 'tsv-login';
    var frameName = 'tsvLoginFrame_' + Date.now();
    wrap.innerHTML =
      '<div class="tsv-login__title">Welcome back</div>' +
      '<div class="tsv-login__sub">Log in to access your Member’s Vault.</div>' +
      '<form class="tsv-login__form" method="post" action="/account/login" accept-charset="UTF-8" target="' + frameName + '">' +
        '<input type="hidden" name="form_type" value="customer_login">' +
        '<input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="return_url" value="/account">' +
        '<input type="hidden" name="checkout_url" value="/account">' +
        '<label class="tsv-login__field">' +
          '<input type="email" name="customer[email]" required autocomplete="email" placeholder="Email" />' +
        '</label>' +
        '<label class="tsv-login__field">' +
          '<input type="password" name="customer[password]" required autocomplete="current-password" placeholder="Password" />' +
        '</label>' +
        '<button type="submit" class="tsv-login__submit">Log in</button>' +
        '<div class="tsv-login__error" hidden></div>' +
      '</form>' +
      '<iframe name="' + frameName + '" class="tsv-login__frame" tabindex="-1" aria-hidden="true"></iframe>' +
      '<div class="tsv-login__links">' +
        '<a href="/account/login#recover" target="_blank" rel="noopener">Forgot password?</a>' +
        '<span class="tsv-login__sep"></span>' +
        '<a href="/account/register" target="_blank" rel="noopener">Create account</a>' +
      '</div>';
    messagesEl.appendChild(wrap);
    scrollBottom();

    var formEl = wrap.querySelector('form');
    var errEl = wrap.querySelector('.tsv-login__error');
    var btn = wrap.querySelector('.tsv-login__submit');
    var frame = wrap.querySelector('.tsv-login__frame');

    formEl.addEventListener('submit', function () {
      var email = String(formEl.querySelector('input[name="customer[email]"]').value || '').trim();
      var password = String(formEl.querySelector('input[name="customer[password]"]').value || '');
      if (!email || !password) return;
      errEl.hidden = true;
      errEl.textContent = '';
      btn.disabled = true;
      btn.dataset.origLabel = btn.textContent;
      btn.textContent = T('cg_signing_in_dots','Signing in...');
      wrap.dataset.email = email;
      wrap.dataset.done = '';
      wrap.dataset.attempt = '0';
      // Speed win 1: iframe fires `load` as soon as Shopify's response
      // arrives, even when X-Frame-Options blocks the frame from rendering.
      // Attach BEFORE we would race the first poll.
      try {
        frame.addEventListener('load', function onLoad() {
          if (wrap.dataset.done === '1') return;
          runProbe(wrap, frame, email, btn, errEl);
        }, { once: false });
      } catch (_) {}
      // Speed win 2: parallel-fire an immediate GET-based probe as a race
      // condition safety-net, and start the polling loop very shortly after.
      // Uniform 250ms interval, 45 attempts (~11 s budget) so slow mobile
      // networks still land.
      setTimeout(function () { runProbe(wrap, frame, email, btn, errEl); }, 80);
      setTimeout(function () {
        pollLoginStatus(wrap, frame, email, btn, errEl, 0);
      }, 200);
    });

    setTimeout(function () {
      var em = wrap.querySelector('input[name="customer[email]"]');
      if (em) em.focus();
    }, 100);
  }

  // Uniform 250ms polling. Fast enough that most sign-ins land in 1-3 ticks,
  // and consistent so we never leave a stale button spinning silently.
  function pollDelay(attempt) { return 250; }

  // Single probe. Uses HEAD first (no body parse) for speed; only fetches
  // the full HTML on the successful poll so name extraction can run.
  function runProbe(wrap, frame, email, btn, errEl) {
    if (wrap.dataset.done === '1') return Promise.resolve(false);

    // Cheap iframe error read (works if XFO didn't block the login page).
    try {
      var ifPath = frame.contentWindow && frame.contentWindow.location
        ? frame.contentWindow.location.pathname : '';
      var ifDoc = frame.contentDocument || (frame.contentWindow && frame.contentWindow.document);
      if (ifPath && /\/account\/login/.test(ifPath) && ifDoc && ifDoc.body && ifDoc.body.innerText) {
        var bodyText = ifDoc.body.innerText;
        if (/incorrect|invalid|could not find|does not match|no customer/i.test(bodyText)) {
          wrap.dataset.done = '1';
          var m = ifDoc.documentElement.outerHTML.match(/<[^>]*(?:class|id)="?(?:errors|form-status|error-message|form__message)"?[^>]*>([\s\S]*?)<\/[^>]+>/i);
          var errMsg = T('cg_login_mismatch', 'That email and password did not match. Please try again.');
          if (m && m[1]) {
            var stripped = m[1].replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
            if (stripped) errMsg = stripped.slice(0, 200);
          }
          showLoginError(btn, errEl, errMsg);
          return Promise.resolve(true);
        }
      }
    } catch (_) {}

    // HEAD-first probe: only the final URL matters. Falls back to GET if HEAD
    // is disallowed (some Shopify setups 405 HEAD on /account).
    return fetch('/account', {
      method: 'HEAD',
      credentials: 'same-origin',
      redirect: 'follow',
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' }
    })
      .then(function (r) {
        if (r.status === 405 || r.status === 501) {
          return fetch('/account', {
            method: 'GET', credentials: 'same-origin', redirect: 'follow', cache: 'no-store',
            headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' }
          });
        }
        return r;
      })
      .then(function (r) {
        var vPath = '';
        try { vPath = new URL(r.url).pathname; } catch (_) { vPath = r.url; }
        var loggedIn = /^\/account(\/|$)/.test(vPath) && !/\/login/.test(vPath) && !/\/register/.test(vPath);
        if (!loggedIn) return false;
        if (wrap.dataset.done === '1') return true;
        wrap.dataset.done = '1';
        // Now (and only now) fetch the HTML to extract the first name.
        return fetch('/account', { method: 'GET', credentials: 'same-origin', redirect: 'follow', cache: 'no-store' })
          .then(function (r2) { return r2.text(); })
          .then(function (html) {
            var firstName = extractFirstNameFromHtml(html) || bestGuessNameFromEmail(email);
            finishLogin(wrap, email, firstName);
            return true;
          })
          .catch(function () {
            // Even if the follow-up GET fails, we know the user is signed in.
            finishLogin(wrap, email, bestGuessNameFromEmail(email));
            return true;
          });
      })
      .catch(function () { return false; });
  }

  function pollLoginStatus(wrap, frame, email, btn, errEl, attempt) {
    if (wrap.dataset.done === '1') return;
    // Total budget: 60 attempts * 250ms = ~15 s.
    if (attempt > 60) {
      // Last-ditch: one final probe after a 2s cooldown before we give up.
      if (wrap.dataset.retriedOnce !== '1') {
        wrap.dataset.retriedOnce = '1';
        setTimeout(function () {
          runProbe(wrap, frame, email, btn, errEl).then(function (done) {
            if (done || wrap.dataset.done === '1') return;
            showLoginError(btn, errEl, T('cg_signin_slow', 'Sign-in is taking longer than expected. Please try again.'));
          });
        }, 2000);
        return;
      }
      showLoginError(btn, errEl, T('cg_signin_slow', 'Sign-in is taking longer than expected. Please try again.'));
      return;
    }
    // Live progress on the button so the customer knows something is happening.
    try {
      wrap.dataset.attempt = String(attempt);
      if (attempt > 4 && attempt <= 60 && btn && !btn.disabled === false) {
        btn.textContent = T('cg_signing_in','Signing in') + Array(((attempt / 3) | 0) % 4 + 1).join('.');
      }
    } catch (_) {}
    runProbe(wrap, frame, email, btn, errEl).then(function (done) {
      if (done || wrap.dataset.done === '1') return;
      setTimeout(function () {
        pollLoginStatus(wrap, frame, email, btn, errEl, attempt + 1);
      }, pollDelay(attempt));
    });
  }

  function showLoginError(btn, errEl, message) {
    errEl.textContent = message;
    errEl.hidden = false;
    btn.disabled = false;
    btn.textContent = btn.dataset.origLabel || T('cg_log_in','Log in');
  }

  // Shopify's default account templates put the first name in a heading
  // like "Hello, First!" or "Hi, First". Reject common false positives from
  // form labels (First / Last / Name) and boilerplate copy so we never
  // greet the customer as "First".
  function extractFirstNameFromHtml(html) {
    if (!html) return null;
    var REJECT = /^(First|Last|Name|there|back|to|the|Your|Account|Full|User|My|Sign|Log|In|Out|Please|Enter|Welcome|Hello|Hi|Order|Orders|Address|Addresses|Details|Edit|Save|Cancel|Home|Store|Menu|Cart|Shop|Search)$/i;
    var patterns = [
      /Hi,?\s+([A-Za-z][A-Za-z'\-]{1,40})/,
      /Hello,?\s+([A-Za-z][A-Za-z'\-]{1,40})/,
      /Welcome,?\s+([A-Za-z][A-Za-z'\-]{1,40})/,
      /Order[^<]{0,40}for\s+([A-Za-z][A-Za-z'\-]{1,40})/
    ];
    for (var i = 0; i < patterns.length; i++) {
      var m = html.match(patterns[i]);
      if (m && m[1] && !REJECT.test(m[1])) return m[1];
    }
    return null;
  }

  function bestGuessNameFromEmail(email) {
    var local = String(email || '').split('@')[0] || '';
    var name = local.split(/[._\-+]/)[0] || '';
    if (!name) return '';
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }

  function finishLogin(wrap, email, firstName) {
    CFG.customer = {
      id: null,
      email: email,
      first_name: firstName || '',
      last_name: ''
    };
    var name = firstName ? firstName : 'there';
    wrap.classList.add('tsv-login--done');
    wrap.innerHTML =
      '<div class="tsv-login__done">' +
        '<div class="tsv-login__dot"></div>' +
        '<div>' +
          '<div class="tsv-login__doneTitle">Signed in as ' + escapeHtml(name) + '</div>' +
          '<div class="tsv-login__doneSub">Updating your session.</div>' +
        '</div>' +
      '</div>';
    // Hold the success card long enough to actually register visually,
    // then drop the personalised welcome + signed-in chips.
    setTimeout(function () {
      // Remove the transient "Signed in as X" card FIRST so it is never part of
      // the snapshot we save just below, then type the welcome + chips.
      if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
      appendConcierge('Welcome back, ' + name + '. I remember what suits you, tell me what you are after today.', true);
      var chips = ['My latest order', 'Track my order', 'My points balance', 'Pick something new for me'];
      appendChips(chips, true);
      // Reload the page to refresh the site header (account dropdown + Members
      // Vault ribbon) ONLY after the welcome has fully typed and chips mounted.
      // Queued on the animation chain so the reload never cuts the welcome off
      // mid-type. We save a clean snapshot (transient card already removed) so
      // the reloaded page rehydrates to welcome + chips, not the login card.
      tsvQueue(function () {
        return new Promise(function (resolve) {
          setTimeout(function () {
            try { saveSnapshot(); } catch (_) {}
            try { window.sessionStorage.setItem('tsv_concierge_reopen', '1'); } catch (_) {}
            try { window.location.reload(); } catch (_) {}
            resolve();
          }, 1400);
        });
      });
    }, 1800);
  }

  // Schedule a soft page reload after the welcome message has been on-screen
  // long enough to be read. Section Rendering API swaps broke the theme's
  // menu-drawer / cart-drawer custom elements because they don't re-init on
  // outerHTML replace. A full reload is the only reliable way to update the
  // header, and it feels seamless because the chat's localStorage snapshot
  // rehydrates the conversation instantly on the next page load.
  function refreshSiteHeader() {
    // Save the snapshot now so the reloaded page has the welcome card cached.
    saveSnapshotWhenIdle();
    // Mark that we should auto-reopen the widget after the reload.
    setTimeout(function () {
      try { window.sessionStorage.setItem('tsv_concierge_reopen', '1'); } catch (_) {}
      try { window.location.reload(); } catch (_) {}
    }, 3200);
  }

  function fallbackIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="#0F1720" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M9 3 h6 v2 h1 v3 c3 1 4 4 4 7 v6 c0 1-1 2-2 2 h-10 c-1 0-2-1-2-2 v-6 c0-3 1-6 4-7 v-3 h1 z"/>' +
      '</svg>';
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Product title splitter — mirrors the PDP splitter logic. Takes a full
  // Shopify title like "Man in Black EDP 100ml" and returns
  // { name: "Man in Black", subtitle: "Eau de Parfum · 100ml" }.
  // Used by every product card in the widget so long concentration + size
  // trails collapse into a compact eyebrow line under the fragrance name,
  // matching the editorial style of the PDP.
  function tsvSplitTitle(fullTitle) {
    var out = { name: String(fullTitle || '').trim(), subtitle: '' };
    if (!out.name) return out;
    var CONC_MAP = {
      'edp': 'Eau de Parfum', 'edt': 'Eau de Toilette',
      'edc': 'Eau de Cologne', 'eds': 'Eau de Senteur',
      'parfum': 'Parfum', 'elixir': 'Elixir',
      'extrait': 'Extrait de Parfum', 'cologne': 'Cologne'
    };
    var CONC_RE = /\b(Eau\s+de\s+Parfum(?:\s+Intense|\s+Fra[iî]che)?|Eau\s+de\s+Toilette(?:\s+Intense)?|Eau\s+de\s+Cologne|Eau\s+de\s+Senteur|Eau\s+Fra[iî]che|Extrait\s+de\s+Parfum|EDP|EDT|EDC|EDS|Parfum|Elixir|Extrait|Cologne)\b(?=(?:\s*(?:limited\s+edition|\(?\s*\d+(?:\.\d+)?\s*(?:[x×]\s*\d+(?:\.\d+)?\s*)?ml\s*\)?|\+\s*\d+(?:\.\d+)?\s*[x×]\s*\d+(?:\.\d+)?\s*ml|(?:gift|discovery|travel)\s+set|duo|set))*\s*$)/i;
    var SIZE_RE = /\(?\s*(\d+(?:\.\d+)?(?:\s*[x×]\s*\d+(?:\.\d+)?)?)\s*ml\b\s*\)?/i;
    /* Product-type suffix — identical list to tsv-search.js so every surface splits alike. */
    var TYPE_RE = /\b(Deodorant\s+Stick|Deodorant\s+Spray|Deodorant|Roll[- ]?On|Bath\s*&\s*Shower\s+Gel|Shower\s+Gel|Shower\s+Cream|Bath\s+Gel|Body\s+Lotion|Body\s+Cream|Body\s+Butter|Body\s+Spray|Body\s+Wash|Body\s+Oil|Hair\s*&\s*Body\s+Mist|Body\s+Mist|Hair\s+Mist|Hand\s+Cream|After\s*shave\s+Balm|After\s*shave\s+Lotion|After\s*shave|Gift\s+Set|Discovery\s+Set|Travel\s+Set|Duo|Beard\s+Oil|Lotion|Soap|Candle)\b/i;
    var titleText = out.name.replace(/\s+/g, ' ');
    var name = titleText;
    var parts = [];
    var concMatch = titleText.match(CONC_RE);
    if (concMatch) {
      var idx = concMatch.index;
      name = titleText.slice(0, idx).replace(/[\s,·\-–]+$/, '').trim();
      var rest = titleText.slice(idx + concMatch[0].length).trim();
      parts.push(CONC_MAP[concMatch[1].toLowerCase()] || concMatch[1]);
      var sizeMatch = rest.match(SIZE_RE) || titleText.match(SIZE_RE);
      if (sizeMatch) parts.push(sizeMatch[1] + 'ml');
      if (!name) { name = titleText; parts = []; }
    } else if (titleText.match(TYPE_RE)) {
      var tmatch = titleText.match(TYPE_RE);
      name = titleText.slice(0, tmatch.index).replace(/[\s,·\-–]+$/, '').trim();
      parts.push(tmatch[1]);
      var tsm = titleText.match(SIZE_RE);
      if (tsm) parts.push(tsm[1] + 'ml');
      if (!name) { name = titleText; parts = []; }
    } else {
      var sm = titleText.match(SIZE_RE);
      if (sm) {
        name = titleText.replace(SIZE_RE, '').replace(/[\s,·\-–]+$/, '').trim();
        parts.push(sm[1] + 'ml');
      }
    }
    out.name = name || titleText;
    out.subtitle = parts.join(' · ');
    return out;
  }

  // Convert ISO currency codes coming from the worker (e.g. "EUR 43.10") to
  // symbols ("€43.10") and collapse extra whitespace. Falls back to the
  // input unchanged if no mapping matches. Output is HTML-escaped.
  var TSV_CCY = { EUR: '€', GBP: '£', USD: '$', AUD: 'A$', CAD: 'C$', JPY: '¥' };
  function formatPriceString(raw) {
    if (raw == null) return '';
    var out = String(raw).trim();
    // Replace "EUR 43.10" or "EUR43.10" with the symbol tight to the digits.
    out = out.replace(/\b(EUR|GBP|USD|AUD|CAD|JPY)\s*/gi, function (_, code) {
      var sym = TSV_CCY[code.toUpperCase()] || code;
      return sym;
    });
    // Collapse any double spaces the swap might introduce.
    out = out.replace(/\s{2,}/g, ' ').trim();
    return escapeHtml(out);
  }

  function appendProducts(items, opts) {
    // Queue behind the typewriter so cards never appear during text reveal.
    return tsvQueue(function () { return _appendProductsImpl(items, opts || {}); });
  }

  // T('cg_complete_set',"Complete the set") body-care upsell. Renders a distinct labelled block
  // (heading + one line of context) so it reads clearly as an add-on, then the
  // matching product using the exact same card as the fragrance recs.
  function appendUpsell(m) {
    if (!m) return;
    var items = (m.items && m.items.length) ? m.items : (m.item ? [m.item] : []);
    if (!items.length) return;
    tsvQueue(function () {
      var head = document.createElement('div');
      head.className = 'tsv-upsell__head';
      head.innerHTML =
        '<div class="tsv-upsell__label">' + escapeHtml(m.heading || T('cg_complete_set','Complete the set')) + '</div>' +
        (m.text ? '<div class="tsv-upsell__text">' + escapeHtml(m.text) + '</div>' : '');
      messagesEl.appendChild(head);
      requestAnimationFrame(function () { head.classList.add('is-in'); });
      return Promise.resolve();
    });
    // One card per matching body product (e.g. shower gel + deodorant), same
    // style as the fragrance cards, mounted one after the other.
    items.forEach(function (it, idx) {
      if (idx > 0) tsvChainPause(600);
      appendProducts([it], { showRefine: false });
    });
  }
  function _appendProductsImpl(items, opts) {
    opts = opts || {};
    if (!items || !items.length) return;
    var wrap = document.createElement('div');
    // Comparison mode (#525): additive layout hint. When opts.layout is
    // 'compare' we render cards in a horizontal grid and append an
    // attribute table below. Default layout unchanged, no behaviour
    // regression on standard product replies.
    var isCompareLayout = opts.layout === 'compare';
    wrap.className = 'tsv-recs' + (isCompareLayout ? ' tsv-recs--compare' : '');
    items.forEach(function (p) {
      var isNiche = /niche/i.test(String(p.badge || ''));
      var card = document.createElement('div');
      card.className = 'tsv-rec' + (isNiche ? ' tsv-rec--niche' : '');

      var imgHtml = p.image
        ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title || '') + '" loading="lazy">'
        : fallbackIcon();

      var badgeHtml = '';
      if (p.badge) {
        var b = String(p.badge);
        var cls = 'tsv-rec__badge ';
        if (isNiche) cls += 'tsv-rec__badge--niche';
        else if (/sale|off|%/i.test(b)) cls += 'tsv-rec__badge--sale';
        else cls += 'tsv-rec__badge--low';
        badgeHtml = '<span class="' + cls + '">' + escapeHtml(b) + '</span>';
      }

      // Selected size variant (defaults to p.variant_id = the 100ml the worker sends).
      var selectedVid = p.variant_id;
      var isSale = !!(p.compare_at_price || p.compare);
      var priceHtml = '';
      if (p.price) {
        if (isSale) {
          priceHtml =
            '<span class="tsv-rec__nowlabel">NOW</span>' +
            '<span class="tsv-rec__price tsv-rec__price--sale">' + formatPriceString(p.price) + '</span>';
        } else {
          priceHtml = '<span class="tsv-rec__price">' + formatPriceString(p.price) + '</span>';
        }
      }
      var compareHtml = isSale
        ? '<span class="tsv-rec__waslabel">WAS</span>' +
          '<span class="tsv-rec__compare">' + formatPriceString(p.compare_at_price || p.compare) + '</span>'
        : '';
      var saveHtml = p.save_amount
        ? '<span class="tsv-rec__savepill">SAVE ' + formatPriceString(p.save_amount) + '</span>'
        : '';

      var topOpenTag = p.url
        ? '<a class="tsv-rec__top" href="' + escapeHtml(p.url) + '" rel="noopener">'
        : '<div class="tsv-rec__top">';
      var topCloseTag = p.url ? '</a>' : '</div>';

      // Feature 41: share button overlay on every product card.
      var shareTitle = escapeHtml((p.vendor ? p.vendor + ' ' : '') + (p.title || ''));
      var shareUrl = p.url ? escapeHtml(p.url) : '';
      var shareBtnHtml = (tsvFeatOn('shareButton') && shareUrl)
        ? '<button type="button" class="tsv-rec__share" data-share-url="' + shareUrl + '" data-share-title="' + shareTitle + '" aria-label="Share this fragrance">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
              '<circle cx="18" cy="5" r="3"/>' +
              '<circle cx="6" cy="12" r="3"/>' +
              '<circle cx="18" cy="19" r="3"/>' +
              '<line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>' +
              '<line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>' +
            '</svg>' +
          '</button>'
        : '';

      var innerHTML =
        shareBtnHtml +
        topOpenTag +
          '<div class="tsv-rec__img">' + imgHtml + '</div>' +
          '<div class="tsv-rec__body">' +
            '<div class="tsv-rec__vendorRow">' +
              '<div class="tsv-rec__vendor">' + escapeHtml(p.vendor || '') + '</div>' +
              badgeHtml +
            '</div>' +
            (function(){ var s = tsvSplitTitle(p.title || ''); return '<div class="tsv-rec__title">' + escapeHtml(s.name) + '</div>' + (s.subtitle ? '<div class="tsv-rec__subtitle">' + escapeHtml(s.subtitle) + '</div>' : ''); })() +
            '<div class="tsv-rec__meta">' + priceHtml + compareHtml + saveHtml + '</div>' +
          '</div>' +
        topCloseTag;

      // OOS products: render Notify-Me button in place of Add/Buy. Widget
      // treats missing in_stock as true (default in-stock) so cached cards
      // from older worker builds keep working.
      var isOOS = (p.in_stock === false);
      if (isOOS) {
        innerHTML +=
          '<div class="tsv-rec__actions">' +
            '<button type="button" class="tsv-rec__action tsv-rec__action--notify" data-product="' + escapeHtml(p.id || '') + '" data-title="' + escapeHtml(p.title || '') + '">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.7 21a2 2 0 0 1-3.4 0"/></svg>' +
              T('cg_notify_back','Notify me when back') +
            '</button>' +
          '</div>';
      } else if (p.variant_id) {
        // Multi-size (consolidated) products: size chips to pick a size before adding.
        var _sizesHtml = '';
        if (p.variants && p.variants.length > 1) {
          _sizesHtml = '<div class="tsv-rec__sizes" role="group" aria-label="Choose a size">' +
            p.variants.map(function (vv) {
              var so = vv.available === false;
              return '<button type="button" class="tsv-rec__size' + (so ? ' is-soldout' : '') + '"' +
                ' data-variant="' + escapeHtml(vv.variant_id) + '"' +
                ' data-price="' + escapeHtml(vv.price || '') + '"' +
                (so ? ' disabled aria-disabled="true"' : '') + '>' +
                escapeHtml(vv.size || '') + '</button>';
            }).join('') + '</div>';
        }
        innerHTML += _sizesHtml +
          '<div class="tsv-rec__actions">' +
            '<button type="button" class="tsv-rec__action tsv-rec__action--add" data-variant="' + escapeHtml(p.variant_id) + '" data-title="' + escapeHtml(p.title || '') + '">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>' +
              T('cg_add_to_bag','Add to bag') +
            '</button>' +
            '<button type="button" class="tsv-rec__action tsv-rec__action--buy" data-buy-variant="' + escapeHtml(p.variant_id) + '">' +
              T('cg_buy_now','Buy now') +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>' +
            '</button>' +
          '</div>';
      }

      card.innerHTML = innerHTML;

      var addBtn = card.querySelector('.tsv-rec__action--add');
      var buyBtn = card.querySelector('.tsv-rec__action--buy');
      var priceEl = card.querySelector('.tsv-rec__price');

      // Size chips: pick a size → update the selected variant, the price, and the
      // Add/Buy buttons. Buy Now is handled by a delegated listener that reads
      // data-buy-variant at click time, so updating the attribute is enough.
      var sizeBtns = card.querySelectorAll('.tsv-rec__size');
      if (sizeBtns.length) {
        var selectSize = function (btn) {
          var vid = btn.getAttribute('data-variant');
          var pr = btn.getAttribute('data-price');
          selectedVid = vid;
          for (var j = 0; j < sizeBtns.length; j++) { sizeBtns[j].classList.remove('is-selected'); }
          btn.classList.add('is-selected');
          if (addBtn) addBtn.setAttribute('data-variant', vid);
          if (buyBtn) buyBtn.setAttribute('data-buy-variant', vid);
          if (priceEl && pr) priceEl.textContent = pr;
        };
        var def = null;
        for (var k = 0; k < sizeBtns.length; k++) {
          if (String(sizeBtns[k].getAttribute('data-variant')) === String(p.variant_id)) { def = sizeBtns[k]; break; }
        }
        if (!def) { for (var m = 0; m < sizeBtns.length; m++) { if (!sizeBtns[m].disabled) { def = sizeBtns[m]; break; } } }
        if (def) selectSize(def);
        for (var n = 0; n < sizeBtns.length; n++) {
          (function (btn) {
            if (btn.disabled) return;
            btn.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); selectSize(btn); });
          })(sizeBtns[n]);
        }
      }

      if (addBtn) {
        addBtn.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          addToCart(selectedVid, addBtn);
        });
      }


      // Notify-Me handler for OOS cards. Swaps the button for an inline
      // mini-form (email input + submit), posts to /back-in-stock/subscribe,
      // then shows a confirmation ribbon in place of the form on success.
      var notifyBtn = card.querySelector('.tsv-rec__action--notify');
      if (notifyBtn) {
        notifyBtn.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var actionsRow = notifyBtn.parentNode;
          if (!actionsRow) return;
          // Prefill from a signed-in customer email if we have one, so
          // most taps become one-click submits.
          var prefill = (window.tsvCurrentCustomer && window.tsvCurrentCustomer.email) || '';
          // Signed-in customers already get marketing mail, so only offer the
          // newsletter opt-in to logged-out shoppers (matches email-picks/contact).
          var notifyAnon = !(window.tsvCurrentCustomer && window.tsvCurrentCustomer.id);
          actionsRow.innerHTML =
            '<form class="tsv-notify" novalidate>' +
              '<input type="email" required autocomplete="email" placeholder="Your email" value="' + escapeHtml(prefill) + '" class="tsv-notify__input" />' +
              '<button type="submit" class="tsv-notify__btn">Notify me</button>' +
            '</form>' +
            (notifyAnon ? '<label class="tsv-mini__check"><input type="checkbox" name="subscribe"><span>Also email me new arrivals and offers</span></label>' : '') +
            '<div class="tsv-notify__err" hidden></div>';
          var form = actionsRow.querySelector('.tsv-notify');
          var input = actionsRow.querySelector('.tsv-notify__input');
          var errEl = actionsRow.querySelector('.tsv-notify__err');
          setTimeout(function () { try { input.focus(); } catch (_) {} }, 60);
          form.addEventListener('submit', function (subEv) {
            subEv.preventDefault();
            var email = (input.value || '').trim();
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
              errEl.textContent = T('cg_valid_email','Give me a valid email.');
              errEl.hidden = false;
              return;
            }
            errEl.hidden = true;
            var btn = form.querySelector('.tsv-notify__btn');
            btn.disabled = true;
            btn.textContent = T('cg_locking_in','Locking in…');
            fetch(TSV_WORKER_URL + '/back-in-stock/subscribe', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                email: email,
                product_id: p.id,
                session_id: window.tsvSessionId || '',
                source: 'widget',
                subscribe: (function () { var s = actionsRow.querySelector('input[name="subscribe"]'); return !!(s && s.checked); })()
              })
            }).then(function (r) { return r.json().catch(function () { return {}; }); })
              .then(function (data) {
                if (data && data.ok && data.already_in_stock) {
                  actionsRow.innerHTML = '<div class="tsv-notify__done tsv-notify__done--now">Already in stock! <a href="' + escapeHtml(data.product && data.product.url || p.url || '#') + '">Have a look</a>.</div>';
                } else if (data && data.ok) {
                  actionsRow.innerHTML = '<div class="tsv-notify__done">You will hear the moment it lands.</div>';
                } else {
                  errEl.textContent = (data && data.message) || T('cg_save_failed','Could not save that. Try again.');
                  errEl.hidden = false;
                  btn.disabled = false;
                  btn.textContent = T('cg_notify_me','Notify me');
                }
              }).catch(function () {
                errEl.textContent = T('cg_network_hiccup','Network hiccup. Try again in a moment.');
                errEl.hidden = false;
                btn.disabled = false;
                btn.textContent = T('cg_notify_me','Notify me');
              });
          });
        });
      }

      var buyBtn = card.querySelector('.tsv-rec__action--buy');
      if (buyBtn) {
        buyBtn.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          buyBtn.disabled = true;
          buyBtn.textContent = 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: p.variant_id, quantity: 1 })
          })
            .then(function (r) {
              if (!r.ok) throw new Error('add failed');
              window.location.href = '/checkout';
            })
            .catch(function () {
              buyBtn.disabled = false;
              buyBtn.textContent = T('cg_buy_now','Buy now');
              appendConcierge(T('cg_checkout_failed', 'Could not start checkout just now. Please try again or open the product page.'));
            });
        });
      }

      // Feature 41: wire share button — Web Share API where available,
      // clipboard fallback everywhere else, with a "Copied" pulse.
      var shareBtn = card.querySelector('.tsv-rec__share');
      if (shareBtn) {
        shareBtn.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var url = shareBtn.getAttribute('data-share-url') || '';
          var title = shareBtn.getAttribute('data-share-title') || '';
          if (!url) return;
          var absUrl = /^https?:\/\//.test(url) ? url : (window.location.origin + url);
          var shareData = { title: title, text: title, url: absUrl };
          function flashCopied() {
            shareBtn.classList.add('is-copied');
            setTimeout(function () { shareBtn.classList.remove('is-copied'); }, 1400);
          }
          if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
            navigator.share(shareData).catch(function () {});
            return;
          }
          if (navigator.share) {
            navigator.share(shareData).catch(function () {
              try {
                navigator.clipboard.writeText(absUrl).then(flashCopied);
              } catch (_) { flashCopied(); }
            });
            return;
          }
          try {
            navigator.clipboard.writeText(absUrl).then(flashCopied).catch(flashCopied);
          } catch (_) { flashCopied(); }
        });
      }

      // Unified card footer row: T('cg_add_shortlist',"Add to shortlist") and T('cg_explain_more',"Explain more") sit on
      // one line with identical styling for a clean, uniform look. Either can be
      // absent (compare cards have no Explain More; shortlist can be feature-off)
      // and the row still lays out correctly.
      var _utilRow = document.createElement('div');
      _utilRow.className = 'tsv-rec__utilRow';
      var _utilUsed = false;
      var _explainPanel = null;

      // Add to shortlist: collects picks across the whole conversation into the
      // pinned shortlist. Separate from the bookmark (signed-in fragrance shelf).
      if (tsvFeatOn('shortlist') && (p.id || p.variant_id)) {
        var slBtn = document.createElement('button');
        slBtn.type = 'button';
        slBtn.className = 'tsv-rec__utilBtn tsv-rec__shortlistBtn';
        slBtn.setAttribute('data-sl-id', String(p.id || p.variant_id || ''));
        (function (prod, button) {
          function paint() {
            var on = shortlistHas(prod.id || prod.variant_id);
            button.classList.toggle('is-in', on);
            button.innerHTML = _shortlistBtnHtml(on);
          }
          paint();
          button.addEventListener('click', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            var key = prod.id || prod.variant_id;
            if (shortlistHas(key)) shortlistRemove(key);
            else shortlistAdd(prod);
            paint();
          });
        })(p, slBtn);
        _utilRow.appendChild(slBtn);
        _utilUsed = true;
      }

      // Feature 8: explain-more expandable panel per card. Skip it on compare
      // cards - the two full side-by-side cards already show all the detail.
      if (tsvFeatOn('explainMore') && !isCompareLayout) {
        var explainRows = [];
        function addExplainRow(label, val) {
          if (val === null || val === undefined || val === '') return;
          explainRows.push('<div class="tsv-rec__explainRow"><div class="tsv-rec__explainLabel">' + escapeHtml(label) + '</div><div class="tsv-rec__explainVal">' + escapeHtml(String(val)) + '</div></div>');
        }
        // Cap comma/slash/'and'-separated lists to the first N so cards show a
        // clean summary instead of dumping every note in the catalog.
        function capList(val, n) {
          var arr = Array.isArray(val)
            ? val.slice()
            : String(val || '').split(/[,;/]|\band\b/i);
          return arr.map(function (t) { return String(t).trim(); })
            .filter(Boolean).slice(0, n).join(', ');
        }
        // Families / notes / longevity / sillage are rendered by the richer
        // scent-profile block (loaded from /perception, capped at 3 each), so we
        // only keep the story line here to avoid duplication and note overload.
        addExplainRow('Story', p.short_description || p.scent_story || '');
        var explainBtn = document.createElement('button');
        explainBtn.type = 'button';
        explainBtn.className = 'tsv-rec__utilBtn tsv-rec__explainBtn';
        explainBtn.innerHTML = 'Scent details <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';
        _explainPanel = document.createElement('div');
        _explainPanel.className = 'tsv-rec__explain';
        _explainPanel.innerHTML = explainRows.join('');
        // Container for community perception, appended once (lazy-loaded).
        var perceptionSlot = document.createElement('div');
        perceptionSlot.className = 'tsv-rec__perception';
        _explainPanel.appendChild(perceptionSlot);
        var perceptionLoaded = false;
        explainBtn.addEventListener('click', function () {
          var open = _explainPanel.classList.toggle('is-open');
          explainBtn.classList.toggle('is-open', open);
          // Lazy-load the community perception on FIRST open only.
          if (open && !perceptionLoaded) {
            perceptionLoaded = true;
            tsvLoadPerception(p, perceptionSlot);
          }
        });
        _utilRow.appendChild(explainBtn);
        _utilUsed = true;
      }

      if (_utilUsed) card.appendChild(_utilRow);
      if (_explainPanel) card.appendChild(_explainPanel);

      // Feature 2 wiring: bookmark button on every product card. Top-right
      // over the image, opens a small popover with Owned / Sampled /
      // Wishlist. Only rendered when the shelf feature is on.
      if (tsvFeatOn('wardrobeView')) {
        var bookmarkBtn = document.createElement('button');
        bookmarkBtn.type = 'button';
        bookmarkBtn.className = 'tsv-rec__bookmark';
        bookmarkBtn.setAttribute('aria-label', T('cg_save_to_shelf','Save to my shelf'));
        bookmarkBtn.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>' +
          '</svg>';
        var pop = document.createElement('div');
        pop.className = 'tsv-rec__bookmarkPop';
        pop.style.display = 'none';
        pop.innerHTML =
          '<button type="button" data-tsv-shelf="owned">Owned</button>' +
          '<button type="button" data-tsv-shelf="sampled">Sampled</button>' +
          '<button type="button" data-tsv-shelf="wishlist">Want next</button>';
        bookmarkBtn.addEventListener('click', function (ev) {
          ev.preventDefault(); ev.stopPropagation();
          pop.style.display = (pop.style.display === 'none') ? 'flex' : 'none';
        });
        pop.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function (ev) {
            ev.preventDefault(); ev.stopPropagation();
            var status = b.getAttribute('data-tsv-shelf') || 'owned';
            tsvAddToWardrobe(p, status);
            pop.style.display = 'none';
          });
        });
        card.appendChild(bookmarkBtn);
        card.appendChild(pop);
      }

      wrap.appendChild(card);
    });

    // Comparison mode: build the attribute table BELOW the cards. Grid of
    // (labels column + one column per product). Only rendered when the
    // worker attached compare_attrs OR when in compare layout mode.
    if (isCompareLayout) {
      var table = document.createElement('div');
      table.className = 'tsv-compare-table';
      var head = document.createElement('div');
      head.className = 'tsv-compare-table__head';
      head.textContent = T('cg_side_by_side','Side by side');
      table.appendChild(head);

      // Render attributes if available, otherwise show empty state
      if (Array.isArray(opts.attrs) && opts.attrs.length) {
        opts.attrs.forEach(function (row) {
          var line = document.createElement('div');
          line.className = 'tsv-compare-table__row';
          var lbl = document.createElement('div');
          lbl.className = 'tsv-compare-table__label';
          lbl.textContent = row.label;
          line.appendChild(lbl);
          var vals = document.createElement('div');
          vals.className = 'tsv-compare-table__vals';
          (row.values || []).forEach(function (v) {
            var cell = document.createElement('div');
            cell.className = 'tsv-compare-table__val';
            cell.textContent = v || T('cg_not_stated','Not stated');
            vals.appendChild(cell);
          });
          line.appendChild(vals);
          table.appendChild(line);
        });
      } else {
        // Empty state: no attribute data available
        var emptyLine = document.createElement('div');
        emptyLine.className = 'tsv-compare-table__row tsv-compare-table__empty';
        emptyLine.textContent = T('cg_no_attribute_data','Attribute data not available for comparison');
        table.appendChild(emptyLine);
      }
      wrap.appendChild(table);
    }

    messagesEl.appendChild(wrap);

    // Feature 19: append the refinement chip strip below the product set
    // so there is always a one-tap way to keep narrowing the picks.
    // Uses the first two products as the reference for "more like these"
    // so the AI has concrete anchor bottles to build off.
    var firstThreeTitles = items.slice(0, 3).map(function (p) {
      return (p.vendor ? p.vendor + ' ' : '') + (p.title || '');
    }).filter(Boolean);
    var _showRefineDefault = (opts.showRefine !== false);
    if (_showRefineDefault && tsvFeatOn('refinementChips') && firstThreeTitles.length) {
      var refineWrap = document.createElement('div');
      refineWrap.className = 'tsv-recs__refine';
      var refineOptions = [
        { label: T('cg_chip_more_like_these','Show me more like these'), kind: 'more' },
        { label: T('cg_chip_cheaper','Something cheaper'), kind: 'cheaper' },
        { label: T('cg_chip_more_niche','Something more niche'), kind: 'niche' },
        { label: T('cg_chip_different_mood','Different mood'), kind: 'mood' }
      ];
      refineOptions.forEach(function (opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tsv-recs__refineBtn';
        btn.textContent = opt.label;
        btn.addEventListener('click', function () {
          removeChips();
          var seed = firstThreeTitles.join(', ');
          var msg;
          if (opt.kind === 'more') {
            msg = T('cg_q_more_similar_to','Show me more picks similar to ') + firstThreeTitles[0] +
                  (firstThreeTitles.length > 1 ? ', but different from ' + firstThreeTitles.join(', ') : '');
          } else if (opt.kind === 'cheaper') {
            msg = T('cg_q_cheaper_than','Cheaper alternatives to ') + firstThreeTitles[0];
          } else if (opt.kind === 'niche') {
            msg = T('cg_q_niche_like','More niche picks like ') + firstThreeTitles[0];
          } else {
            msg = T('cg_q_different_mood_to','Different mood to ') + seed + ' — same quality, different vibe';
          }
          appendUser(opt.label);
          submitDirect(msg);
        });
        refineWrap.appendChild(btn);
      });
      messagesEl.appendChild(refineWrap);
    }

    // Stick to the BOTTOM as the card set mounts so the reply unrolls
    // downward and the newest card is always in view (matches the text
    // typewriter, which also sticks to the bottom). Re-pin on image load
    // and a couple of times after the entrance settles, because a
    // late-loading image or the CSS slide-in grows the card height and
    // would otherwise leave the container a few pixels short of the bottom.
    // tsvMaybeStickBottom force-sticks while _tsvRevealActive is set (the
    // reveal path); outside a reveal it respects the 80px "user scrolled
    // up" threshold, so this never fights a customer re-reading history.
    tsvMaybeStickBottom();
    try {
      var imgs = wrap.querySelectorAll('img');
      imgs.forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', function () { tsvMaybeStickBottom(); }, { once: true });
        img.addEventListener('error', function () { tsvMaybeStickBottom(); }, { once: true });
      });
    } catch (_) {}
    setTimeout(function () { tsvMaybeStickBottom(); }, 300);
    setTimeout(function () { tsvMaybeStickBottom(); }, 1200);
    // Remember the last product set (with reasons) so T('cg_email_picks',"Email me these picks")
    // can send it. Reason strings come from the [REC:id:reason] format the
    // parser emits, so they carry the "why this pick" line into the email.
    try {
      lastProductsBatch = (items || []).slice(0, 6).map(function (p) {
        return {
          title: p.title || '',
          vendor: p.vendor || '',
          price: p.price || '',
          compare_at_price: p.compare_at_price || '',
          image: p.image || '',
          url: p.url || '',
          reason: p.reason || ''
        };
      });
    } catch (_) {}
    // ALWAYS surface the mailer chip right after the products land. Runs
    // synchronously so it can't be pre-empted by any AI follow-up chips.
    // If a previous email-picks chip is still visible from an earlier turn,
    // we skip appending a duplicate.
    var hasEmailChip = false;
    var existingChips = messagesEl.querySelectorAll('.tsv-chip');
    for (var _c = 0; _c < existingChips.length; _c++) {
      if (/^email me these picks$/i.test((existingChips[_c].textContent || '').trim())) {
        hasEmailChip = true; break;
      }
    }
    if (!hasEmailChip) {
      // Signed-in customers already get marketing emails, so skip the newsletter
      // chip for them and only offer the picks mailer. Both chips render with
      // primary styling (ivory-filled with icon) so they read as distinct
      // conversion actions rather than just another follow-up suggestion.
      var isMember = !!(CFG.customer && (CFG.customer.email || CFG.customer.id));
      var chips = isMember
        ? [T('cg_send_shortlist','Send me the shortlist')]
        : [T('cg_send_shortlist','Send me the shortlist'), T('cg_drops_alerts','Send me drops + sale alerts')];
      appendChips(chips, true);
    }
    saveSnapshotWhenIdle();
  }

  var lastProductsBatch = [];

  // Inline mini form: Email me these picks.
  function showEmailPicksForm(chipText, itemsOverride) {
    if (chipText) { removeChips(); appendUser(chipText); }
    // itemsOverride lets the shortlist reuse this exact form + endpoint. Falls
    // back to the last batch of picks the AI showed.
    var picksToSend = (itemsOverride && itemsOverride.length) ? itemsOverride : lastProductsBatch;
    if (!picksToSend || !picksToSend.length) {
      appendConcierge(T('cg_no_shortlist_yet','I do not have a shortlist to send yet. Ask me for picks first.'), true);
      return;
    }
    var existing = messagesEl.querySelector('.tsv-mini--picks');
    if (existing) existing.parentNode && existing.parentNode.removeChild(existing);
    var c = CFG.customer || {};
    var notSignedIn = !(c && (c.email || c.id));
    var wrap = document.createElement('div');
    wrap.className = 'tsv-mini tsv-mini--picks';
    wrap.innerHTML =
      '<div class="tsv-mini__title">Send you these picks</div>' +
      '<div class="tsv-mini__sub">I will email the ' + Number(picksToSend.length) + ' fragrance' + (picksToSend.length > 1 ? 's' : '') + ' with links and prices.</div>' +
      '<form class="tsv-mini__form">' +
        '<input type="email" name="email" required maxlength="200" placeholder="you@email.com" value="' + escapeHtml(c.email || '') + '" autocomplete="email">' +
        (notSignedIn ? (
          '<label class="tsv-mini__check"><input type="checkbox" name="subscribe"><span>Email me new arrivals and offers</span></label>'
        ) : '') +
        '<button type="submit" class="tsv-mini__btn">Send picks</button>' +
      '</form>' +
      '<div class="tsv-mini__err" hidden></div>';
    messagesEl.appendChild(wrap);
    scrollBottom();
    var formEl = wrap.querySelector('form');
    var input  = wrap.querySelector('input[name="email"]');
    var btn    = wrap.querySelector('.tsv-mini__btn');
    var errEl  = wrap.querySelector('.tsv-mini__err');
    if (input && !c.email) setTimeout(function () { input.focus(); }, 80);
    formEl.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var email = String(input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errEl.hidden = false; errEl.textContent = T('cg_valid_email','Give me a valid email.');
        return;
      }
      errEl.hidden = true;
      btn.disabled = true; btn.textContent = 'Sending...';
      var subEl = wrap.querySelector('input[name="subscribe"]');
      var wantSub = !!(subEl && subEl.checked);
      conciergePost('/email-picks', { email: email, items: picksToSend, session_id: sessionId, customer_id: (c.id || null), subscribe: wantSub })
        .then(function (r) {
          if (r && r.ok) {
            wrap.classList.add('tsv-mini--done');
            wrap.innerHTML =
              '<div class="tsv-mini__doneRibbon">' +
                '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12l5 5L20 6"/></svg>' +
                '<span>Sent. Check ' + escapeHtml(email) + '.</span>' +
              '</div>';
            saveSnapshotWhenIdle();
          } else {
            btn.disabled = false; btn.textContent = T('cg_send_picks','Send picks');
            errEl.hidden = false;
            errEl.textContent = (r && (r.message || r.error)) ? String(r.message || r.error) : T('cg_send_failed','Could not send. Try again shortly.');
          }
        })
        .catch(function () {
          btn.disabled = false; btn.textContent = T('cg_send_picks','Send picks');
          errEl.hidden = false; errEl.textContent = T('cg_network_issue','Network issue. Try again in a moment.');
        });
    });
  }

  // Inline mini form: Newsletter opt-in.
  function showNewsletterForm(chipText) {
    if (chipText) { removeChips(); appendUser(chipText); }
    var existing = messagesEl.querySelector('.tsv-mini--news');
    if (existing) existing.parentNode && existing.parentNode.removeChild(existing);
    var c = CFG.customer || {};
    var wrap = document.createElement('div');
    wrap.className = 'tsv-mini tsv-mini--news';
    wrap.innerHTML =
      '<div class="tsv-mini__title">Sale + new drop alerts</div>' +
      '<div class="tsv-mini__sub">One editorial email a week. Unsubscribe with one click.</div>' +
      '<form class="tsv-mini__form">' +
        '<input type="email" name="email" required maxlength="200" placeholder="you@email.com" value="' + escapeHtml(c.email || '') + '" autocomplete="email">' +
        '<button type="submit" class="tsv-mini__btn">Sign up</button>' +
      '</form>' +
      '<div class="tsv-mini__err" hidden></div>';
    messagesEl.appendChild(wrap);
    scrollBottom();
    var formEl = wrap.querySelector('form');
    var input  = wrap.querySelector('input[name="email"]');
    var btn    = wrap.querySelector('.tsv-mini__btn');
    var errEl  = wrap.querySelector('.tsv-mini__err');
    if (input && !c.email) setTimeout(function () { input.focus(); }, 80);
    formEl.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var email = String(input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errEl.hidden = false; errEl.textContent = T('cg_valid_email','Give me a valid email.');
        return;
      }
      errEl.hidden = true;
      btn.disabled = true; btn.textContent = T('cg_signing_up','Signing up...');
      var payload = { email: email };
      if (c.first_name) payload.first_name = c.first_name;
      if (c.last_name)  payload.last_name  = c.last_name;
      conciergePost('/newsletter', payload)
        .then(function (r) {
          if (r && r.ok) {
            wrap.classList.add('tsv-mini--done');
            wrap.innerHTML =
              '<div class="tsv-mini__doneRibbon">' +
                '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12l5 5L20 6"/></svg>' +
                '<span>' + (r.already_subscribed ? T('cg_already_on_list','Already on the list.') : T('cg_you_are_in','You are in. Welcome.')) + '</span>' +
              '</div>';
            saveSnapshotWhenIdle();
          } else {
            btn.disabled = false; btn.textContent = T('cg_sign_up','Sign up');
            errEl.hidden = false;
            errEl.textContent = (r && (r.message || r.error)) ? String(r.message || r.error) : T('cg_signup_failed','Could not sign up. Try again shortly.');
          }
        })
        .catch(function () {
          btn.disabled = false; btn.textContent = T('cg_sign_up','Sign up');
          errEl.hidden = false; errEl.textContent = T('cg_network_issue','Network issue. Try again in a moment.');
        });
    });
  }

  // -------------------------------------------------------------------------
  // Phase 2: dedicated handlers for the signed-in chip actions. Each one
  // hits its own worker endpoint (fast, deterministic) instead of routing
  // through the AI chat. Render output as concierge messages + product cards.
  // -------------------------------------------------------------------------

  function conciergeBase() {
    var ep = CFG.endpoint || '';
    return ep.replace(/\/chat\/?$/, '');
  }
  function conciergePost(pathName, body) {
    var base = conciergeBase();
    if (!base) return Promise.reject(new Error('no endpoint'));
    return fetch(base + pathName, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body || {})
    }).then(function (r) { return r.json().catch(function () { return null; }); });
  }
  function customerPayload() {
    var c = CFG.customer || {};
    return {
      customer_id: c.id || null,
      customer_email: c.email || null,
      customer_first_name: c.first_name || null,
      session_id: sessionId
    };
  }
  function beforeChipRequest(chipText) {
    removeChips();
    appendUser(chipText);
    // Drive the loading status from the chip label so tapped flows (order,
    // loyalty, similar, etc.) get the same in-context status line as typed
    // queries, instead of falling back to the last typed query or generic.
    _tsvPendingQuery = String(chipText || '');
    appendTyping();
  }
  function afterChipRequest() {
    removeTyping();
  }
  function signInPromptIfNeeded() {
    var c = CFG.customer || {};
    if (!c.email && !c.id) {
      // Slide the sign-in form straight into the chat (same form shown when the
      // widget first opens) instead of bouncing the customer to chips, so they
      // can log in inline and I can pull up their account detail right away.
      appendConcierge(T('cg_member_only_detail','That is member-only detail. Pop your login in below and I will pull it up right away.'), true);
      try { showLoginForm(); } catch (_) {}
      appendChips([chipT('keep_chatting','cg_chip_keep_chatting','Keep chatting with you')], true);
      return true;
    }
    return false;
  }

  // --- My latest order -----------------------------------------------------
  function handleOrderLookupChip(chipText) {
    beforeChipRequest(chipText);
    if (signInPromptIfNeeded()) { afterChipRequest(); saveSnapshot(); return; }
    // Decide how many orders to fetch based on the phrasing.
    var t = String(chipText || '').toLowerCase();
    var wantsList = /orders|history|past|recent orders/.test(t);
    var body = customerPayload();
    body.limit = wantsList ? 5 : 1;
    conciergePost('/order-lookup', body)
      .then(function (data) {
        afterChipRequest();
        if (!data || !data.ok) {
          appendConcierge(T('cg_orders_fetch_failed', 'I could not pull your orders just now. Please try again shortly.'), true);
          appendChips([chipT('bestsellers','cg_chip_pick_new','Pick something new for me'), chipT('points','cg_chip_points','My points balance'), T('cg_speak_to_team','Speak to the team')], true);
          saveSnapshotWhenIdle();
          return;
        }
        var orders = (data.orders || []);
        if (!orders.length) {
          appendConcierge(T('cg_no_orders_yet', 'Looks like you have not placed an order with us yet. Tell me what you are drawn to and I will find something for you.'), true);
          appendChips([chipT('bestsellers','cg_chip_pick_new','Pick something new for me'), chipT('on_sale','cg_chip_on_sale','What is on sale this week')], true);
          return;
        }
        if (wantsList && orders.length > 1) {
          appendConcierge(T('cg_here_are_your','Here are your ') + orders.length + T('cg_most_recent_orders',' most recent orders.'), true);
          orders.forEach(function (o) { renderOrder(o); });
        } else {
          // Warm typing intro so the order card follows a text bubble
          // instead of appearing on its own, matching the AI response feel.
          appendConcierge(T('cg_recent_order_intro', 'Here is your most recent order. Full item list, order total, delivery status, and tracking if it has shipped are all in the card below.'), true);
          renderOrder(orders[0]);
        }
        appendChips([chipT('track','cg_chip_track_order','Track my order'), chipT('points','cg_chip_points','My points balance'), T('cg_speak_to_team','Speak to the team')], true);
        saveSnapshotWhenIdle();
      })
      .catch(function () {
        afterChipRequest();
        submitDirect(chipText);
      });
  }
  function renderOrder(o) {
    return tsvQueue(function () { return _renderOrderImpl(o); });
  }
  function _renderOrderImpl(o) {
    if (!o) return;
    var placed = o.created_at ? new Date(o.created_at) : null;
    var dateStr = (placed && !isNaN(placed.getTime()))
      ? placed.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })
      : '';
    var wrap = document.createElement('div');
    wrap.className = 'tsv-msg tsv-msg--concierge tsv-order';
    // Header row: order name + date + total
    var meta = [];
    if (dateStr) meta.push('Placed ' + dateStr);
    if (o.total) meta.push('Total ' + formatPriceString(o.total));
    // Status pills
    var pills = '';
    if (o.status_label) pills += '<span class="tsv-order__pill tsv-order__pill--' + (o.status_tone || 'info') + '">' + escapeHtml(o.status_label) + '</span>';
    if (o.financial_label) pills += '<span class="tsv-order__pill tsv-order__pill--' + (o.financial_tone || 'info') + '">' + escapeHtml(o.financial_label) + '</span>';
    // Items list with thumbs where available
    var itemsHtml = (Array.isArray(o.items) ? o.items : []).slice(0, 6).map(function (it) {
      var img = it.image
        ? '<img src="' + escapeHtml(it.image) + '" alt="" loading="lazy">'
        : fallbackIcon();
      var qty = it.qty && it.qty > 1 ? '<span class="tsv-order__qty">x' + Number(it.qty) + '</span>' : '';
      var priceRow = it.price ? '<div class="tsv-order__price">' + escapeHtml(formatPriceString(it.price)) + '</div>' : '';
      var titleContent = escapeHtml(it.title || 'Item') + (it.variant_title ? ' <span class="tsv-order__variant">' + escapeHtml(it.variant_title) + '</span>' : '');
      var openTag = it.url ? '<a class="tsv-order__item" href="' + escapeHtml(it.url) + '" rel="noopener">' : '<div class="tsv-order__item">';
      var closeTag = it.url ? '</a>' : '</div>';
      return openTag +
        '<div class="tsv-order__thumb">' + img + '</div>' +
        '<div class="tsv-order__meta">' +
          '<div class="tsv-order__title">' + titleContent + qty + '</div>' +
          priceRow +
        '</div>' +
      closeTag;
    }).join('');
    // Tracking + account CTAs
    var actions = '';
    var track = Array.isArray(o.tracking) ? o.tracking[0] : null;
    if (track && track.url) {
      actions += '<a class="tsv-order__cta tsv-order__cta--primary" href="' + escapeHtml(track.url) + '" target="_blank" rel="noopener">' +
        T('cg_track_parcel','Track parcel') + (track.company ? ' with ' + escapeHtml(track.company) : '') +
      '</a>';
    }
    if (o.account_url) {
      actions += '<a class="tsv-order__cta tsv-order__cta--ghost" href="' + escapeHtml(o.account_url) + '" rel="noopener">View order</a>';
    }
    wrap.innerHTML =
      '<div class="tsv-order__head">' +
        '<div class="tsv-order__label">' + escapeHtml(o.name || 'Order') + '</div>' +
        '<div class="tsv-order__metaRow">' + escapeHtml(meta.join(' | ')) + '</div>' +
        (pills ? '<div class="tsv-order__pills">' + pills + '</div>' : '') +
      '</div>' +
      (itemsHtml ? '<div class="tsv-order__items">' + itemsHtml + '</div>' : '') +
      (actions ? '<div class="tsv-order__actions">' + actions + '</div>' : '');
    messagesEl.appendChild(wrap);
    scrollToTopOf(wrap);
  }

  // --- Your past chats (signed-in only) ------------------------------------
  // Lists the customer's saved conversations from previous sessions/devices
  // and lets them reopen one. The entry chip is only emitted for signed-in
  // customers, and the worker also refuses to return anything without a
  // matching customer_id, so anonymous users can never see other chats.
  function handlePastChatsChip(chipText) {
    beforeChipRequest(chipText);
    if (signInPromptIfNeeded()) { afterChipRequest(); saveSnapshot(); return; }
    var c = CFG.customer || {};
    conciergePost('/account/conversations', { customer_id: c.id || null })
      .then(function (data) {
        afterChipRequest();
        var list = (data && data.ok && Array.isArray(data.conversations)) ? data.conversations : [];
        if (!list.length) {
          appendConcierge(T('cg_no_past_chats','No past conversations yet.'), true);
          appendChips([chipT('bestsellers','cg_chip_pick_new','Pick something new for me'), chipT('keep_chatting','cg_chip_keep_chatting','Keep chatting with you')], true);
          saveSnapshotWhenIdle();
          return;
        }
        appendConcierge(T('cg_past_chats_intro','Here are your past chats. Tap one to reopen it.'), true);
        renderPastChatsList(list);
        appendChips([chipT('keep_chatting','cg_chip_keep_chatting','Keep chatting with you')], true);
        saveSnapshotWhenIdle();
      })
      .catch(function () {
        afterChipRequest();
        appendConcierge(T('cg_past_chats_failed', 'I could not load your past chats just now. Please try again shortly.'), true);
        appendChips([chipT('keep_chatting','cg_chip_keep_chatting','Keep chatting with you')], true);
      });
  }

  function renderPastChatsList(conversations) {
    return tsvQueue(function () { return _renderPastChatsListImpl(conversations); });
  }
  function _renderPastChatsListImpl(conversations) {
    var wrap = document.createElement('div');
    wrap.className = 'tsv-msg tsv-msg--concierge tsv-pastchats';
    for (var i = 0; i < conversations.length; i++) {
      var conv = conversations[i];
      if (!conv || !conv.session_id) continue;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tsv-pastchat';
      var titleEl = document.createElement('div');
      titleEl.className = 'tsv-pastchat__title';
      // User content: use textContent, never innerHTML, so titles are safe.
      titleEl.textContent = String(conv.title || 'Conversation');
      var metaEl = document.createElement('div');
      metaEl.className = 'tsv-pastchat__meta';
      metaEl.textContent = tsvPastChatMeta(conv);
      btn.appendChild(titleEl);
      btn.appendChild(metaEl);
      (function (sid) {
        btn.addEventListener('click', function () { openPastConversation(sid); });
      })(conv.session_id);
      wrap.appendChild(btn);
    }
    messagesEl.appendChild(wrap);
    scrollToTopOf(wrap);
  }

  function tsvPastChatMeta(conv) {
    var parts = [];
    var when = tsvShortWhen(conv.last_message_at || conv.started_at);
    if (when) parts.push(when);
    var n = Number(conv.message_count || 0);
    if (n > 0) parts.push(n + (n === 1 ? ' message' : ' messages'));
    return parts.join(' | ');
  }

  function tsvShortWhen(ts) {
    var n = Number(ts);
    if (!n) return '';
    // Stored as unix seconds; guard against milliseconds just in case.
    var ms = n < 1e12 ? n * 1000 : n;
    var d = new Date(ms);
    if (isNaN(d.getTime())) return '';
    var diff = Math.floor((Date.now() - ms) / 1000);
    if (diff < 60) return 'just now';
    if (diff < 3600) { var mm = Math.floor(diff / 60); return mm + (mm === 1 ? T('cg_min_ago',' min ago') : T('cg_mins_ago',' mins ago')); }
    if (diff < 86400) { var hh = Math.floor(diff / 3600); return hh + (hh === 1 ? ' hr ago' : T('cg_hrs_ago',' hrs ago')); }
    if (diff < 604800) { var dd = Math.floor(diff / 86400); return dd + (dd === 1 ? T('cg_day_ago',' day ago') : T('cg_days_ago',' days ago')); }
    return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
  }

  function openPastConversation(sessionIdToOpen) {
    var c = CFG.customer || {};
    appendTyping();
    conciergePost('/account/conversation', { customer_id: c.id || null, session_id: sessionIdToOpen })
      .then(function (data) {
        removeTyping();
        if (!data || !data.ok || !Array.isArray(data.messages) || !data.messages.length) {
          appendConcierge(T('cg_reopen_failed', 'I could not reopen that conversation. Please try another.'), true);
          appendChips([chipT('keep_chatting','cg_chip_keep_chatting','Keep chatting with you')], true);
          return;
        }
        appendPastConversationSeparator();
        // Reuse the exact renderer the widget uses for /history results.
        replayHistory(data.messages);
        appendChips([chipT('keep_chatting','cg_chip_keep_chatting','Keep chatting with you')], true);
        saveSnapshotWhenIdle();
      })
      .catch(function () {
        removeTyping();
        appendConcierge(T('cg_reopen_failed_retry', 'I could not reopen that conversation just now. Please try again shortly.'), true);
        appendChips([chipT('keep_chatting','cg_chip_keep_chatting','Keep chatting with you')], true);
      });
  }

  function appendPastConversationSeparator() {
    var sep = document.createElement('div');
    sep.className = 'tsv-msg tsv-msg--concierge tsv-pastchat-sep';
    sep.textContent = T('cg_viewing_past','Viewing a past conversation');
    messagesEl.appendChild(sep);
    scrollToTopOf(sep);
  }

  // --- My points balance ---------------------------------------------------
  function handleLoyaltyChip(chipText) {
    beforeChipRequest(chipText);
    if (signInPromptIfNeeded()) { afterChipRequest(); saveSnapshot(); return; }
    conciergePost('/loyalty', customerPayload())
      .then(function (data) {
        afterChipRequest();
        if (!data || !data.ok) {
          appendConcierge(T('cg_loyalty_failed', 'I could not reach your loyalty balance just now. Please try again shortly.'), true);
          appendChips([chipT('latest_order','cg_chip_latest_order','My latest order'), chipT('bestsellers','cg_chip_pick_new','Pick something new for me'), T('cg_speak_to_team','Speak to the team')], true);
          saveSnapshotWhenIdle();
          return;
        }
        // Warm typing intro before the Vault card mounts, matching the
        // uniform "text types, then card slides in" feel used elsewhere.
        var loyFirst = (CFG.customer && CFG.customer.first_name) ? CFG.customer.first_name : '';
        var loyIntro = (loyFirst ? (T('cg_vault_intro_named', 'Here is your Member’s Vault, ') + loyFirst + '. ') : T('cg_vault_intro', 'Here is your Member’s Vault. '))
          + T('cg_vault_tier_line', 'Your current tier, live points balance, and every reward you can claim right now are all below.');
        appendConcierge(loyIntro, true);
        renderLoyalty(data);
        appendChips([chipT('latest_order','cg_chip_latest_order','My latest order'), chipT('bestsellers','cg_chip_pick_new','Pick something new for me')], true);
        saveSnapshotWhenIdle();
      })
      .catch(function () {
        afterChipRequest();
        submitDirect(chipText);
      });
  }
  function renderLoyalty(d) {
    return tsvQueue(function () { return _renderLoyaltyImpl(d); });
  }
  function _renderLoyaltyImpl(d) {
    var wrap = document.createElement('div');
    wrap.className = 'tsv-msg tsv-msg--concierge tsv-vault';
    // The API sometimes returns tier as "Member" and sometimes as
    // "Member Member" already. Normalise: strip a trailing "member"
    // (case-insensitive) so we can safely append " member" below.
    var tierRaw = String(d.tier || 'Member').trim();
    tierRaw = tierRaw.replace(/\s+member\s*$/i, '').trim();
    if (!tierRaw) tierRaw = 'Member';
    var tier = escapeHtml(tierRaw);
    var balance = Number(d.balance || 0);
    var nextAt = Number(d.next_reward_at || 0);
    var toNext = Number(d.points_to_next || (nextAt > balance ? nextAt - balance : 0));
    var nextVal = d.next_reward_value ? escapeHtml(String(d.next_reward_value)) : '';
    var tierNextName = d.tier_next ? escapeHtml(String(d.tier_next)) : '';
    var tierNextAt = Number(d.tier_next_at || 0);
    var tierPct = Number(d.tier_progress_pct || 0);
    // Rewards list.
    var rewards = Array.isArray(d.available_rewards) ? d.available_rewards : [];
    var readyList = rewards.filter(function (r) { return !r.threshold || balance >= Number(r.threshold); });
    var comingList = rewards.filter(function (r) { return r.threshold && balance < Number(r.threshold); });
    var rewardsReadyHtml = readyList.length
      ? readyList.slice(0, 6).map(function (r) {
          var label = escapeHtml(r.label || 'Reward');
          var val = r.value ? escapeHtml(formatPriceString(String(r.value))) : '';
          var code = r.code ? '<div class="tsv-vault__code">' + escapeHtml(r.code) + '</div>' : '';
          return '<div class="tsv-vault__reward tsv-vault__reward--ready">' +
            '<div class="tsv-vault__rewardTitle">' + label + '</div>' +
            (val ? '<div class="tsv-vault__rewardValue">Worth ' + val + '</div>' : '') +
            code +
          '</div>';
        }).join('')
      : '';
    var rewardsComingHtml = comingList.length
      ? comingList.slice(0, 4).map(function (r) {
          var label = escapeHtml(r.label || 'Reward');
          var val = r.value ? escapeHtml(formatPriceString(String(r.value))) : '';
          var need = Number(r.threshold) - balance;
          return '<div class="tsv-vault__reward tsv-vault__reward--coming">' +
            '<div class="tsv-vault__rewardTitle">' + label + (val ? ' <span class="tsv-vault__rewardValue">(' + val + ')</span>' : '') + '</div>' +
            '<div class="tsv-vault__rewardMeta">' + Number(need).toLocaleString() + ' points away</div>' +
          '</div>';
        }).join('')
      : '';
    // Recent ledger.
    var ledger = Array.isArray(d.recent_ledger) ? d.recent_ledger.slice(0, 3) : [];
    var ledgerHtml = ledger.length
      ? '<div class="tsv-vault__section">' +
          '<div class="tsv-vault__sectionLabel">Recent activity</div>' +
          ledger.map(function (l) {
            var delta = Number(l.delta || 0);
            var sign = delta >= 0 ? '+' : '';
            var reason = escapeHtml(l.reason || 'Activity');
            var when = l.at ? (new Date(l.at)).toLocaleDateString(undefined, { day: 'numeric', month: 'short' }) : '';
            return '<div class="tsv-vault__ledgerRow">' +
              '<span class="tsv-vault__ledgerReason">' + reason + '</span>' +
              '<span class="tsv-vault__ledgerDelta ' + (delta >= 0 ? 'is-plus' : 'is-minus') + '">' + sign + Number(delta).toLocaleString() + '</span>' +
              (when ? '<span class="tsv-vault__ledgerWhen">' + escapeHtml(when) + '</span>' : '') +
            '</div>';
          }).join('') +
        '</div>'
      : '';
    // Header hero: tier badge + balance.
    var progressBar = (tierNextName && tierPct !== null && tierPct >= 0)
      ? '<div class="tsv-vault__progress"><div class="tsv-vault__progressFill" style="width:' + Math.max(0, Math.min(100, tierPct)) + '%"></div></div>' +
        '<div class="tsv-vault__progressLabel">' + Math.max(0, Number(tierNextAt) - balance).toLocaleString() + T('cg_points_to',' points to ') + tierNextName + '</div>'
      : '';
    var nextRewardLine = (toNext > 0 && nextVal)
      ? '<div class="tsv-vault__section"><div class="tsv-vault__sectionLabel">Next reward</div><div class="tsv-vault__next">' + Number(toNext).toLocaleString() + T('cg_points_away_from', ' points away from your next ') + nextVal + ' reward.</div></div>'
      : '';
    wrap.innerHTML =
      '<div class="tsv-vault__hero">' +
        '<div class="tsv-vault__tier">' + tier + ' member</div>' +
        '<div class="tsv-vault__balance">' + balance.toLocaleString() + '<span class="tsv-vault__balanceUnit">points</span></div>' +
        progressBar +
      '</div>' +
      nextRewardLine +
      (rewardsReadyHtml ? '<div class="tsv-vault__section"><div class="tsv-vault__sectionLabel">Ready to redeem</div><div class="tsv-vault__rewards">' + rewardsReadyHtml + '</div></div>' : '') +
      (rewardsComingHtml ? '<div class="tsv-vault__section"><div class="tsv-vault__sectionLabel">Coming up</div><div class="tsv-vault__rewards">' + rewardsComingHtml + '</div></div>' : '') +
      ledgerHtml +
      '<div class="tsv-vault__actions">' +
        '<a class="tsv-order__cta tsv-order__cta--primary" href="/account" rel="noopener">Open Member’s Vault</a>' +
      '</div>';

    // Feature 33: tier upgrade nudge. Shown when the customer is close to
    // the next tier (>= 60% along OR fewer than 500 points to go).
    if (tsvFeatOn('vaultTierNudge') && tierNextName && tierNextAt > balance) {
      var gap = Math.max(0, Number(tierNextAt) - balance);
      var close = (tierPct >= 60) || (gap <= 500);
      if (close) {
        var nudge = document.createElement('div');
        nudge.className = 'tsv-vault__nudge';
        nudge.innerHTML =
          '<div class="tsv-vault__nudgeTitle">You are close to ' + escapeHtml(String(tierNextName)) + '</div>' +
          '<div>Just ' + gap.toLocaleString() + ' points away. Here are two picks that would get you there.</div>' +
          '<button type="button" class="tsv-vault__nudgeBtn">Show me picks to unlock ' + escapeHtml(String(tierNextName)) + '</button>';
        var nudgeBtn = nudge.querySelector('.tsv-vault__nudgeBtn');
        if (nudgeBtn) {
          nudgeBtn.addEventListener('click', function () {
            var euroTarget = Math.max(30, Math.ceil(gap / 1));
            var msg = T('cg_q_two_picks_around','Show me two picks around EUR ') + euroTarget + T('cg_q_that_would_take_me',' that would take me to ') + tierNextName;
            appendUser(T('cg_q_picks_to_unlock','Show me picks to unlock ') + tierNextName);
            submitDirect(msg);
          });
        }
        wrap.appendChild(nudge);
      }
    }

    messagesEl.appendChild(wrap);
    scrollToTopOf(wrap);
  }

  // --- Similar to X --------------------------------------------------------
  // Compound flow for "similar to my last order". Fetches the most
  // recent order, extracts the primary fragrance name from its line
  // items, then runs /similar against it so the customer sees real
  // product cards without waiting for the AI to guess. Requires the
  // customer to be signed in (call site guards this).
  function handleSimilarToLastOrder(chipText) {
    beforeChipRequest(chipText);
    var payload = customerPayload();
    payload.limit = 1;
    conciergePost('/order-lookup', payload)
      .then(function (orderData) {
        if (!orderData || !orderData.ok || !Array.isArray(orderData.orders) || !orderData.orders.length) {
          afterChipRequest();
          appendConcierge(T('cg_no_order_to_base_on', 'I could not find a recent order to base this on. Try describing a fragrance you like and I will match from there.'), true);
          appendChips([chipT('bestsellers','cg_chip_pick_new','Pick something new for me'), chipT('on_sale','cg_chip_on_sale','What is on sale this week')], true);
          saveSnapshotWhenIdle();
          return;
        }
        // First order is most recent. Its first line item is the
        // primary fragrance to anchor recommendations to.
        var order = orderData.orders[0];
        var firstItem = (order.items && order.items.length) ? order.items[0] : null;
        if (!firstItem || !firstItem.title) {
          afterChipRequest();
          appendConcierge(T('cg_order_name_unreadable', 'I found your last order but could not read the fragrance name from it. Try describing a fragrance you like and I will match from there.'), true);
          saveSnapshotWhenIdle();
          return;
        }
        // Now fire /similar with the fragrance title.
        var simBody = customerPayload();
        simBody.reference = firstItem.title;
        simBody.limit = 4;
        conciergePost('/similar', simBody)
          .then(function (sim) {
            afterChipRequest();
            if (!sim || !sim.ok || !Array.isArray(sim.products) || !sim.products.length) {
              appendConcierge(T('cg_you_picked_up','You picked up ') + firstItem.title + ' last time. I could not find close matches in stock right now. Tell me what you loved about it and I will keep looking.', true);
              appendChips([chipT('bestsellers','cg_chip_pick_new','Pick something new for me'), chipT('on_sale','cg_chip_on_sale','What is on sale this week')], true);
              saveSnapshotWhenIdle();
              return;
            }
            appendConcierge(T('cg_based_on','Based on ') + firstItem.title + ' from your last order, here are the closest matches we have in stock right now.', true);
            appendProducts(sim.products);
            appendChips([chipT('bestsellers','cg_chip_pick_new','Pick something new for me'), chipT('on_sale','cg_chip_on_sale','What is on sale this week')], true);
            saveSnapshotWhenIdle();
          })
          .catch(function () {
            afterChipRequest();
            submitDirect(chipText);
          });
      })
      .catch(function () {
        afterChipRequest();
        submitDirect(chipText);
      });
  }

  // Feature 27: Fragrance twin finder — same shape as handleSimilarChip
  // but with a max_price ceiling. Falls back to text-search via
  // submitDirect if the /similar endpoint has no matches under budget.
  function handleFragranceTwin(chipText, reference, maxPrice) {
    beforeChipRequest(chipText);
    var body = customerPayload();
    body.reference = String(reference || '').trim();
    body.limit = 6;
    body.max_price = maxPrice;
    conciergePost('/similar', body)
      .then(function (data) {
        if (!data || !data.ok || !Array.isArray(data.products) || !data.products.length) {
          afterChipRequest();
          submitDirect(chipText);
          return;
        }
        // Client-side price ceiling in case the server ignored it.
        var priceCap = Number(maxPrice) || 0;
        var withinBudget = priceCap ? data.products.filter(function (p) {
          var priceNum = parseFloat(String(p.price || '').replace(/[^0-9.,]/g, '').replace(',', '.')) || 0;
          return priceNum > 0 && priceNum <= priceCap;
        }) : data.products;
        if (!withinBudget.length) {
          afterChipRequest();
          appendConcierge(T('cg_no_match_to','I could not find a match to ') + reference + T('cg_under_eur',' under EUR ') + priceCap + T('cg_closest_overall',' right now. Here is the closest we stock overall.'), true);
          appendProducts(data.products.slice(0, 4));
          appendChips([chipT('bestsellers','cg_chip_pick_new','Pick something new for me'), chipT('on_sale','cg_chip_on_sale','What is on sale this week')], true);
          saveSnapshotWhenIdle();
          return;
        }
        afterChipRequest();
        var refLabel = data.reference && data.reference.title
          ? (data.reference.vendor ? data.reference.vendor + ' ' : '') + data.reference.title
          : body.reference;
        appendConcierge(T('cg_closest_twins_to','Closest twins to ') + refLabel + T('cg_in_stock_under_eur',' we have in stock under EUR ') + priceCap + '.', true);
        appendProducts(withinBudget.slice(0, 4));
        appendChips([T('cg_chip_pricier',chipT('','cg_chip_pricier','Show me the pricier options')), chipT('bestsellers','cg_chip_pick_new','Pick something new for me')], true);
        saveSnapshotWhenIdle();
      })
      .catch(function () {
        afterChipRequest();
        submitDirect(chipText);
      });
  }

  function handleSimilarChip(chipText, referenceOverride) {
    beforeChipRequest(chipText);
    var body = customerPayload();
    body.reference = referenceOverride
      || String(chipText).replace(/^similar to\s+/i, '').trim();
    body.limit = 4;
    conciergePost('/similar', body)
      .then(function (data) {
        if (!data || !data.ok || !Array.isArray(data.products) || !data.products.length) {
          afterChipRequest();
          submitDirect(chipText);
          return;
        }
        afterChipRequest();
        var refLabel = data.reference && data.reference.title
          ? (data.reference.vendor ? data.reference.vendor + ' ' : '') + data.reference.title
          : body.reference;
        appendConcierge(T('cg_closest_matches_to','Closest matches to ') + refLabel + T('cg_from_what_we_stock',' from what we stock right now.'), true);
        appendProducts(data.products);
        appendChips([chipT('bestsellers','cg_chip_pick_new','Pick something new for me'), chipT('on_sale','cg_chip_on_sale','What is on sale this week')], true);
        saveSnapshotWhenIdle();
      })
      .catch(function () {
        afterChipRequest();
        submitDirect(chipText);
      });
  }

  // --- Compare A and B -----------------------------------------------------
  // Route comparison queries through /chat so the worker handles them with
  // proper SSE streaming and message ordering (text → products with compare
  // layout → chips). The /compare endpoint returns a different JSON structure
  // that renderResponse can't handle. Let /chat handle comparison detection.
  function handleCompareChip(chipText, items) {
    removeChips();
    appendUser(chipText);
    submitDirect(chipText);
  }
  function parseCompareItems(text) {
    var t = String(text || '').replace(/^compare\s+/i, '').trim();
    // Split on " vs ", " and ", " with ", " to " or comma / ampersand.
    return t.split(/\s+(?:vs\.?|and|with|to)\s+|\s*[,&]\s*/i)
            .map(function (p) { return p.trim(); })
            .filter(Boolean)
            .slice(0, 3);
  }
  function renderCompare(data) {
    // Phase 2 #11: rich side-by-side comparison card. Product cards up
    // top (customer can still ATB from them), then a visual attribute
    // grid that puts each product in its own column with each attribute
    // as a row, so differences are instantly scannable.
    var products = data.products || [];
    var names = products.map(function (p) {
      return (p.vendor ? p.vendor + ' ' : '') + p.title;
    });
    appendConcierge(T('cg_here_side_by_side','Here they are side by side.'), true);
    // Keep the buyable cards so the customer can add to bag from either.
    appendProducts(products);
    var rows = Array.isArray(data.comparison) ? data.comparison : [];
    if (!products.length || !rows.length) return;
    // Colours: header ivory, body warm; borders soft. Uses inline styles
    // so the block ships even when the customer's theme hasn't loaded
    // the compare-specific CSS yet.
    var colWidth = (100 / products.length).toFixed(2) + '%';
    var thStyle = 'text-align:left;padding:8px 10px;font-size:10px;letter-spacing:1.6px;text-transform:uppercase;color:#c9b37f;border-bottom:1px solid rgba(201,179,127,0.35);background:rgba(20,28,40,0.85)';
    var tdLabel = 'text-align:left;padding:8px 10px;font-size:11px;letter-spacing:1px;text-transform:uppercase;color:#8a94a3;background:rgba(20,28,40,0.5);border-bottom:1px solid rgba(255,255,255,0.06);vertical-align:top;width:80px';
    var tdVal   = 'padding:8px 10px;font-size:13px;line-height:1.45;color:#e5e1d8;border-bottom:1px solid rgba(255,255,255,0.06);vertical-align:top';
    var header = '<tr><th style="' + tdLabel + ';color:#c9b37f;background:rgba(20,28,40,0.85);border-bottom:1px solid rgba(201,179,127,0.35);text-transform:uppercase;letter-spacing:1.4px;font-size:10px">Attribute</th>';
    products.forEach(function (p, i) {
      var vendor = p.vendor ? '<div style="font-size:10px;letter-spacing:1.4px;text-transform:uppercase;color:#c9b37f;margin-bottom:2px">' + escapeHtml(p.vendor) + '</div>' : '';
      var title  = '<div style="font-size:12px;line-height:1.3;color:#f3eee4;font-weight:500">' + escapeHtml(p.title || '') + '</div>';
      header += '<th style="' + thStyle + ';width:' + colWidth + '">' + vendor + title + '</th>';
    });
    header += '</tr>';
    var bodyRows = rows.map(function (row) {
      var vals = (row.values || []).map(function (v) {
        var val = (v == null || v === '') ? '&mdash;' : escapeHtml(String(v));
        return '<td style="' + tdVal + '">' + val + '</td>';
      }).join('');
      return '<tr><td style="' + tdLabel + '">' + escapeHtml(row.label || '') + '</td>' + vals + '</tr>';
    }).join('');
    var block = document.createElement('div');
    block.className = 'tsv-compare-grid';
    block.style.cssText = 'margin:12px 0;border:1px solid rgba(201,179,127,0.25);border-radius:10px;overflow:hidden;background:rgba(15,23,32,0.75);box-shadow:0 2px 12px rgba(0,0,0,0.2)';
    block.innerHTML = '<div style="padding:10px 14px;background:linear-gradient(90deg,rgba(201,179,127,0.16),rgba(201,179,127,0.06));border-bottom:1px solid rgba(201,179,127,0.3);font-size:10px;letter-spacing:1.8px;text-transform:uppercase;color:#c9b37f;font-weight:600">Side by side</div>' +
      '<div style="overflow-x:auto"><table style="width:100%;border-collapse:collapse;font-family:inherit"><thead>' + header + '</thead><tbody>' + bodyRows + '</tbody></table></div>';
    if (messagesEl) messagesEl.appendChild(block);
  }

  // --- Pick something new / What is on sale --------------------------------
  function handleBestsellersChip(chipText, opts) {
    beforeChipRequest(chipText);
    var body = customerPayload();
    body.limit = 4;
    if (opts && opts.on_sale) body.on_sale = true;
    conciergePost('/bestsellers', body)
      .then(function (data) {
        // No products (endpoint missing, 404, empty result, or malformed).
        // Silently forward the chip text to /chat so the AI answers instead
        // of dropping the user on a dead end.
        if (!data || !data.ok || !Array.isArray(data.products) || !data.products.length) {
          afterChipRequest();
          submitDirect(chipText);
          return;
        }
        afterChipRequest();
        var intro = opts && opts.on_sale
          ? T('cg_sale_loved_this_week','A few pieces on sale that people are loving this week.')
          : T('cg_shortlist_intro', 'A shortlist to explore, chosen from what our members keep coming back to.');
        appendConcierge(intro, true);
        appendProducts(data.products);
        appendChips([chipT('latest_order','cg_chip_latest_order','My latest order'), chipT('points','cg_chip_points','My points balance')], true);
        saveSnapshotWhenIdle();
      })
      .catch(function () {
        // Network error or endpoint totally unavailable. Fall back to /chat.
        afterChipRequest();
        submitDirect(chipText);
      });
  }

  // Inline contact form. Renders the form directly inside the chat with the
  // customer's known email pre-filled. Submits to the /escalate worker
  // endpoint which logs to D1 + emails the team + confirms the customer.
  function showContactForm(chipText, prefill) {
    if (chipText) { removeChips(); appendUser(chipText); }
    var existing = messagesEl.querySelector('.tsv-contact');
    if (existing) { existing.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    var c = CFG.customer || {};
    var name = [c.first_name, c.last_name].filter(Boolean).join(' ').trim();
    var pf = prefill || {};
    // Must stay identical to the contact page form so both feed the same
    // reporting categories in the super admin ticket filters.
    var reasons = [T('cg_order_issue','Order issue'), T('cg_product_question','Product question'), 'Returns & exchanges', 'Wholesale', 'Press', 'Other'];
    var reasonOpts = reasons.map(function (r) {
      var sel = (pf.reason && String(pf.reason).toLowerCase() === r.toLowerCase()) ? ' selected' : '';
      return '<option value="' + escapeHtml(r) + '"' + sel + '>' + escapeHtml(r) + '</option>';
    }).join('');
    var wrap = document.createElement('div');
    wrap.className = 'tsv-contact';
    wrap.innerHTML =
      '<div class="tsv-contact__title">Message the team</div>' +
      '<div class="tsv-contact__sub">We answer most queries within 24 hours.</div>' +
      '<form class="tsv-contact__form" autocomplete="on">' +
        '<label class="tsv-contact__field">' +
          '<span>Name</span>' +
          '<input type="text" name="name" value="' + escapeHtml(name) + '" required maxlength="120" autocomplete="name">' +
        '</label>' +
        '<label class="tsv-contact__field">' +
          '<span>Email</span>' +
          '<input type="email" name="email" value="' + escapeHtml(c.email || '') + '" required maxlength="200" autocomplete="email">' +
        '</label>' +
        '<label class="tsv-contact__field">' +
          '<span>Reason</span>' +
          '<select name="reason">' +
            '<option value="">Choose a reason (optional)</option>' +
            reasonOpts +
          '</select>' +
        '</label>' +
        '<label class="tsv-contact__field tsv-contact__field--order">' +
          '<span>Order number <em>optional</em></span>' +
          '<select name="order_number_select" class="tsv-contact__orderSelect">' +
            '<option value="">Select or leave blank</option>' +
            '<option value="__manual__">Type it manually</option>' +
          '</select>' +
          '<input type="text" name="order_number" value="' + escapeHtml(pf.order_number || '') + '" placeholder="Like TSV1234 or 551181" maxlength="40" hidden>' +
        '</label>' +
        '<label class="tsv-contact__field">' +
          '<span>Message</span>' +
          '<textarea name="message" rows="4" required maxlength="4000" placeholder="Tell us the detail and we will get back to you.">' + escapeHtml(pf.message || '') + '</textarea>' +
        '</label>' +
        ((c && (c.email || c.id)) ? '' :
          '<label class="tsv-contact__check"><input type="checkbox" name="subscribe"><span>Email me new arrivals and offers</span></label>') +
        '<button type="submit" class="tsv-contact__submit">Send message</button>' +
        '<div class="tsv-contact__error" hidden></div>' +
      '</form>';
    messagesEl.appendChild(wrap);
    scrollBottom();
    var formEl = wrap.querySelector('form');
    var errEl = wrap.querySelector('.tsv-contact__error');
    var btn = wrap.querySelector('.tsv-contact__submit');
    var orderSelect = formEl.querySelector('select[name="order_number_select"]');
    var orderInput = formEl.querySelector('input[name="order_number"]');
    // Populate the order dropdown from the customer's recent orders. Anonymous
    // customers skip this and just see the manual-entry path.
    (function populateOrderOptions() {
      var cc = CFG.customer || {};
      if (!cc.email && !cc.id) {
        // Not signed in: show only the manual-entry option.
        orderSelect.value = '__manual__';
        orderSelect.style.display = 'none';
        orderInput.hidden = false;
        return;
      }
      var body = customerPayload();
      body.limit = 15;
      conciergePost('/order-lookup', body)
        .then(function (data) {
          if (!data || !data.ok || !Array.isArray(data.orders) || !data.orders.length) return;
          data.orders.forEach(function (o) {
            if (!o || !o.name) return;
            var when = o.created_at ? new Date(o.created_at) : null;
            var whenStr = when && !isNaN(when.getTime())
              ? when.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })
              : '';
            var totalStr = o.total ? ' - ' + o.total : '';
            var label = o.name + (whenStr ? ' (' + whenStr + ')' : '') + totalStr;
            var opt = document.createElement('option');
            opt.value = String(o.name).replace(/^#/, '');
            opt.textContent = label;
            // Insert before the __manual__ option so it stays at the bottom.
            var manualOpt = orderSelect.querySelector('option[value="__manual__"]');
            if (manualOpt) orderSelect.insertBefore(opt, manualOpt);
            else orderSelect.appendChild(opt);
          });
          // If prefill has an order number that matches, select it.
          if (pf.order_number) {
            var target = String(pf.order_number).replace(/^#/, '');
            var opts = orderSelect.querySelectorAll('option');
            for (var i = 0; i < opts.length; i++) {
              if (opts[i].value === target) { orderSelect.value = target; break; }
            }
          }
        })
        .catch(function () {});
    })();
    orderSelect.addEventListener('change', function () {
      if (orderSelect.value === '__manual__') {
        orderInput.hidden = false;
        orderInput.value = '';
        setTimeout(function () { orderInput.focus(); }, 50);
      } else {
        orderInput.hidden = true;
        orderInput.value = orderSelect.value || '';
      }
    });
    function showContactSuccess(payload) {
      // Give a brief "Sent" flash on the button, then swap in the confirmation.
      try {
        btn.classList.remove('is-loading');
        btn.textContent = 'Sent';
        btn.classList.add('tsv-contact__submit--sent');
      } catch (_) {}
      setTimeout(function () {
        try {
          wrap.classList.add('tsv-contact--done');
          // Lightweight confirmation: single green ribbon + one line pointing
          // at the customer's inbox. The full detail is already in the email.
          wrap.innerHTML =
            '<div class="tsv-contact__doneRibbon">' +
              '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12l5 5L20 6"/></svg>' +
              '<span>Message sent. Confirmation in your inbox.</span>' +
            '</div>';
          saveSnapshotWhenIdle();
          // Make sure the customer actually sees the confirmation card even if
          // they had scrolled away from it while typing.
          try {
            wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(function () { scrollBottom(); }, 400);
          } catch (_) { scrollBottom(); }
        } catch (renderErr) {
          try { console.error('[tsv-concierge] success render failed', renderErr); } catch (_) {}
          try { wrap.parentNode && wrap.parentNode.removeChild(wrap); } catch (_) {}
          appendConcierge(T('cg_message_sent_to','Message sent. A confirmation is on the way to ') + payload.email + '. The team will reply within 24 hours.', true);
          saveSnapshotWhenIdle();
        }
      }, 900);
    }
    function showContactError(msg) {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.textContent = btn.dataset.origLabel || T('cg_send_message','Send message');
      errEl.hidden = false; errEl.textContent = msg || 'Could not send. Please try again or email help@thescentvault.ie.';
      try { errEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (_) {}
    }
    formEl.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var reasonSel = formEl.querySelector('select[name="reason"]');
      var chosenOrder = '';
      if (orderSelect && orderSelect.value && orderSelect.value !== '__manual__') {
        chosenOrder = orderSelect.value;
      } else if (orderInput && !orderInput.hidden) {
        chosenOrder = orderInput.value.trim();
      }
      var payload = {
        session_id: sessionId,
        name: formEl.querySelector('input[name="name"]').value.trim(),
        email: formEl.querySelector('input[name="email"]').value.trim(),
        reason: reasonSel ? reasonSel.value.trim() : '',
        order_number: chosenOrder,
        message: formEl.querySelector('textarea[name="message"]').value.trim(),
        page_url: window.location.href,
        customer_id: (c.id || null),
        subscribe: (function () { var s = formEl.querySelector('input[name="subscribe"]'); return !!(s && s.checked); })()
      };
      if (!payload.name || !payload.email || !payload.message) {
        showContactError(T('cg_form_required','Name, email and message are all required.'));
        return;
      }
      errEl.hidden = true;
      btn.disabled = true;
      btn.classList.add('is-loading');
      // The original label is preserved so we can put it back on error.
      var origLabel = btn.dataset.origLabel || btn.textContent;
      btn.dataset.origLabel = origLabel;
      btn.innerHTML = '<span class="tsv-contact__spinner" aria-hidden="true"></span> Sending...';
      // 15s hard timeout so a stalled fetch never leaves the button spinning.
      var settled = false;
      var timeoutId = setTimeout(function () {
        if (settled) return;
        settled = true;
        console.warn('[tsv-concierge] escalate timed out after 15s');
        showContactError('That is taking too long. Please try again or email help@thescentvault.ie.');
      }, 15000);
      conciergePost('/escalate', payload)
        .then(function (r) {
          if (settled) return;
          settled = true;
          clearTimeout(timeoutId);
          if (r && r.ok) {
            showContactSuccess(payload);
          } else {
            var reason = (r && (r.message || r.error)) ? String(r.message || r.error) : T('cg_could_not_send','Could not send just now.');
            try { console.warn('[tsv-concierge] escalate failed', r); } catch (_) {}
            showContactError(T('cg_could_not_send_prefix','Could not send: ') + reason + '. Try again or email help@thescentvault.ie.');
          }
        })
        .catch(function (err) {
          if (settled) return;
          settled = true;
          clearTimeout(timeoutId);
          try { console.error('[tsv-concierge] escalate error', err); } catch (_) {}
          showContactError(T('cg_network_or_email','Network issue. Try again in a moment or email help@thescentvault.ie.'));
        });
    });
    setTimeout(function () {
      var target = wrap.querySelector('textarea[name="message"]');
      if (target && !name && !c.email) target = wrap.querySelector('input[name="name"]');
      if (target) target.focus();
    }, 120);
  }

  // Track your order. Fetches recent orders and either:
  //  a) 0 orders  -> friendly nudge
  //  b) 1 order   -> render tracking pill directly
  //  c) many      -> render an order picker; on select, render tracking
  function handleTrackChip(chipText) {
    beforeChipRequest(chipText);
    if (signInPromptIfNeeded()) { afterChipRequest(); saveSnapshot(); return; }
    var body = customerPayload();
    body.limit = 5;
    conciergePost('/order-lookup', body)
      .then(function (data) {
        afterChipRequest();
        if (!data || !data.ok || !Array.isArray(data.orders) || !data.orders.length) {
          appendConcierge(T('cg_no_orders_guest', 'I do not see any recent orders on your account. If you ordered as a guest, use the tracking link in your confirmation email.'), true);
          appendChips([chipT('bestsellers','cg_chip_pick_new','Pick something new for me'), chipT('points','cg_chip_points','My points balance'), T('cg_speak_to_team','Speak to the team')], true);
          saveSnapshotWhenIdle();
          return;
        }
        var trackable = data.orders.filter(function (o) { return Array.isArray(o.tracking) && o.tracking.length; });
        if (trackable.length === 1) {
          // Warm typing intro before the tracking card mounts.
          appendConcierge(T('cg_tracking_intro', 'Here is your tracking. The latest carrier update, expected delivery window, and a link to follow the parcel in real time are all in the card below.'), true);
          renderTrackingCard(trackable[0]);
        } else if (trackable.length > 1) {
          appendConcierge(T('cg_you_have','You have ') + trackable.length + T('cg_orders_with_tracking',' orders with tracking. Pick one.'), true);
          renderOrderPickerForTracking(trackable);
        } else {
          appendConcierge(T('cg_no_tracking_yet', 'Your most recent order does not have tracking yet. It usually appears once the parcel is picked up by the carrier.'), true);
          renderOrder(data.orders[0]);
        }
        appendChips([chipT('latest_order','cg_chip_latest_order','My latest order'), T('cg_speak_to_team','Speak to the team')], true);
        saveSnapshotWhenIdle();
      })
      .catch(function () {
        afterChipRequest();
        appendConcierge(T('cg_orders_fetch_failed', 'I could not pull your orders just now. Please try again shortly.'), true);
      });
  }
  function renderTrackingCard(o) {
    return tsvQueue(function () { return _renderTrackingCardImpl(o); });
  }
  function _renderTrackingCardImpl(o) {
    if (!o) return;
    var t = (Array.isArray(o.tracking) && o.tracking[0]) || null;
    var wrap = document.createElement('div');
    wrap.className = 'tsv-msg tsv-msg--concierge tsv-track';
    var carrier = (t && t.company) ? escapeHtml(t.company) : 'Carrier';
    var number = (t && t.number) ? escapeHtml(t.number) : '';
    var url = (t && t.url) ? escapeHtml(t.url) : '';
    wrap.innerHTML =
      '<div class="tsv-track__label">Tracking for ' + escapeHtml(o.name || 'your order') + '</div>' +
      '<div class="tsv-track__carrier">' + carrier + '</div>' +
      (number ? '<div class="tsv-track__number">' + number + '</div>' : '') +
      '<div class="tsv-track__actions">' +
        (url ? '<a class="tsv-order__cta tsv-order__cta--primary" href="' + url + '" target="_blank" rel="noopener">Open tracking</a>' : '') +
        (o.account_url ? '<a class="tsv-order__cta tsv-order__cta--ghost" href="' + escapeHtml(o.account_url) + '" rel="noopener">View order</a>' : '') +
      '</div>';
    messagesEl.appendChild(wrap);
    scrollToTopOf(wrap);
  }
  function renderOrderPickerForTracking(orders) {
    var wrap = document.createElement('div');
    wrap.className = 'tsv-msg tsv-msg--concierge tsv-picker';
    wrap.innerHTML = orders.slice(0, 5).map(function (o, idx) {
      var t = (o.tracking && o.tracking[0]) || {};
      var when = o.created_at ? (new Date(o.created_at)).toLocaleDateString(undefined, { day: 'numeric', month: 'short' }) : '';
      var carrier = t.company ? escapeHtml(t.company) : 'Carrier';
      return '<button type="button" class="tsv-picker__row" data-idx="' + idx + '">' +
        '<div class="tsv-picker__name">' + escapeHtml(o.name || 'Order') + '</div>' +
        '<div class="tsv-picker__meta">' + escapeHtml(when) + ' | ' + carrier + '</div>' +
      '</button>';
    }).join('');
    messagesEl.appendChild(wrap);
    scrollBottom();
    wrap.querySelectorAll('.tsv-picker__row').forEach(function (row) {
      row.addEventListener('click', function () {
        var idx = Number(row.getAttribute('data-idx'));
        renderTrackingCard(orders[idx]);
      });
    });
  }

  function addToCart(variantId, btn) {
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-icon-bubble,cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart add failed');
        return res.json();
      })
      .then(function (data) {
        if (data && data.sections && data.sections['cart-icon-bubble']) {
          var iconEl = document.getElementById('cart-icon-bubble');
          if (iconEl) {
            var tmp = document.createElement('div');
            tmp.innerHTML = data.sections['cart-icon-bubble'];
            var incoming = tmp.querySelector('#cart-icon-bubble');
            iconEl.innerHTML = incoming ? incoming.innerHTML : tmp.innerHTML;
          }
        }
        if (data && data.sections && data.sections['cart-drawer']) {
          var drawerEl = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
          if (drawerEl) {
            var tmp2 = document.createElement('div');
            tmp2.innerHTML = data.sections['cart-drawer'];
            var incoming2 = tmp2.querySelector('cart-drawer') || tmp2.querySelector('#CartDrawer');
            if (incoming2) drawerEl.innerHTML = incoming2.innerHTML;
          }
        }
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; });
      })
      .then(function (cart) {
        // Keep the Scent Expert's own snapshot in step with the add we just
        // made. Without this the widget held its pre-add bag, and the next
        // message told the worker the cart was still empty.
        try {
          if (cart && typeof cart.item_count === 'number') {
            var freshBag = tsvNormaliseShoppingBag(cart);
            if (freshBag) {
              _tsvShoppingBag = freshBag;
              _tsvBagLastFetch = Date.now();
            }
          }
        } catch (_) {}
        if (cart && typeof cart.item_count === 'number') {
          var fabBadge = document.querySelector('.tsv-fab__badge');
          if (fabBadge) {
            if (cart.item_count > 0) {
              fabBadge.style.display = 'block';
              fabBadge.textContent = cart.item_count > 9 ? '9+' : String(cart.item_count);
            } else {
              fabBadge.style.display = 'none';
            }
          }
        }
        var events = ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxProduct:added', 'tsv:cart:updated'];
        events.forEach(function (name) {
          try { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } })); } catch (e) {}
        });
        try {
          if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'tsv-concierge', cartData: cart });
          }
        } catch (e) {}
        appendConcierge(T('cg_added_to_bag','Added to your bag.'));
      })
      .catch(function () {
        appendConcierge(T('cg_add_failed_single', 'Sorry, that could not be added just now. Please try again or open the product page.'));
      })
      .then(function () {
        if (btn) btn.disabled = false;
      });
  }

  // ==== Multi-fragrance SHORTLIST builder ================================
  // A running, session-scoped shortlist the customer builds across the whole
  // conversation from the T('cg_add_shortlist',"Add to shortlist") toggle on each card. Persisted to
  // localStorage so it survives page reloads (e.g. after sign-in). A pinned bar
  // above the input shows the count and opens a review panel with two actions:
  // email the shortlist, or add every item to the bag in one go.
  var _tsvShortlist = [];
  function _shortlistKey() { return 'tsv_shortlist_' + sessionId; }
  function loadShortlist() {
    try {
      var raw = window.localStorage.getItem(_shortlistKey());
      if (raw) { var arr = JSON.parse(raw); if (Array.isArray(arr)) _tsvShortlist = arr; }
    } catch (_) {}
  }
  function saveShortlist() {
    try { window.localStorage.setItem(_shortlistKey(), JSON.stringify(_tsvShortlist)); } catch (_) {}
  }
  function shortlistHas(key) {
    key = String(key || '');
    if (!key) return false;
    return _tsvShortlist.some(function (p) { return String(p.id) === key || String(p.variant_id) === key; });
  }
  function shortlistAdd(p) {
    if (!p) return;
    var id = String(p.id || p.variant_id || '');
    if (!id || shortlistHas(id)) return;
    _tsvShortlist.push({
      id: id, title: p.title || '', vendor: p.vendor || '', price: p.price || '',
      compare_at_price: p.compare_at_price || '', image: p.image || '', url: p.url || '',
      variant_id: p.variant_id || '', reason: p.reason || ''
    });
    saveShortlist();
    updateShortlistBar();
  }
  function shortlistRemove(key) {
    key = String(key || '');
    _tsvShortlist = _tsvShortlist.filter(function (p) { return String(p.id) !== key && String(p.variant_id) !== key; });
    saveShortlist();
    updateShortlistBar();
  }

  var _shortlistBarEl = null;
  function ensureShortlistBar() {
    if (_shortlistBarEl || !messagesEl || !messagesEl.parentNode) return;
    var bar = document.createElement('div');
    bar.className = 'tsv-slBar';
    bar.style.display = 'none';
    bar.innerHTML =
      '<span class="tsv-slBar__icon">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>' +
      '</span>' +
      '<div class="tsv-slBar__info">' +
        '<span class="tsv-slBar__count"></span>' +
        '<span class="tsv-slBar__hint">Email them or add all to your bag</span>' +
      '</div>' +
      '<button type="button" class="tsv-slBar__review">Review shortlist</button>';
    // Sit the bar directly after the scrolling message list, so it floats just
    // above the input without needing to edit the widget shell markup.
    messagesEl.parentNode.insertBefore(bar, messagesEl.nextSibling);
    bar.querySelector('.tsv-slBar__review').addEventListener('click', function () { openShortlistReview(); });
    _shortlistBarEl = bar;
  }
  function updateShortlistBar() {
    ensureShortlistBar();
    if (!_shortlistBarEl) return;
    var n = _tsvShortlist.length;
    if (!n) { _shortlistBarEl.style.display = 'none'; return; }
    _shortlistBarEl.style.display = '';
    // Middle column: just the item count (the icon is its own left column now).
    _shortlistBarEl.querySelector('.tsv-slBar__count').textContent =
      n + (n === 1 ? ' item' : ' items');
  }

  function openShortlistReview() {
    if (!_tsvShortlist.length) {
      appendConcierge(T('cg_shortlist_empty', 'Your shortlist is empty. Tap "Add to shortlist" on any pick to start one.'), true);
      return;
    }
    // Remove any prior review panel so we always show the current state.
    var prev = messagesEl.querySelector('.tsv-slReview');
    if (prev && prev.parentNode) prev.parentNode.removeChild(prev);
    var wrap = document.createElement('div');
    wrap.className = 'tsv-slReview';
    var rows = '';
    for (var i = 0; i < _tsvShortlist.length; i++) {
      var p = _tsvShortlist[i];
      rows +=
        '<div class="tsv-slReview__row" data-id="' + escapeHtml(p.id) + '">' +
          '<img class="tsv-slReview__img" src="' + escapeHtml(p.image || '') + '" alt="" onerror="this.style.visibility=\'hidden\'">' +
          '<div class="tsv-slReview__meta">' +
            '<div class="tsv-slReview__vendor">' + escapeHtml(p.vendor || '') + '</div>' +
            '<div class="tsv-slReview__name">' + escapeHtml(p.title || '') + '</div>' +
            (p.price ? '<div class="tsv-slReview__price">' + escapeHtml(p.price) + '</div>' : '') +
          '</div>' +
          '<button type="button" class="tsv-slReview__remove" aria-label="' + T('cg_remove_shortlist',"Remove from shortlist") + '">&times;</button>' +
        '</div>';
    }
    wrap.innerHTML =
      '<div class="tsv-slReview__title">Your shortlist</div>' +
      rows +
      '<div class="tsv-slReview__actions">' +
        '<button type="button" class="tsv-slReview__email">Email me the shortlist</button>' +
        '<button type="button" class="tsv-slReview__bag">Add all to bag</button>' +
      '</div>';
    messagesEl.appendChild(wrap);
    var removes = wrap.querySelectorAll('.tsv-slReview__remove');
    for (var r = 0; r < removes.length; r++) {
      removes[r].addEventListener('click', function () {
        var row = this.parentNode;
        var id = row && row.getAttribute('data-id');
        shortlistRemove(id);
        if (row && row.parentNode) row.parentNode.removeChild(row);
        // Repaint any visible per-card toggle for this product.
        _repaintCardShortlistToggles();
        if (!_tsvShortlist.length && wrap.parentNode) wrap.parentNode.removeChild(wrap);
      });
    }
    wrap.querySelector('.tsv-slReview__email').addEventListener('click', function () {
      showEmailPicksForm(null, _tsvShortlist);
    });
    wrap.querySelector('.tsv-slReview__bag').addEventListener('click', function () {
      addShortlistToBag(this);
    });
    if (typeof scrollBottom === 'function') scrollBottom();
  }

  function _shortlistBtnHtml(on) {
    return on
      ? '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12l5 5L20 6"/></svg> In shortlist'
      : '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg> Add to shortlist';
  }
  // Keep any on-screen per-card T('cg_add_shortlist',"Add to shortlist") buttons in sync after a
  // removal from the review panel (matched by the data-sl-id we stamp on each).
  function _repaintCardShortlistToggles() {
    if (!messagesEl) return;
    var btns = messagesEl.querySelectorAll('.tsv-rec__shortlistBtn');
    for (var i = 0; i < btns.length; i++) {
      var on = shortlistHas(btns[i].getAttribute('data-sl-id'));
      btns[i].classList.toggle('is-in', on);
      btns[i].innerHTML = _shortlistBtnHtml(on);
    }
  }

  function addShortlistToBag(btn) {
    var items = _tsvShortlist
      .filter(function (p) { return p.variant_id; })
      .map(function (p) { return { id: String(p.variant_id), quantity: 1 }; });
    if (!items.length) {
      appendConcierge(T('cg_add_from_product_pages','These picks need to be added from their product pages. Tap a card to open it.'), true);
      return;
    }
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-icon-bubble,cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (res) { if (!res.ok) throw new Error('cart add failed'); return res.json(); })
      .then(function (data) {
        if (data && data.sections && data.sections['cart-icon-bubble']) {
          var iconEl = document.getElementById('cart-icon-bubble');
          if (iconEl) {
            var tmp = document.createElement('div');
            tmp.innerHTML = data.sections['cart-icon-bubble'];
            var incoming = tmp.querySelector('#cart-icon-bubble');
            iconEl.innerHTML = incoming ? incoming.innerHTML : tmp.innerHTML;
          }
        }
        if (data && data.sections && data.sections['cart-drawer']) {
          var drawerEl = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
          if (drawerEl) {
            var tmp2 = document.createElement('div');
            tmp2.innerHTML = data.sections['cart-drawer'];
            var incoming2 = tmp2.querySelector('cart-drawer') || tmp2.querySelector('#CartDrawer');
            if (incoming2) drawerEl.innerHTML = incoming2.innerHTML;
          }
        }
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; });
      })
      .then(function (cart) {
        // Keep the Scent Expert's own snapshot in step with the add we just
        // made. Without this the widget held its pre-add bag, and the next
        // message told the worker the cart was still empty.
        try {
          if (cart && typeof cart.item_count === 'number') {
            var freshBag = tsvNormaliseShoppingBag(cart);
            if (freshBag) {
              _tsvShoppingBag = freshBag;
              _tsvBagLastFetch = Date.now();
            }
          }
        } catch (_) {}
        if (cart && typeof cart.item_count === 'number') {
          var fabBadge = document.querySelector('.tsv-fab__badge');
          if (fabBadge) {
            if (cart.item_count > 0) { fabBadge.style.display = 'block'; fabBadge.textContent = cart.item_count > 9 ? '9+' : String(cart.item_count); }
            else { fabBadge.style.display = 'none'; }
          }
        }
        ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxProduct:added', 'tsv:cart:updated'].forEach(function (name) {
          try { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } })); } catch (e) {}
        });
        try {
          if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'tsv-concierge', cartData: cart });
          }
        } catch (e) {}
        if (btn) { btn.textContent = 'Added ' + items.length + ' to bag'; }
        appendConcierge(T('cg_added_shortlist_open','Added your shortlist (') + items.length + (items.length === 1 ? ' item' : ' items') + T('cg_added_shortlist_close',') to your bag.'), true);
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = T('cg_add_all_to_bag','Add all to bag'); }
        appendConcierge(T('cg_add_failed_multi', 'Sorry, those could not be added just now. Please try again in a moment.'), true);
      });
  }

  // Load any persisted shortlist and show the bar if it has items.
  loadShortlist();
  updateShortlistBar();

  var resetBtn = widget.querySelector('[data-tsv-reset]');
  var confirmEl = widget.querySelector('#tsvConfirm');
  var confirmOk = widget.querySelector('[data-tsv-confirm-ok]');
  var confirmCancel = widget.querySelector('[data-tsv-confirm-cancel]');

  function showConfirm() {
    widget.classList.add('is-confirming');
    if (confirmEl) confirmEl.setAttribute('aria-hidden', 'false');
  }
  function hideConfirm() {
    widget.classList.remove('is-confirming');
    if (confirmEl) confirmEl.setAttribute('aria-hidden', 'true');
  }

  // End-chat flow. Different from Clear (which just wipes for a new chat):
  // this thanks the customer, invites a rating, and offers newsletter opt-in.
  function showEndChatFlow() {
    // Prevent stacking multiple cards.
    if (messagesEl.querySelector('.tsv-endchat')) {
      messagesEl.querySelector('.tsv-endchat').scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    removeChips();
    var wrap = document.createElement('div');
    wrap.className = 'tsv-endchat';
    wrap.innerHTML =
      '<div class="tsv-endchat__eyebrow">Thanks for chatting</div>' +
      '<div class="tsv-endchat__title">How was your experience with The Scent Expert?</div>' +
      '<div class="tsv-endchat__rating" role="radiogroup" aria-label="Rate this chat">' +
        [1,2,3,4,5].map(function (n) {
          return '<button type="button" class="tsv-endchat__star" data-rating="' + n + '" aria-label="' + n + ' star' + (n > 1 ? 's' : '') + '">' +
            '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
              '<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>' +
            '</svg>' +
          '</button>';
        }).join('') +
      '</div>' +
      '<div class="tsv-endchat__ratingLabel" hidden></div>' +
      '<div class="tsv-endchat__divider"></div>' +
      '<div class="tsv-endchat__newsBlock">' +
        '<div class="tsv-endchat__newsHead">Stay in the loop</div>' +
        '<div class="tsv-endchat__newsSub">One editorial email a week. Sales, new drops, unsubscribe with one click.</div>' +
        '<form class="tsv-endchat__newsForm">' +
          '<input type="email" name="email" required maxlength="200" placeholder="you@email.com" value="' + escapeHtml((CFG.customer && CFG.customer.email) || '') + '">' +
          '<button type="submit" class="tsv-endchat__newsBtn">Sign up</button>' +
        '</form>' +
        '<div class="tsv-endchat__newsErr" hidden></div>' +
      '</div>' +
      '<div class="tsv-endchat__actions">' +
        '<button type="button" class="tsv-endchat__close">Close chat</button>' +
      '</div>';
    messagesEl.appendChild(wrap);
    wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });

    // Rating clicks.
    var stars = wrap.querySelectorAll('.tsv-endchat__star');
    var labelEl = wrap.querySelector('.tsv-endchat__ratingLabel');
    var LABELS = ['', T('cg_rate_not_great','Not great'), T('cg_rate_ok','It was ok'), 'Solid', T('cg_rate_good','Really good'), T('cg_rate_loved','Loved it')];
    stars.forEach(function (star) {
      star.addEventListener('click', function () {
        var val = Number(star.getAttribute('data-rating'));
        stars.forEach(function (s2, idx) {
          s2.classList.toggle('is-active', idx < val);
        });
        labelEl.textContent = LABELS[val] || '';
        labelEl.hidden = false;
        // Fire-and-forget rating submission. Uses /flag-attempt as a lightweight
        // signal channel (reason=rating). Reuses existing endpoint so no worker
        // change needed here.
        try {
          if (CFG.endpoint) {
            fetch(CFG.endpoint.replace(/\/chat\/?$/, '/flag-attempt'), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ session_id: sessionId, reason: 'rating', matched: String(val) })
            }).catch(function () {});
          }
        } catch (_) {}
      });
    });

    // Newsletter opt-in submit.
    var newsForm = wrap.querySelector('.tsv-endchat__newsForm');
    var newsBtn  = wrap.querySelector('.tsv-endchat__newsBtn');
    var newsErr  = wrap.querySelector('.tsv-endchat__newsErr');
    var newsInput = wrap.querySelector('input[name="email"]');
    newsForm.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var email = String(newsInput.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        newsErr.hidden = false; newsErr.textContent = T('cg_valid_email_2','Enter a valid email.');
        return;
      }
      newsErr.hidden = true;
      newsBtn.disabled = true; newsBtn.textContent = T('cg_signing_up','Signing up...');
      var payload = { email: email };
      var c = CFG.customer || {};
      if (c.first_name) payload.first_name = c.first_name;
      if (c.last_name)  payload.last_name  = c.last_name;
      conciergePost('/newsletter', payload)
        .then(function (r) {
          if (r && r.ok) {
            var block = wrap.querySelector('.tsv-endchat__newsBlock');
            block.innerHTML = '<div class="tsv-endchat__newsDone">' + (r.already_subscribed ? T('cg_already_list_nice','Already on the list. Nice.') : T('cg_you_are_in','You are in. Welcome.')) + '</div>';
            saveSnapshotWhenIdle();
          } else {
            newsBtn.disabled = false; newsBtn.textContent = T('cg_sign_up','Sign up');
            newsErr.hidden = false;
            newsErr.textContent = (r && (r.message || r.error)) ? String(r.message || r.error) : T('cg_signup_failed_short','Could not sign up.');
          }
        })
        .catch(function () {
          newsBtn.disabled = false; newsBtn.textContent = T('cg_sign_up','Sign up');
          newsErr.hidden = false; newsErr.textContent = T('cg_network_issue','Network issue. Try again in a moment.');
        });
    });

    // Close chat button: confirm, then end for real. Wipes the end-chat
    // card so reopening later doesn't show a stale rating panel, and
    // shrinks the bubble into a minimised state so it's out of the way.
    var closeBtnE = wrap.querySelector('.tsv-endchat__close');
    if (closeBtnE) closeBtnE.addEventListener('click', function () {
      if (!confirm(T('cg_close_chat_confirm','Close this chat? Your conversation stays saved for 30 days.'))) return;
      try {
        // Remove the end-chat card so it does not persist in the snapshot.
        if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
      } catch (_) {}
      // Persist the wiped state so a page refresh does not restore it.
      saveSnapshotWhenIdle();
      // Minimise the bubble.
      widget.classList.add('is-minimised');
      close();
    });

    saveSnapshotWhenIdle();
  }

  function resetConversation() {
    clearSnapshot();
    sessionId = makeId();
    try { window.localStorage.setItem(SESSION_KEY, sessionId); } catch (e) {}
    SNAPSHOT_KEY = 'tsv_concierge_snapshot_' + sessionId;
    SNAPSHOT_ID_KEY = 'tsv_concierge_snapshot_id_' + sessionId;
    historyPromise = null;
    historyLoaded = false;
    if (messagesEl) messagesEl.innerHTML = '';
    hasGreeted = false;
    setTimeout(function () {
      hasGreeted = true;
      restoreOrGreet();
    }, 100);
    hideConfirm();
  }

  if (resetBtn) resetBtn.addEventListener('click', showConfirm);
  var endBtn = widget.querySelector('[data-tsv-end]');
  if (endBtn) endBtn.addEventListener('click', showEndChatFlow);
  if (confirmCancel) confirmCancel.addEventListener('click', hideConfirm);
  if (confirmOk) confirmOk.addEventListener('click', resetConversation);
  if (confirmEl) {
    confirmEl.addEventListener('click', function (e) {
      if (e.target === confirmEl) hideConfirm();
    });
  }

  function renderResponse(data) {
    if (!data || (!data.messages && !data.reply)) {
      appendConcierge(T('cg_expert_offline', 'The Scent Expert is offline right now. Please try again shortly.'));
      saveSnapshotWhenIdle();
      return;
    }
    // Safety net: strip any bare email/phone that slipped past the AI's
    // rule, and if the AI's text mentions contact/team without emitting a
    // chip, inject a T('cg_message_team',"Message the team") chip so the customer gets a
    // button that opens the contact form inline instead of a dead
    // sentence pointing at nothing.
    (function tsvSanitiseContactMentions() {
      try {
        if (!data.messages || !data.messages.length) return;
        var contactHint = /help@thescentvault\.ie|contact form|message the team|email (us|the team|customer)|reach out to (us|the team)/i;
        var mentionIndex = -1; // index of the text message that mentioned contact
        var alreadyHasChip = false;
        for (var i = 0; i < data.messages.length; i++) {
          var m = data.messages[i];
          if (!m) continue;
          if (m.type === 'text' && m.text) {
            var before = String(m.text);
            var after = before
              .replace(/help@thescentvault\.ie/gi, 'the contact form')
              .replace(/\bemail\s+(us|the team|help@[\w.-]+)/gi, 'message the team')
              .replace(/\buse the contact form (below|here)\b/gi, 'open the contact form')
              .replace(/\bcontact form below\b/gi, 'contact form');
            // Collapse "the contact form or ... the contact form" style
            // duplicates that arise when the AI wrote something like
            // "reach us at help@... or use the contact form" and the
            // email replacement above created two contact-form mentions.
            after = after
              .replace(/\bthe contact form\b(.{0,40})\bthe contact form\b/gi, 'the contact form$1')
              .replace(/\b(?:reach|contact)\s+(?:us|the team)\s+(?:at|via|through)\s+the contact form(?:\s+or\s+.{0,60})?/gi, 'reach the team through the contact form')
              .replace(/\bat the contact form or\s+(?:use|open)\s+the contact form\b/gi, 'through the contact form')
              .replace(/\bthe contact form\s+on\s+the\s+site\b/gi, 'the contact form');
            if (contactHint.test(before) && mentionIndex === -1) mentionIndex = i;
            if (after !== before) m.text = after;
          }
          if (m.type === 'chips' && Array.isArray(m.items)) {
            for (var j = 0; j < m.items.length; j++) {
              if (/^(message the team|speak to the team|contact the team|contact support)$/i.test(String(m.items[j] || '').trim())) {
                alreadyHasChip = true; break;
              }
            }
          }
        }
        if (mentionIndex !== -1 && !alreadyHasChip) {
          // Splice the Message the team chip in DIRECTLY AFTER the text
          // that mentioned contact, so it appears as the very next
          // element under that bubble instead of below all other chips.
          data.messages.splice(mentionIndex + 1, 0, { type: 'chips', items: [T('cg_message_team','Message the team')] });
        }
      } catch (_) {}
    })();
    var list = data.messages;
    if (!list && data.reply) list = [{ type: 'text', text: data.reply }];
    var expanded = [];
    list.forEach(function (m) {
      if (!m) return;
      if (typeof m === 'string') {
        String(m).split(/\n{2,}/).forEach(function (p) {
          if (p.trim()) expanded.push({ type: 'text', text: p.trim(), fade: true });
        });
        return;
      }
      // Upsell carries a .text field for its label copy, but it is NOT a text
      // bubble - it must keep its item card + heading. Handle it BEFORE the
      // generic m.text catch below (which would otherwise flatten it into a
      // plain paragraph and drop the product card).
      if (m.type === 'upsell') { expanded.push(m); return; }
      if (m.type === 'text' || m.text) {
        String(m.text || '').split(/\n{2,}/).forEach(function (p) {
          if (p.trim()) expanded.push({ type: 'text', text: p.trim(), fade: true });
        });
        return;
      }
      expanded.push(m);
    });
    // Chip dedupe + chips-last enforcement. The AI sometimes emits chips
    // BEFORE the elaboration text or in the middle of the response —
    // that reads as premature follow-up prompting. Regardless of the
    // model's order, we always move every chip strip to the very end,
    // merge them into one strip, dedupe labels. Server-side reorder is
    // belt, this is braces.
    // Full order guarantee: text first, then product/account cards, then a
    // single merged+deduped chip strip last. Reordered BEFORE mounting so
    // there is no visible shuffle. Non-streaming, so this is stable.
    (function () {
      var texts = [], cards = [], chipStrips = [];
      expanded.forEach(function (m) {
        if (!m) return;
        if (m.type === 'chips' && Array.isArray(m.items)) { chipStrips.push(m); return; }
        if (m.type === 'text') { texts.push(m); return; }
        cards.push(m);
      });
      var kept = texts.concat(cards);
      if (chipStrips.length) {
        var seen = Object.create(null);
        var merged = [];
        chipStrips.forEach(function (strip) {
          strip.items.forEach(function (c) {
            var k = String(c || '').trim().toLowerCase();
            if (!k || seen[k]) return;
            seen[k] = true;
            merged.push(c);
          });
        });
        if (merged.length) kept.push({ type: 'chips', items: merged });
      }
      expanded = kept;
    })();
    // Remember where the response starts so we can anchor scroll to the top
    // of the first new node once all parts have landed.
    var startCount = messagesEl.children.length;
    // Natural scroll: the reveal never anchors or sticks the view. Content
    // mounts, the browser keeps the scroll position, and the customer scrolls
    // when they want to.
    var delay = 0;
    // Helper: anchor scroll to the top of the first new response node.
    // Uses direct scrollTop (uninterruptible), temporarily disables CSS
    // smooth-scroll (which iOS Safari can interrupt), and re-runs the
    // anchor on a couple of timers so late reflows (fade-in animation
    // completing, image loading, product card layout settling) don't
    // leave the customer scrolled to the bottom.
    function anchorToFirstNew() {
      var firstNew = messagesEl.children[startCount];
      if (!firstNew) return;
      var prevBehavior = messagesEl.style.scrollBehavior;
      messagesEl.style.scrollBehavior = 'auto';
      // Direct scrollTop is instant and cannot be interrupted mid-animation.
      // A tiny negative padding compensates for the message container's
      // top padding so the first message aligns flush with the top edge.
      var target = Math.max(0, firstNew.offsetTop - 8);
      messagesEl.scrollTop = target;
      // Restore smooth behavior after a paint tick.
      requestAnimationFrame(function () {
        messagesEl.style.scrollBehavior = prevBehavior || '';
      });
    }
    // Refined sequencer: every element mounts through the animation
    // queue with deliberate pauses. Cards fade in ONE AT A TIME with a
    // long pause between each so it looks like the concierge is placing
    // them on the table for you, not spraying them at you.
    expanded.forEach(function (m, i) {
      if (m.type === 'text') {
        // Small pause before the next text bubble starts typing.
        tsvChainPause(500);
        // Call appendConcierge DIRECTLY (not wrapped in another tsvQueue).
        // appendConcierge already enqueues its DOM-insertion task on the
        // same chain, so calling it here places that insertion in the
        // correct chain slot, BEFORE the card and chip tasks that this
        // synchronous forEach enqueues after it. The old double-wrap
        // deferred the real text insertion by one queue cycle, so by the
        // time it ran the cards and chips were already queued ahead of it
        // and the text landed at the very bottom of the reply. This is the
        // root cause of "text comes last". Matches how products/chips are
        // called directly just below.
        appendConcierge(m.text, m.fade);
      } else if (m.type === 'products' && m.items && m.items.length) {
        // Long pause before the first card lands.
        tsvChainPause(700);
        // Comparison mode (#525): mount all cards in one horizontal grid
        // call, then append the compare_attrs table below. Skips the
        // one-by-one cascade so both cards are visible at the same time.
        if (m.layout === 'compare' && Array.isArray(m.compare_attrs)) {
          appendProducts(m.items, { layout: 'compare', attrs: m.compare_attrs, showRefine: false });
        } else {
          // Standard mode: mount cards ONE BY ONE. Because appendProducts
          // internally enqueues its impl on the same chain, calling it
          // directly (not wrapped in another tsvQueue) preserves
          // ordering: each card's impl runs before the next chainPause
          // begins. Refinement chips are suppressed on all but the LAST
          // card so they appear exactly once at the end of the set.
          // Built-in refinement chip strip is suppressed on all cards.
          // The AI's own follow-up chips are more contextual (e.g. "Tell
          // me more about Bvlgari Man in Black" instead of generic "show
          // me more like these") so we do not need both strips fighting
          // for attention. Card sequencing pause between mounts stays at
          // 900ms.
          m.items.forEach(function (product, idx) {
            if (idx > 0) tsvChainPause(900);
            appendProducts([product], { showRefine: false });
          });
        }
      } else if (m.type === 'upsell' && m.item) {
        // T('cg_complete_set',"Complete the set") add-on: a labelled block then the matching
        // body-care card. Lands after the fragrance cards, before the chips.
        tsvChainPause(800);
        appendUpsell(m);
      } else if (m.type === 'chips' && m.items) {
        // Chips arrive last after another beat. appendChips already
        // enqueues its impl on the animation chain, so calling it
        // directly here preserves the pause-then-chips ordering.
        tsvChainPause(700);
        appendChips(m.items, true);
      }
      // Final settle after everything mounts.
      if (i === expanded.length - 1) {
        tsvQueue(function () {
          return new Promise(function (resolve) {
            saveSnapshotWhenIdle();
            // Natural scroll only: nothing anchors or sticks the view at the
            // end of a reply either. The browser keeps the scroll position.
            resolve();
          });
        });
      }
    });
  }

  // Same as submit() but skips the intent-detection loop, so the Phase 2
  // handlers can forward their text through to /chat as a genuine fallback
  // without recursing back into themselves.
  function submitDirect(text, extras) {
    if (!text) return;
    var _redD = tsvRedactSensitive(text);
    if (_redD.redacted) { text = _redD.clean; tsvFlashInput(T('cg_redacted_notice','For your security, sensitive details were removed.')); }
    if (tsvDetectProfanity(text)) {
      tsvFlashInput(T('cg_keep_respectful', 'Please keep it respectful.'));
      return;
    }
    tsvDismissOnboarding();
    // Do not re-append the user bubble; the chip handler already did.
    appendTyping();
    var _tsvExtras = extras || {};
    if (sendBtn) sendBtn.disabled = true;

    var endpoint = CFG.endpoint;
    if (!endpoint) {
      setTimeout(function () {
        removeTyping();
        appendConcierge(T('cg_expert_offline', 'The Scent Expert is offline right now. Please try again shortly.'));
        if (sendBtn) sendBtn.disabled = false;
      }, 500);
      return;
    }

    var _tsvLastRes2 = null;
    // Await a fresh bag snapshot before sending so the worker's system
    // prompt always sees LIVE bag contents. Without this, on first-open
    // or when the customer added items just before typing, the cached
    // /cart.js may still be empty and the AI ends up refusing to comment.
    // Refresh the bag on EVERY message, not only cart-shaped ones. The worker
    // can only distinguish "bag is empty" from "bag unknown" when the snapshot
    // is actually fresh, and gating on tsvIsCartQuery meant most turns shipped
    // a stale or never-populated bag. The 2s throttle above keeps this cheap,
    // and /cart.js is Shopify, so it costs nothing on Cloudflare.
    Promise.resolve(tsvRefreshShoppingBag()).catch(function(){ return null; }).then(function () {
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        message: text,
        session_id: sessionId,
        currency: CFG.currency,
        money_format: CFG.moneyFormat,
        shop: CFG.shop,
        locale: CFG.locale,
        session_language: _tsvSessionLang || null,
        page_url: window.location.href,
        customer_id: CFG.customer ? CFG.customer.id : null,
        customer_email: CFG.customer ? CFG.customer.email : null,
        customer_first_name: CFG.customer ? CFG.customer.first_name : null,
        recently_viewed: tsvGetRecentlyViewed(),
      shopping_bag: tsvGetShoppingBag(),
        is_gift_query: !!_tsvExtras.is_gift_query,
        is_signature_query: !!_tsvExtras.is_signature_query,
        is_daily_query: !!_tsvExtras.is_daily_query
      })
    })
      .then(function (res) {
        _tsvLastRes2 = res;
        if (!res.ok) throw new Error('bad status ' + res.status);
        return res.json();
      })
      .then(function (data) { removeTyping(); if(data&&data.ok===false){tsvHandleChatError(new Error('body ok:false'),_tsvLastRes2).then(function(m){appendConcierge(m);try{saveSnapshot();}catch(_){}});return;} renderResponse(data); try { saveSnapshot(); } catch (_) {} })
      .catch(function (err) { removeTyping(); tsvHandleChatError(err, _tsvLastRes2).then(function(msg){appendConcierge(msg); try { saveSnapshot(); } catch (_) {}}); })
      .then(function () { if (sendBtn) sendBtn.disabled = false; });
    });
  }

  // ==== Feature 12: language auto-switching + explicit commands ==========
  var _tsvSessionLang = null;
  // NOTE: session language deliberately not restored from localStorage. It
  // should only stick within the current browsing session so a stale
  // preference from days ago does not override a customer typing in a
  // different language today. Explicit commands like "reply in French"
  // will re-set it during the current session via tsvSetSessionLanguage.
  try { window.sessionStorage.getItem && (_tsvSessionLang = window.sessionStorage.getItem('tsv_lang') || null); } catch (_) {}
  function tsvDetectLangCommand(text) {
    if (!text) return null;
    var t = String(text).toLowerCase().trim();
    var patterns = [
      { rx: /\b(?:speak|reply|respond|write|answer)\s+(?:in\s+)?english\b/, code: 'en' },
      { rx: /\b(?:parle|reponds?|repondez|ecris?)\s+(?:en\s+)?francais\b/, code: 'fr' },
      { rx: /\b(?:sprich|antworte|schreib)\s+(?:auf\s+)?deutsch\b/, code: 'de' },
      { rx: /\b(?:habla|responde|escribe)\s+(?:en\s+)?espanol\b/, code: 'es' },
      { rx: /\b(?:parla|rispondi|scrivi)\s+(?:in\s+)?italiano\b/, code: 'it' },
      { rx: /\bin\s+english\b/, code: 'en' },
      { rx: /\ben\s+francais\b/, code: 'fr' },
      { rx: /\bauf\s+deutsch\b/, code: 'de' },
      { rx: /\ben\s+espanol\b/, code: 'es' },
      { rx: /\bin\s+italiano\b/, code: 'it' },
      { rx: /\b(?:svara|skriv)\s+(?:p[åa]\s+)?svenska\b/, code: 'sv' },
      { rx: /\bp[åa]\s+svenska\b/, code: 'sv' }
    ];
    for (var i = 0; i < patterns.length; i++) {
      if (patterns[i].rx.test(t)) return patterns[i].code;
    }
    return null;
  }
  function tsvSetSessionLanguage(code) {
    if (!code) return;
    _tsvSessionLang = code;
    try { window.sessionStorage.setItem('tsv_lang', code); } catch (_) {}
    // Also clear any legacy localStorage entry from before this change.
    try { window.localStorage.removeItem('tsv_lang'); } catch (_) {}
    try {
      var endpoint = CFG.endpoint;
      if (!endpoint) return;
      var url = endpoint.replace(/\/chat\/?$/, '/session/language');
      if (url === endpoint) url = endpoint + '/session/language';
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: sessionId, language: code })
      }).catch(function () {});
    } catch (_) {}
    var confirms = {
      en: 'Reply language is now English.',
      fr: 'Langue de reponse: francais.',
      de: 'Antwortsprache ist jetzt Deutsch.',
      es: 'Idioma de respuesta: espanol.',
      it: 'Lingua di risposta: italiano.'
    };
    if (typeof appendConcierge === 'function' && confirms[code]) {
      try { appendConcierge(confirms[code], true); } catch (_) {}
    }
  }

  // ==== Feature 5: gifting mode multi-step flow ==========================
  function tsvOpenGiftFlow() {
    if (!tsvFeatOn('giftingMode')) return;
    var state = { step: 0 };
    var wrap = document.createElement('div');
    wrap.className = 'tsv-msg tsv-msg--concierge';
    wrap.style.borderLeftColor = 'var(--tsv-ivory)';
    messagesEl.appendChild(wrap);
    try { messagesEl.scrollTop = messagesEl.scrollHeight; } catch (_) {}
    var STEPS = [
      { key: 'recipient', q: T('cg_gift_q_who','Who is this gift for?'), options: ['Partner', 'Parent', 'Sibling', 'Friend', 'Colleague', 'Myself'] },
      { key: 'occasion',  q: T('cg_gift_q_occasion','What is the occasion?'),   options: ['Birthday', 'Christmas', 'Anniversary', 'Wedding', T('cg_gift_a_just_because','Just because')] },
      { key: 'budget',    q: T('cg_gift_q_budget','What is the budget?'),     options: ['Under 60 euro', '60 to 100 euro', '100 to 150 euro', '150 to 250 euro', T('cg_gift_a_250_plus','250 euro plus')] },
      { key: 'vibe',      q: T('cg_gift_q_style','Any style leaning?'),      options: ['Fresh and clean', T('cg_gift_a_warm_spicy','Warm and spicy'), T('cg_gift_a_sweet_gourmand','Sweet and gourmand'), T('cg_gift_a_woody_smoky','Woody and smoky'), T('cg_gift_a_floral_pretty','Floral and pretty'), T('cg_gift_a_not_sure','Not sure')] }
    ];
    function render() {
      var st = STEPS[state.step];
      wrap.innerHTML = '<div style="font-size:12px;letter-spacing:0.06em;text-transform:uppercase;color:var(--tsv-muted);margin-bottom:4px">Gift Finder ' + (state.step + 1) + ' / ' + STEPS.length + '</div>' +
                       '<div style="font-size:13px;line-height:1.55;margin-bottom:10px">' + escapeHtml(st.q) + '</div>' +
                       '<div class="tsv-chips" style="margin:0"></div>';
      var chipsEl = wrap.querySelector('.tsv-chips');
      st.options.forEach(function (opt) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'tsv-chip'; b.textContent = opt;
        b.addEventListener('click', function () {
          state[st.key] = opt;
          if (state.step < STEPS.length - 1) { state.step += 1; render(); } else { finish(); }
        });
        chipsEl.appendChild(b);
      });
      try { messagesEl.scrollTop = messagesEl.scrollHeight; } catch (_) {}
    }
    function finish() {
      var line = 'GIFT REQUEST: for my ' + state.recipient.toLowerCase() +
                 ' for their ' + state.occasion.toLowerCase() +
                 ', budget ' + state.budget.toLowerCase() +
                 ', leaning ' + state.vibe.toLowerCase() + '.';
      try { wrap.parentNode && wrap.parentNode.removeChild(wrap); } catch (_) {}
      appendUser('Gift for ' + state.recipient + ' / ' + state.occasion);
      submitDirect(line, { is_gift_query: true });
    }
    render();
  }

  // Called from bookmark UI on product cards to persist a product to
  // the customer's fragrance shelf under a given status.
  function tsvAddToWardrobe(product, status) {
    if (!tsvFeatOn('wardrobeView')) return;
    var endpoint = CFG.endpoint;
    if (!endpoint) return;
    var url = endpoint.replace(/\/chat\/?$/, '/wardrobe/add');
    if (url === endpoint) url = endpoint + '/wardrobe/add';
    var body = {
      session_id: sessionId,
      customer_id: CFG.customer ? CFG.customer.id : null,
      product_id: product.id,
      product_title: product.title || '',
      product_vendor: product.vendor || '',
      product_image: product.image || '',
      product_url: product.url || '',
      status: status || 'owned'
    };
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function () {
        try {
          var word = status === 'owned' ? 'owned' : (status === 'sampled' ? 'sampled' : 'wishlist');
          appendConcierge(T('cg_saved_to_shelf_as','Saved to your shelf as ') + word + '.', true);
          saveSnapshotWhenIdle();
        } catch (_) {}
      })
      .catch(function () {});
  }

  // ==== Feature 2: fragrance SHELF (was 'wardrobe') ======================
  // Customer-facing label is 'My Fragrance Shelf'. Internally the DB
  // table and endpoints are still 'wardrobe' to avoid a migration.
  function tsvOpenShelf() {
    if (!tsvFeatOn('wardrobeView')) return;
    var endpoint = CFG.endpoint;
    if (!endpoint) return;
    var url = endpoint.replace(/\/chat\/?$/, '/wardrobe/get');
    if (url === endpoint) url = endpoint + '/wardrobe/get';
    var body = { session_id: sessionId, customer_id: CFG.customer ? CFG.customer.id : null };
    beforeChipRequest(T('cg_chip_my_shelf2', 'My fragrance shelf'));
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        afterChipRequest();
        if (!data || !data.ok || !Array.isArray(data.items) || !data.items.length) {
          appendConcierge(T('cg_shelf_empty', 'Your shelf is empty right now. Add a fragrance from any product card by tapping the bookmark icon, and it will show up here.'), true);
          appendChips([chipT('bestsellers','cg_chip_pick_new','Pick something new for me'), chipT('on_sale','cg_chip_on_sale','What is on sale this week'), chipT('','cg_chip_buy_gift','Help me buy a gift')], true);
          saveSnapshotWhenIdle();
          return;
        }
        appendConcierge(T('cg_shelf_intro', 'Here is your fragrance shelf. Split by what you own, sampled, and want next.'), true);
        _tsvRenderShelfCard(data.items);
        appendChips([chipT('bestsellers','cg_chip_pick_new','Pick something new for me'), chipT('on_sale','cg_chip_on_sale','What is on sale this week')], true);
        saveSnapshotWhenIdle();
      })
      .catch(function () { afterChipRequest(); submitDirect(T('cg_chip_my_shelf2', 'My fragrance shelf')); });
  }
  // Render the fragrance shelf using the SAME rich product cards as the rest
  // of the widget (image, price, size chips, Add to bag, Buy now, bookmark,
  // share, similar). Shelf rows only persist minimal data, so each product is
  // hydrated from its Shopify product JSON to get live variants + pricing,
  // then rendered through appendProducts for identical styling + functionality.
  function _tsvRenderShelfCard(items) {
    var groups = [
      { label: 'Owned',     list: items.filter(function (i) { return i.status === 'owned'; }) },
      { label: 'Sampled',   list: items.filter(function (i) { return i.status === 'sampled'; }) },
      { label: T('cg_want_next','Want next'), list: items.filter(function (i) { return i.status === 'wishlist'; }) }
    ];

    function hydrate(item) {
      // Preferred path: the /wardrobe/get endpoint already enriched the row
      // with live variant + price data, so build the card directly (no fetch).
      if (item.variant_id) {
        var vlist = Array.isArray(item.variants) ? item.variants.map(function (v) {
          return { variant_id: String(v.variant_id), price: v.price, size: v.size || '', available: v.available !== false };
        }) : [];
        return Promise.resolve({
          id: item.product_id || '',
          title: item.product_title || '',
          vendor: item.product_vendor || '',
          image: item.product_image || '',
          url: item.product_url || '',
          price: item.price || '',
          variant_id: String(item.variant_id),
          variants: vlist.length > 1 ? vlist : [],
          in_stock: item.in_stock !== false
        });
      }
      var raw = String(item.product_url || '');
      var base = raw.split('?')[0].replace(/\/$/, '');
      var fallback = {
        id: item.product_id || '',
        title: item.product_title || '',
        vendor: item.product_vendor || '',
        image: item.product_image || '',
        url: item.product_url || ''
      };
      if (!base) return Promise.resolve(fallback);
      return fetch(base + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (pj) {
          if (!pj || !Array.isArray(pj.variants) || !pj.variants.length) return fallback;
          var variants = pj.variants.map(function (v) {
            return {
              variant_id: String(v.id),
              price: (Number(v.price) / 100).toFixed(2),
              size: (v.title && v.title !== 'Default Title') ? v.title : (pj.title || ''),
              available: v.available !== false
            };
          });
          var firstAvail = variants.filter(function (v) { return v.available; })[0] || variants[0];
          var img = item.product_image || pj.featured_image ||
            (pj.images && pj.images.length ? pj.images[0] : '');
          return {
            id: pj.id ? String(pj.id) : (item.product_id || ''),
            title: pj.title || item.product_title || '',
            vendor: pj.vendor || item.product_vendor || '',
            image: img,
            url: item.product_url || ('/products/' + pj.handle),
            price: firstAvail.price,
            variant_id: firstAvail.variant_id,
            variants: variants.length > 1 ? variants : [],
            in_stock: variants.some(function (v) { return v.available; })
          };
        })
        .catch(function () { return fallback; });
    }

    // Hydrate everything up front, then render each section (header + cards)
    // in order so headers always sit above their cards.
    var pending = [];
    groups.forEach(function (g) {
      g.list.forEach(function (it) { pending.push(hydrate(it).then(function (p) { it._p = p; })); });
    });

    var firstSection = true;
    Promise.all(pending).then(function () {
      groups.forEach(function (g) {
        if (!g.list.length) return;
        var isFirst = firstSection; firstSection = false;
        tsvQueue(function () {
          var head = document.createElement('div');
          head.className = 'tsv-shelf__label tsv-shelf__label--rec';
          head.textContent = g.label + ' (' + g.list.length + ')';
          head.style.cssText = 'margin:14px 4px 8px;font-size:11px;letter-spacing:1.6px;text-transform:uppercase;font-weight:600;color:#c9b37f;opacity:.95';
          messagesEl.appendChild(head);
          if (isFirst) { try { scrollToTopOf(head); } catch (_) {} }
          return Promise.resolve();
        });
        appendProducts(g.list.map(function (it) { return it._p; }), { showRefine: false });
      });
      saveSnapshotWhenIdle();
    });
  }

  // ==== Feature 9: note deep-dive card ====================================
  function tsvNoteDeepdive(noteName, opts) {
    if (!tsvFeatOn('noteDeepDive')) return;
    var endpoint = CFG.endpoint;
    if (!endpoint) return;
    var url = endpoint.replace(/\/chat\/?$/, '/note-deepdive');
    if (url === endpoint) url = endpoint + '/note-deepdive';
    // If the caller already appended the user's message (typed-intent route),
    // just remove chips + show typing dots. Otherwise show the chip-style
    // "Tell me about X" bubble.
    if (opts && opts.skipUserAppend) {
      removeChips();
      appendTyping();
    } else {
      beforeChipRequest('Tell me about ' + noteName);
    }
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: String(noteName || '').toLowerCase() }) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        afterChipRequest();
        if (!data || !data.ok || !data.known) {
          submitDirect('Tell me about ' + noteName);
          return;
        }
        // Build a richer 2-3 sentence intro from the note payload so the
        // card lands with proper context, not a one-liner.
        var noteCap = String(data.note || '').charAt(0).toUpperCase() + String(data.note || '').slice(1);
        var characterLower = String(data.character || '').replace(/\.$/, '').toLowerCase();
        var intro = noteCap + T('cg_note_intro_tail', ' is one of the more distinctive notes in perfumery, prized by houses that want depth without shouting. ');
        if (characterLower) {
          intro += T('cg_character_reads_as','The character reads as ') + characterLower + '. ';
        }
        if (data.origin) {
          intro += T('cg_origin_traces_to','Origin traces back to ') + data.origin + '. ';
        }
        intro += T('cg_note_full_picture', 'Here is the full picture, plus a few picks from our catalogue that lean into it.');
        // Type the intro first, THEN mount the card, THEN products, THEN
        // Discovery mention, THEN chips. Every step goes through tsvQueue
        // and every transition gets a deliberate pause so nothing arrives
        // on top of the previous element. Reads as considered, editorial
        // pacing — not a stack of cards flung onto the screen.
        appendConcierge(intro, true);
        tsvChainPause(650);
        tsvQueue(function () { _tsvRenderNoteCard(data); });
        if (data.catalogue_matches && data.catalogue_matches.length) {
          // Long pause after the note card so the customer can actually
          // read it before the product recommendations start arriving.
          tsvChainPause(1600);
          appendConcierge(T('cg_three_that_feature','Three from what we stock right now that feature ') + data.note + ' prominently:', true);
          tsvChainPause(500);
          appendProducts(data.catalogue_matches);
          // Wait for the staggered product-card fade to finish (6 cards *
          // 420ms stagger + 1.6s duration = ~4.1s worst case) before the
          // Discovery mention starts typing. 3s gives 3-4 cards plenty of
          // time to settle without feeling laggy.
          tsvChainPause(3000);
          // Discovery Collection mention — Discovery is the safest way to
          // try multiple compositions built around a note before committing.
          appendConcierge(T('cg_if_you_want_sample','If you want to sample a few ') + data.note + '-forward compositions side by side before locking in a full bottle, our Discovery Collection lets you wear six curated scents for a week each. [Explore the Discovery Collection](/pages/discovery-collection-launch)', true);
          tsvChainPause(600);
        } else {
          // No catalogue matches at all. Ask the AI to recommend
          // fragrances that feature this note, so the customer never
          // sees a bare note card with nothing under it.
          tsvChainPause(1400);
          appendConcierge(T('cg_let_me_pull_some','Let me pull some ') + data.note + T('cg_forward_picks_suffix','-forward picks from our catalogue for you now.'), true);
          submitDirect('Recommend three fragrances we stock that feature ' + data.note + ' prominently, ordered from designer to niche.');
          return;
        }
        appendChips([T('cg_chip_another_note',chipT('','cg_chip_another_note','Tell me about another note')), T('cg_chip_discovery_collection',chipT('','cg_chip_discovery_collection','Show me the Discovery Collection')), chipT('bestsellers','cg_chip_pick_new','Pick something new for me')], true);
        saveSnapshotWhenIdle();
      })
      .catch(function () { afterChipRequest(); submitDirect('Tell me about ' + noteName); });
  }
  function _tsvRenderNoteCard(data) {
    var wrap = document.createElement('div');
    wrap.className = 'tsv-msg tsv-msg--concierge tsv-note';
    wrap.innerHTML = '<div class="tsv-note__title">' + escapeHtml((data.note || '').toUpperCase()) + '</div>' +
                     '<div class="tsv-note__row"><div class="tsv-note__label">Origin</div><div>' + escapeHtml(data.origin || '') + '</div></div>' +
                     '<div class="tsv-note__row"><div class="tsv-note__label">Character</div><div>' + escapeHtml(data.character || '') + '</div></div>' +
                     (data.pairs_well_with && data.pairs_well_with.length ? '<div class="tsv-note__row"><div class="tsv-note__label">Pairs with</div><div>' + escapeHtml(data.pairs_well_with.join(', ')) + '</div></div>' : '') +
                     (data.famous_fragrances && data.famous_fragrances.length ? '<div class="tsv-note__row"><div class="tsv-note__label">Famous in</div><div>' + escapeHtml(data.famous_fragrances.join(', ')) + '</div></div>' : '');
    messagesEl.appendChild(wrap);
    scrollToTopOf(wrap);
  }

  // ==== Feature 40: community perception on explain-more panel ==============
  // Compact real scent profile (families + key notes, capped at 3 each, plus
  // longevity + sillage) built from the catalog data the worker attaches to the
  // /perception response. Shown above the community perception.
  function _tsvRenderProfile(prof) {
    if (!prof) return '';
    function cap3(arr) {
      return (arr || []).map(function (x) { return String(x).trim(); }).filter(Boolean).slice(0, 3);
    }
    var fams = cap3(prof.families);
    // Key notes: top, then heart, then base, then flat notes; de-duped; max 3.
    var seen = {}, keyNotes = [];
    ['top_notes', 'heart_notes', 'base_notes', 'notes'].forEach(function (k) {
      (prof[k] || []).forEach(function (x) {
        var t = String(x).trim(), lc = t.toLowerCase();
        if (t && !seen[lc] && keyNotes.length < 3) { seen[lc] = 1; keyNotes.push(t); }
      });
    });
    var chip = function (t) { return '<span class="tsv-profChip">' + escapeHtml(t) + '</span>'; };
    var out = '';
    if (fams.length)     out += '<div class="tsv-profSection"><div class="tsv-profHeading">Scent Profile</div><div class="tsv-profChips">' + fams.map(chip).join('') + '</div></div>';
    if (keyNotes.length) out += '<div class="tsv-profSection"><div class="tsv-profHeading">Key Notes</div><div class="tsv-profChips">' + keyNotes.map(chip).join('') + '</div></div>';
    var stats = '';
    if (prof.longevity) stats += '<div class="tsv-profStatItem"><span class="tsv-profStatLabel">Longevity</span><span class="tsv-profStatVal">' + escapeHtml(String(prof.longevity)) + '</span></div>';
    if (prof.sillage)   stats += '<div class="tsv-profStatItem"><span class="tsv-profStatLabel">Sillage</span><span class="tsv-profStatVal">' + escapeHtml(String(prof.sillage)) + '</span></div>';
    if (stats) out += '<div class="tsv-profStats">' + stats + '</div>';
    return out ? '<div class="tsv-scentProfile">' + out + '</div>' : '';
  }

  function tsvLoadPerception(product, slot) {
    if (!slot) return;
    slot.innerHTML = '<div class="tsv-rec__perceptionLoading">Reading the room, one second.</div>';
    var endpoint = CFG.endpoint;
    if (!endpoint) { slot.innerHTML = ''; return; }
    var url = endpoint.replace(/\/chat\/?$/, '/perception');
    if (url === endpoint) url = endpoint + '/perception';
    var body = {
      product_id: String(product.id || product.product_id || ''),
      title:      String(product.title || ''),
      vendor:     String(product.vendor || ''),
      notes:      Array.isArray(product.notes) ? product.notes.join(',') : String(product.notes || '')
    };
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.ok) { slot.innerHTML = ''; return; }
        var html = '';
        if (data.profile)    html += _tsvRenderProfile(data.profile);
        if (data.perception) html += _tsvRenderPerception(data.perception);
        slot.innerHTML = html;
      })
      .catch(function () { slot.innerHTML = ''; });
  }
  function _tsvRenderPerception(perc) {
    function scoreRow(label, score, note) {
      if (score === null || score === undefined) return '';
      var s = Math.max(1, Math.min(10, parseInt(score, 10) || 5));
      var pct = (s / 10) * 100;
      return '<div class="tsv-perc__scoreRow">'
        + '<div class="tsv-perc__scoreLabel">' + escapeHtml(label) + '</div>'
        + '<div class="tsv-perc__bar"><div class="tsv-perc__barFill" style="width:' + pct + '%"></div></div>'
        + '<div class="tsv-perc__scoreVal">' + s + '/10</div>'
        + (note ? '<div class="tsv-perc__scoreNote">' + escapeHtml(String(note)) + '</div>' : '')
        + '</div>';
    }
    var head = '<div class="tsv-perc__head">'
      + '<div class="tsv-perc__title">HOW IT WEARS</div>'
      + '<div class="tsv-perc__subtitle">A short character read on this bottle</div>'
      + '</div>';
    // Numeric scores (longevity/sillage/compliments) removed: too easily read as
    // measured community metrics when they are AI-summarised opinion. Keep the
    // scoreRow helper defined above but never call it. Season / audience chips,
    // best_worn, skin_story, and the verdict paragraph carry the profile.
    var scores = '';
    var chips = '';
    if (perc.season || perc.audience) {
      chips = '<div class="tsv-perc__chips">'
        + (perc.season   ? '<span class="tsv-perc__chip">' + escapeHtml(perc.season) + '</span>' : '')
        + (perc.audience ? '<span class="tsv-perc__chip">' + escapeHtml(perc.audience) + '</span>' : '')
        + (perc.signature_worthy ? '<span class="tsv-perc__chip tsv-perc__chip--signature">Signature-worthy</span>' : '')
        + '</div>';
    }
    // Label + value each get their own block-level element so the CSS
    // can stack them cleanly and centre them without fighting the
    // anonymous text node the old span+text markup created.
    var lines = '';
    if (perc.best_worn) {
      lines += '<div class="tsv-perc__line">' +
                 '<div class="tsv-perc__lineLabel">Best worn</div>' +
                 '<div class="tsv-perc__lineValue">' + escapeHtml(perc.best_worn) + '</div>' +
               '</div>';
    }
    if (perc.skin_story) {
      lines += '<div class="tsv-perc__line">' +
                 '<div class="tsv-perc__lineLabel">On skin</div>' +
                 '<div class="tsv-perc__lineValue">' + escapeHtml(perc.skin_story) + '</div>' +
               '</div>';
    }
    var verdict = perc.verdict
      ? '<div class="tsv-perc__verdict">' + escapeHtml(perc.verdict) + '</div>'
      : '';
    var signature = (perc.signature_worthy && perc.signature_reason)
      ? '<div class="tsv-perc__signature">' + escapeHtml(perc.signature_reason) + '</div>'
      : '';
    return head + scores + chips + lines + verdict + signature;
  }

  // ==== Feature 18: intelligent barcode scanner =============================
  // Opens a camera modal that scans EAN/UPC barcodes using the native
  // BarcodeDetector API. On scan, calls /barcode-lookup which returns either
  // the matching in-stock product with full note + community breakdown, or
  // an AI-identified fallback with three similar in-stock alternatives.
  function tsvBarcodeSupported() {
    return (typeof window.BarcodeDetector === 'function')
      && !!navigator.mediaDevices
      && !!navigator.mediaDevices.getUserMedia;
  }
  function tsvOpenBarcodeScanner() {
    if (!tsvFeatOn('barcodeScanner')) return;
    if (!tsvBarcodeSupported()) {
      // Explicit device-specific guidance so the customer knows why the
      // scanner is not opening. iOS Chrome / Firefox / Edge all use
      // WKWebView which blocks the BarcodeDetector API — only iOS Safari
      // 17+ has it. Android Chrome supports it. Older browsers on any OS
      // will hit this same fallback.
      var ua = String(navigator.userAgent || '');
      var isIOS = /iP(hone|od|ad)/.test(ua);
      var isIOSChrome = isIOS && /CriOS|FxiOS|EdgiOS/.test(ua);
      var msg;
      if (isIOSChrome) {
        msg = T('cg_scan_safari_only', 'The camera scanner only works in Safari on iPhone, not in Chrome or other iOS browsers (Apple blocks camera access there). Copy the current page URL and open it in Safari to scan.');
      } else if (isIOS) {
        msg = T('cg_scan_ios_old', 'Your iOS version does not support in-browser barcode scanning yet. Update iOS to version 17 or later, then reopen this page in Safari.');
      } else {
        msg = T('cg_scan_no_camera', 'This browser cannot access the camera for barcode scanning. Try Safari on iPhone (17+) or Chrome on Android. You can also type the fragrance name and I will find it for you.');
      }
      appendConcierge(msg, true);
      return;
    }
    var modal = document.createElement('div');
    modal.className = 'tsv-scan';
    modal.innerHTML = ''
      + '<div class="tsv-scan__box">'
      +   '<div class="tsv-scan__header">'
      +     '<div class="tsv-scan__title">POINT AT ANY FRAGRANCE BARCODE</div>'
      +     '<button type="button" class="tsv-scan__close" aria-label="Close scanner">&times;</button>'
      +   '</div>'
      +   '<div class="tsv-scan__viewport">'
      +     '<video class="tsv-scan__video" autoplay playsinline muted></video>'
      +     '<div class="tsv-scan__reticle"></div>'
      +   '</div>'
      +   '<div class="tsv-scan__status">Looking for a barcode.</div>'
      + '</div>';
    document.body.appendChild(modal);
    var videoEl  = modal.querySelector('.tsv-scan__video');
    var statusEl = modal.querySelector('.tsv-scan__status');
    var closeBtn = modal.querySelector('.tsv-scan__close');
    var stream = null;
    var scanning = true;
    var detector;
    try { detector = new window.BarcodeDetector({ formats: ['ean_13', 'ean_8', 'upc_a', 'upc_e'] }); }
    catch (_) { detector = new window.BarcodeDetector(); }
    function shutdown() {
      scanning = false;
      try { if (stream) stream.getTracks().forEach(function (t) { t.stop(); }); } catch (_) {}
      try { if (modal.parentNode) modal.parentNode.removeChild(modal); } catch (_) {}
    }
    closeBtn.addEventListener('click', shutdown);
    modal.addEventListener('click', function (e) { if (e.target === modal) shutdown(); });
    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } })
      .then(function (s) {
        stream = s;
        videoEl.srcObject = s;
        return videoEl.play();
      })
      .then(function () {
        function loop() {
          if (!scanning) return;
          detector.detect(videoEl).then(function (results) {
            if (!scanning) return;
            if (results && results.length) {
              var raw = String(results[0].rawValue || '').trim();
              if (/^\d{8,14}$/.test(raw)) {
                statusEl.textContent = T('cg_got_it_looking_up','Got it. Looking up ') + raw + '.';
                shutdown();
                tsvHandleBarcodeResult(raw);
                return;
              }
            }
            setTimeout(loop, 250);
          }).catch(function () { setTimeout(loop, 400); });
        }
        loop();
      })
      .catch(function () {
        statusEl.textContent = T('cg_scan_permission_denied', 'Camera permission was declined. Enable camera access in your browser settings.');
        setTimeout(shutdown, 3000);
      });
  }
  function tsvHandleBarcodeResult(ean) {
    var endpoint = CFG.endpoint;
    if (!endpoint) return;
    var url = endpoint.replace(/\/chat\/?$/, '/barcode-lookup');
    if (url === endpoint) url = endpoint + '/barcode-lookup';
    appendUser(T('cg_scanned_barcode','Scanned barcode ') + ean);
    beforeChipRequest(T('cg_scanned_barcode','Scanned barcode ') + ean);
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ean: ean,
        session_id: sessionId,
        customer_id: (CFG.customer && CFG.customer.id) || ''
      })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        afterChipRequest();
        if (!data || !data.ok) {
          appendConcierge(T('cg_scan_unreadable', 'I could not read that barcode. Try again with better lighting, or type the fragrance name.'), true);
          return;
        }
        if (data.matched && data.product) {
          var p = data.product;
          appendConcierge(T('cg_found_it','Found it. ') + p.title + ' by ' + p.vendor + T('cg_is_in_stock_now',' is in stock right now.'), true);
          appendProducts([p]);
          if (data.similar && data.similar.length) {
            tsvChainPause(2000);
            appendConcierge(T('cg_scan_close_options', 'If you want to see other options in the same profile, here are three close ones from our shelves:'), true);
            appendProducts(data.similar);
            tsvChainPause(1500);
            appendConcierge('Or if you want to sample a curated flight of six scents built around similar notes, our Discovery Collection lets you wear them for a week each. [Explore the Discovery Collection](/pages/discovery-collection-launch)', true);
          }
        } else if (data.ai_guess && data.ai_guess.title) {
          appendConcierge(T('cg_scan_recognised_not_stocked', 'We do not stock that exact one, but I recognised it. That barcode reads as ') + data.ai_guess.title + (data.ai_guess.vendor ? ' by ' + data.ai_guess.vendor : '') + '.', true);
          if (data.similar && data.similar.length) {
            tsvChainPause(1500);
            appendConcierge(T('cg_three_share_profile','Here are three we stock that share its profile:'), true);
            appendProducts(data.similar);
            tsvChainPause(1500);
            appendConcierge('Or start with our Discovery Collection to try six curated scents built around similar notes. [Explore the Discovery Collection](/pages/discovery-collection-launch)', true);
          } else {
            tsvChainPause(700);
            appendConcierge(T('cg_tell_me_note_or_mood','Tell me a note or mood you liked about it and I will find something close.'), true);
          }
        } else {
          appendConcierge(T('cg_scan_unknown', 'We do not stock that one, and I could not identify it from the barcode alone. Tell me the name and I will find something close.'), true);
        }
        appendChips([T('cg_chip_similar_picks',chipT('','cg_chip_similar_picks','Show me similar picks')), T('cg_chip_scan_another',chipT('scan_another','cg_chip_scan_another','Scan another')), T('cg_chip_about_a_note',chipT('','cg_chip_about_a_note','Tell me about a note'))], true);
        saveSnapshotWhenIdle();
      })
      .catch(function () {
        afterChipRequest();
        appendConcierge(T('cg_lookup_failed','The lookup failed just now. Try again in a moment.'), true);
      });
  }

  // ==== Feature 28: signature scent finder =================================
  function tsvOpenSignatureFinder() {
    if (!tsvFeatOn('signatureFinder')) return;
    var state = { step: 0 };
    var wrap = document.createElement('div');
    wrap.className = 'tsv-msg tsv-msg--concierge';
    wrap.style.borderLeftColor = 'var(--tsv-ivory)';
    messagesEl.appendChild(wrap);
    try { messagesEl.scrollTop = messagesEl.scrollHeight; } catch (_) {}
    var STEPS = [
      { key: 'when',     q: T('cg_sig_q_when','When would you wear your signature most?'),           options: ['Day, all day', T('cg_sig_a_evenings','Evenings out'), 'Work, professional', T('cg_sig_a_weekends','Weekends and casual')] },
      { key: 'presence', q: T('cg_sig_q_project','Do you want it to project or stay close to skin?'),   options: [T('cg_sig_a_announce','Announce me in the room'), T('cg_sig_a_between','Somewhere in between'), T('cg_sig_a_skin_close','Skin-close and personal')] },
      { key: 'style',    q: 'Familiar and easy, or distinctive and memorable?',   options: ['Familiar, well-loved', T('cg_sig_a_bit_of_both','A bit of both'), 'Distinctive, memorable'] },
      { key: 'temp',     q: T('cg_sig_q_warm_cool','Warm and cosy or cool and crisp?'),                   options: [T('cg_sig_a_warm_cosy','Warm and cosy'), 'Balanced', T('cg_sig_a_cool_crisp','Cool and crisp')] },
      { key: 'sweet',    q: T('cg_sig_q_sweet_dry','Sweet-leaning or dry?'),                              options: [T('cg_sig_a_touch_sweet','A touch sweet'), 'Neither', T('cg_sig_a_dry_structured','Dry and structured')] },
      { key: 'budget',   q: T('cg_sig_q_budget','Budget for the bottle?'),                             options: ['Under 80 euro', '80 to 150 euro', '150 to 250 euro', T('cg_gift_a_250_plus','250 euro plus')] }
    ];
    function render() {
      var st = STEPS[state.step];
      wrap.innerHTML = '<div style="font-size:12px;letter-spacing:0.06em;text-transform:uppercase;color:var(--tsv-muted);margin-bottom:4px">Signature Finder ' + (state.step + 1) + ' / ' + STEPS.length + '</div>' +
                       '<div style="font-size:13px;line-height:1.55;margin-bottom:10px">' + escapeHtml(st.q) + '</div>' +
                       '<div class="tsv-chips" style="margin:0"></div>';
      var chipsEl = wrap.querySelector('.tsv-chips');
      st.options.forEach(function (opt) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'tsv-chip'; b.textContent = opt;
        b.addEventListener('click', function () {
          state[st.key] = opt;
          if (state.step < STEPS.length - 1) { state.step += 1; render(); } else { finish(); }
        });
        chipsEl.appendChild(b);
      });
      try { messagesEl.scrollTop = messagesEl.scrollHeight; } catch (_) {}
    }
    function finish() {
      var line = 'SIGNATURE FINDER: worn most ' + state.when.toLowerCase() +
                 ', projection: ' + state.presence.toLowerCase() +
                 ', style: ' + state.style.toLowerCase() +
                 ', temperature: ' + state.temp.toLowerCase() +
                 ', sweetness: ' + state.sweet.toLowerCase() +
                 ', budget: ' + state.budget.toLowerCase() +
                 '. Give me exactly one signature recommendation.';
      try { wrap.parentNode && wrap.parentNode.removeChild(wrap); } catch (_) {}
      appendUser(T('cg_chip_signature', 'Find my signature scent'));
      submitDirect(line, { is_signature_query: true });
    }
    render();
  }

  // Route typed inputs through the same intent handlers the chips use.
  // Keeps behaviour consistent whether the user clicks a chip or types the
  // phrase (or a near-variant) into the input.
  function detectAndRouteIntent(text) {
    var t = String(text || '').trim().toLowerCase().replace(/[?.!]+$/, '');
    // SIGN IN / LOG IN. Open the inline login form directly instead of letting
    // the phrase hit the AI (which was wrongly deflecting "sign in" to the
    // contact form and showing fragrance-picking statuses). Covers the bare
    // phrase, natural variants ("i want to sign in", "let me log in", "how do
    // i sign in"), and short sign-in-ish messages. Uses a letters-only copy so
    // punctuation never blocks the match. "sign up" / "signing up" do NOT match.
    var _si = t.replace(/[^a-z ]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (/^(sign ?in|log ?in|signin|login|sign me in|log me in)$/.test(_si) ||
        /\b(want|wanna|need|like|let me|help me|how do i|how can i|can i|could i|please|id like|i d like)\b[^.]*\b(sign ?in|log ?in|signin|login)\b/.test(_si) ||
        (/\b(sign ?in|log ?in|signin|login)\b/.test(_si) && _si.length <= 26)) {
      removeChips();
      appendUser(text);
      showLoginForm();
      return true;
    }
    // Daily-wear picker: "what should I wear today / tonight", "daily wear",
    // "what fragrance should I wear to work", etc. Routes to the worker's
    // DAILY WEAR rule so it picks in-stock scents for today's season/occasion.
    if (/\bwhat\s+(should|shall|do|can)\s+i\s+wear\b/.test(t) ||
        /\b(what|which)\s+(fragrance|scent|perfume|cologne)\s+(should|shall|do|can)\s+i\s+wear\b/.test(t) ||
        /\bdaily[\s-]?wear\b/.test(t) ||
        /\bwear\s+(today|tonight|tomorrow|to\s+work|to\s+the\s+office|on\s+a\s+date|to\s+the\s+gym|out\s+tonight)\b/.test(t) ||
        /\b(pick|choose|suggest|help me pick)\b[^.]*\b(scent|fragrance|perfume|cologne)\b[^.]*\b(today|tonight|for\s+the\s+day|for\s+work|for\s+tonight)\b/.test(t) ||
        /^what\s+to\s+wear\b/.test(t)) {
      removeChips();
      appendUser(text);
      _tsvPendingQuery = text;
      submitDirect('DAILY WEAR: ' + text, { is_daily_query: true });
      return true;
    }
    // Feature 5: gift flow triggers.
    if (tsvFeatOn('giftingMode') && (
        /^help me buy a gift$/i.test(t) ||
        /^gift for /i.test(t) ||
        /^i (want|need) to buy a gift/i.test(t) ||
        /^buy(ing)? a gift/i.test(t)
      )) {
      removeChips();
      appendUser(text);
      tsvOpenGiftFlow();
      return true;
    }
    // Feature 2: fragrance shelf triggers.
    if (tsvFeatOn('wardrobeView') && (
        /^(my )?(fragrance )?shelf$/i.test(t) ||
        /^show me my (fragrance )?shelf$/i.test(t) ||
        /^(open|view|see) my (fragrance )?shelf$/i.test(t) ||
        /^what.?s on my shelf$/i.test(t) ||
        /^(my )?(fragrance )?collection$/i.test(t)
      )) {
      removeChips();
      appendUser(text);
      tsvOpenShelf();
      return true;
    }
    // Feature 28: signature scent finder triggers.
    if (tsvFeatOn('signatureFinder') && (
        /^find my signature( scent)?$/i.test(t) ||
        /^(help me find|what is) my signature( scent)?$/i.test(t) ||
        /^signature scent$/i.test(t)
      )) {
      removeChips();
      appendUser(text);
      tsvOpenSignatureFinder();
      return true;
    }
    // Feature 9: note deep-dive triggers. Widened to catch common typos
    // and looser phrasings — the strict "tell me" regex missed "tell em",
    // "tellme", and messages ending with "note" but no verb prefix like
    // "the oud note". Any of the trigger verbs + a plausible note-length
    // phrase now routes to the deep-dive card.
    if (tsvFeatOn('noteDeepDive')) {
      var noteName = null;
      // Verb-led: "tell me / tell em / tellme / what is / describe / explain / more about" + note
      var vm = t.match(/^(?:tell\s*[ea]m|tell\s*me|tellme|what(?:'?s|\s+is|\s+does)|explain|describe|more\s+about|deep\s+dive\s+(?:on|into)|learn(?:\s+me)?\s+about)\s+(?:the\s+note\s+|the\s+|a\s+|about\s+)?([a-z][a-z '-]{1,29}?)(?:\s+note)?[.?!]?$/i);
      if (vm) noteName = vm[1];
      // Bare noun form: "oud note", "the oud note", "note: oud"
      if (!noteName) {
        var vm2 = t.match(/^(?:the\s+)?([a-z][a-z '-]{1,29}?)\s+note[.?!]?$/i)
                 || t.match(/^note[:\-\s]+([a-z][a-z '-]{1,29}?)[.?!]?$/i);
        if (vm2) noteName = vm2[1];
      }
      if (noteName) {
        noteName = String(noteName).trim().replace(/\s+/g, ' ');
        // Filter out common verbs / articles that slipped through so we
        // don't route "tell me about it" to a phantom "it" note.
        var stopwords = /^(it|this|that|these|those|them|us|me|you|him|her|the|a|an)$/i;
        if (noteName.length >= 3 && noteName.length <= 30 && !stopwords.test(noteName)) {
          removeChips();
          appendUser(text);
          tsvNoteDeepdive(noteName, { skipUserAppend: true });
          return true;
        }
      }
    }

    // -----------------------------------------------------------------
    // LOYALTY / POINTS / VAULT / TIER / REWARDS
    // Any query that mentions the customer's points, tier, rewards,
    // vault, or the loyalty programme, in any natural-language shape.
    // Routes to /loyalty so the customer sees their real balance +
    // rewards ladder instead of the AI giving generic prose.
    // -----------------------------------------------------------------
    if (/^(my\s+)?(points?|loyalty|rewards?|vault)\s+(balance|status)?$/.test(t) ||
        /\b(loyalty|reward|members?)\s+points?\b/.test(t) ||
        /\bpoints?\s+balance\b/.test(t) ||
        /\bmy\s+(loyalty|reward|member|members|vault|tier|points?|rewards?)\b/.test(t) ||
        /\b(what|whats|what'?s|hows|how'?s|which)\s+(are|is)?\s*(my\s+)?(loyalty|reward|member|members|vault|tier|point|points|rewards?|balance)\b/.test(t) ||
        /\bhow\s+(much|many)\s+(loyalty\s+|reward\s+|member\s+)?points?\b/.test(t) ||
        /\bdo\s+i\s+have\s+(any\s+)?(points?|rewards?|discounts?|codes?|perks?)\b/.test(t) ||
        /\b(check|see|view|show|find|open|display|tell me about|tell me|pull up|give me|bring up|get me)\s+(me\s+)?(my\s+)?(loyalty|reward|point|points|members?|vault|balance|tier|perks?|discounts?|codes?)\b/.test(t) ||
        /\b(members?\s+vault|vault\s+status|vault\s+card|tier\s+status|tier\s+am\s+i|what\s+tier|which\s+tier|next\s+tier|current\s+tier)\b/.test(t) ||
        /\btell\s+me\s+about\s+the\s+(rewards?|loyalty|vault|points?|programme|program|tier|tiers|ladder)\b/.test(t) ||
        /\b(how|where)\s+do\s+i\s+(redeem|claim|use|spend)\b/.test(t) ||
        /\b(rewards?|points?)\s+ladder\b/.test(t) ||
        /\benough\s+points?\b/.test(t) ||
        /\bpoints?\s+(do|would|will|have|left)\s+i\b/.test(t) ||
        /\b(what|which|any)\s+(rewards?|discounts?|perks?|codes?)\b/.test(t) ||
        /\brewards?\s+(can|do|would|will|are|am)\s+i\b/.test(t) ||
        /\bwhat\s+can\s+i\s+(get|claim|redeem|use|buy with)\b/.test(t) ||
        /^redeem\b/.test(t) ||
        /^(how|what).*to\s+(earn|get|collect)\s+(more\s+)?points?\b/.test(t) ||
        /\bhow\s+do\s+i\s+(join|sign up for|become)\s+(the\s+)?(loyalty|vault|rewards|programme|program|members?)\b/.test(t) ||
        /\b(loyalty|reward|vault|tier|points?)\s+balance\b/.test(t) ||
        /\breward\s+(is\s+)?available\b/.test(t) ||
        /\bam\s+i\s+a\s+member\b/.test(t)) {
      handleLoyaltyChip(text);
      return true;
    }

    // -----------------------------------------------------------------
    // TRACKING / SHIPPING STATUS / DELIVERY OF AN EXISTING ORDER
    // Order in flight — where is it, when will it arrive, etc.
    // Check this BEFORE the general order-lookup so "where is my
    // order" hits the tracking card first.
    // -----------------------------------------------------------------
    if (/^(track|where is|where'?s|whereabouts of|status of|shipping status|delivery status|when will i get)\s+(my\s+)?(latest|last|recent|old|past|previous|older)?\s*(order|orders|parcel|parcels|package|packages|shipment|shipments|delivery|deliveries)\b/.test(t) ||
        /^tracking(\s+(number|info|link|details))?$/.test(t) ||
        /^(where'?s|where is|whereabouts is|whereabouts of)\s+my\s+(latest|last|recent|old|past|previous|older)?\s*(order|parcel|package|delivery|shipment|box)\b/.test(t) ||
        /\bhas\s+my\s+(order|parcel|package|shipment|delivery)\s+(shipped|dispatched|left|arrived|been sent|been posted|gone out|been picked up)\b/.test(t) ||
        /\bwhen\s+(will|does|is)\s+my\s+(order|parcel|package|shipment|delivery)\s+(arrive|come|get here|be here|show up|be delivered|ship|dispatch)\b/.test(t) ||
        /\b(is|has)\s+my\s+(order|parcel|package|shipment)\s+(out for delivery|arrived|delivered|on the way|coming|shipping|shipped|dispatched)\b/.test(t) ||
        /\b(estimated|expected)\s+(delivery|arrival|shipping)\s+(date|time)\b/.test(t) ||
        /\bdelivery\s+(status|update|eta|estimate|time|date)\b/.test(t) ||
        /\btracking\s+(number|info|details|link|status|code)\b/.test(t) ||
        /\bwhen\s+(will|does|is)\s+it\s+(arrive|come|get here|show up|ship)\b/.test(t) ||
        /\bstill\s+waiting\s+for\s+my\s+(order|parcel|package|delivery|shipment)\b/.test(t) ||
        /\bmy\s+(order|parcel|package|delivery|shipment)\s+(hasn'?t|has\s+not|still\s+hasn'?t)\s+(arrived|come|shown\s+up|turned\s+up|been\s+delivered)\b/.test(t) ||
        /\border\s+status\b/.test(t)) {
      handleTrackChip(text);
      return true;
    }

    // -----------------------------------------------------------------
    // ORDER LOOKUP / ORDER HISTORY / WHAT DID I BUY
    // Any free-text order query. Always hits /order-lookup so real
    // data shows up instead of the AI escalating to an email form.
    // -----------------------------------------------------------------
    if (/^orders?$/.test(t) ||
        /^my orders?$/.test(t) ||
        /^(my\s+)?(latest|last|recent|newest|previous|current|past|older|old)\s+orders?$/.test(t) ||
        /^(all|view|show|see|open|display|check|find|give|get|bring|fetch|pull|grab|look up|lookup|tell me about|tell me)\s+(me\s+)?(all\s+)?(my\s+)?(all\s+)?(latest|last|recent|current|past|previous|old)?\s*orders?\b/.test(t) ||
        /^order\s+(details|status|info|information|history|summary|list)$/.test(t) ||
        /^(my\s+)?order\s+history$/.test(t) ||
        /^past orders?$/.test(t) ||
        /\bwhat\s+did\s+i\s+(buy|order|get|purchase)\b/.test(t) ||
        /\bwhat\s+have\s+i\s+(ordered|bought|purchased|got)\b/.test(t) ||
        /\bwhat\s+(was|is)\s+in\s+my\s+(last|latest|recent|previous)\s+order\b/.test(t) ||
        /\bshow\s+me\s+my\s+(last|latest|recent|previous|old|past)\s+orders?\b/.test(t) ||
        /\bmy\s+recent\s+purchase(s)?\b/.test(t) ||
        /\bmy\s+(order|purchase|receipt|invoice)\b/.test(t) ||
        /\bmy\s+account\s+(orders?|purchases?|history)\b/.test(t) ||
        /\bdid\s+i\s+order\b/.test(t) ||
        /\bcan\s+(i|you)\s+(see|check|show|find)\s+my\s+orders?\b/.test(t) ||
        /\bi\s+want\s+to\s+(see|check|view)\s+my\s+orders?\b/.test(t) ||
        /\bhow\s+many\s+orders\s+have\s+i\b/.test(t) ||
        /\bmy\s+(past|previous|old|older)\s+orders?\b/.test(t) ||
        /\bwhat\s+was\s+my\s+(last|latest|previous)\s+order\b/.test(t) ||
        /\bwhat\s+have\s+i\s+ordered\s+before\b/.test(t) ||
        /\blook\s+up\s+my\s+orders?\b/.test(t)) {
      handleOrderLookupChip(text);
      return true;
    }

    // -----------------------------------------------------------------
    // "SIMILAR TO MY LAST ORDER" — compound flow
    // Fetches the most recent order, extracts the fragrance, then runs
    // /similar. Signed-in only; anon customers fall through to /chat.
    // -----------------------------------------------------------------
    var wantsSimilarToOrder =
      /^(similar to|based on|like|recommend .*(like|based on|similar to))\s+.*(my\s+)?(last|latest|recent|previous|old|past)\s+order/i.test(t) ||
      /\blike\s+what\s+i\s+(ordered|bought|got|purchased)\b/i.test(t) ||
      /\bsimilar\s+to\s+what\s+i\s+(ordered|bought|got|purchased)\b/i.test(t) ||
      /\bmore\s+(like|of)\s+(what|the one|the fragrance)\s+i\s+(ordered|bought|got)\b/i.test(t) ||
      /\brecommend\s+(me\s+)?(something\s+)?(like|similar to|based on)\s+(my\s+)?(last|latest|recent|past)\s+order\b/i.test(t);
    if (wantsSimilarToOrder) {
      var isSignedIn = !!(CFG.customer && (CFG.customer.email || CFG.customer.id));
      if (isSignedIn) {
        handleSimilarToLastOrder(text);
        return true;
      }
    }

    // -----------------------------------------------------------------
    // SALES / DEALS / DISCOUNTS / OFFERS
    // -----------------------------------------------------------------
    if (/^what('?s| is|s)\s+on\s+sale(\s+(this\s+week|right now|today|currently|at the moment|now))?$/.test(t) ||
        /^show me (the )?(current |any )?(sales?|deals?|discounts?|offers?|promotions?)\b/.test(t) ||
        /^(any|are there|got any|have you got any)\s+(sales?|deals?|discounts?|offers?|promotions?)\b/.test(t) ||
        /\bon\s+sale\s+(this\s+week|right now|today|currently|now)\b/.test(t) ||
        /^what('?s| is)\s+(the\s+)?(current\s+)?(sales?|deals?|discounts?|offers?|promotions?)\b/.test(t) ||
        /^sales?$/.test(t) ||
        /^deals?$/.test(t) ||
        /^discounts?$/.test(t) ||
        /^offers?$/.test(t) ||
        /^promotions?$/.test(t) ||
        /^clearance\b/.test(t) ||
        /\b(anything|what)\s+(is\s+)?(on\s+)?(sale|discounted|reduced)\b/.test(t) ||
        /\bshow\s+me\s+(what('?s| is)\s+)?(on\s+)?(sale|discount|reduced|clearance)\b/.test(t) ||
        /\bwhat\s+(fragrances?|perfumes?|scents?|colognes?)\s+are\s+on\s+sale\b/.test(t)) {
      handleBestsellersChip(text, { on_sale: true });
      return true;
    }

    // -----------------------------------------------------------------
    // BESTSELLERS / PICK FOR ME / SURPRISE ME / RECOMMENDATIONS
    // Anything asking for a general pick without a specific brand/note.
    // -----------------------------------------------------------------
    if (/^pick\s+(something\s+)?(new\s+)?(for\s+me)?$/.test(t) ||
        /^surprise\s+me\b/.test(t) ||
        /^recommend(\s+(me\s+)?(something|a scent|a fragrance|a perfume|a cologne))?$/.test(t) ||
        /^what\s+should\s+i\s+(try|get|buy|wear)\b/.test(t) ||
        /^what('?s| is)\s+(popular|trending|hot|new|best)\b/.test(t) ||
        /^what('?s| is)\s+your\s+(best|top|most popular|favourite|favorite)\b/.test(t) ||
        /^bestsellers?\b/.test(t) ||
        /^top\s+sellers?\b/.test(t) ||
        /^most\s+popular\b/.test(t) ||
        /^what('?s| is)\s+new\b/.test(t) ||
        /^new\s+in\b/.test(t) ||
        /^new\s+(arrivals?|releases?|launches?)\b/.test(t) ||
        /\b(help\s+me\s+(choose|pick|decide|find))\b/.test(t) ||
        /\bcan\s+you\s+(pick|choose|recommend|suggest)\s+(something|one|a scent|a fragrance)\b/.test(t) ||
        /\bi\s+don'?t\s+know\s+what\s+to\s+(get|try|buy)\b/.test(t) ||
        /\bany\s+(recommendations?|suggestions?)\b/.test(t)) {
      handleBestsellersChip(text, {});
      return true;
    }

    // -----------------------------------------------------------------
    // CONTACT TEAM / SPEAK TO HUMAN / CUSTOMER SUPPORT
    // Widened but kept specific — must actually signal "reach a person"
    // so we do not hijack "help me pick a scent" (bestsellers) or
    // "help me find a birthday gift" (discovery chat).
    // -----------------------------------------------------------------
    if (/^(speak|talk|chat|connect)\s+(to\s+)?(a\s+)?(human|team|support|someone|agent|person|advisor|assistant|representative|colleague|expert)\b/.test(t) ||
        /^contact\s+(the\s+)?(team|support|customer\s+service|customer\s+support|you|us)\b/.test(t) ||
        /^(email|message)\s+(the\s+)?(team|support|you|customer\s+service|customer\s+support)\b/.test(t) ||
        /^(customer\s+)?(service|support)\s+(please|contact|help)\b/.test(t) ||
        /^customer\s+(service|support|care)$/.test(t) ||
        /^(i|we)\s+(need|want|would like)\s+to\s+(speak|talk|chat|contact|reach)\s+(to\s+)?(a\s+|the\s+)?(human|someone|a person|the team|support|customer service|an agent|advisor)\b/.test(t) ||
        /\bcan\s+i\s+(speak|talk|chat|contact)\s+(to\s+)?(a\s+|the\s+)?(human|someone|a person|the team|support|customer service|an agent)\b/.test(t) ||
        /\breal\s+person\b/.test(t) ||
        /\breach\s+(the\s+)?(team|support|customer\s+service)\b/.test(t) ||
        /\bfile\s+(a\s+)?complaint\b/.test(t) ||
        /\bmake\s+(a\s+)?complaint\b/.test(t) ||
        /^raise\s+(an? )?(issue|complaint|ticket)\b/.test(t) ||
        /\b(refund|return|exchange|replacement|missing|damaged|broken|wrong item|wrong order|faulty|leaking|smashed|delivery issue|shipping issue|billing issue|payment issue|charged twice|overcharged)\b/.test(t)) {
      showContactForm(text);
      return true;
    }

    // -----------------------------------------------------------------
    // FRAGRANCE TWIN FINDER (typed) e.g. "closest to Baccarat Rouge
    // under €80", "dupe for Sauvage below 60", "twin of Aventus for
    // less than 100". Parses the reference fragrance + price ceiling
    // and hits /similar with a max_price filter.
    // -----------------------------------------------------------------
    var twinMatch = t.match(/^(?:closest (?:match )?(?:to)|(?:the )?twin (?:of|for)|dupes? (?:of|for)|alternative (?:to)|find (?:me )?something like)\s+(.+?)\s+(?:under|below|less than|no more than|max(?:imum)?|not more than|for less than|for under|cheaper than)\s+.?€?\s?(\d+(?:\.\d{1,2})?)/);
    if (tsvFeatOn('twinFinder') && twinMatch) {
      var twinRef = twinMatch[1].trim().replace(/^(?:a |an |the )/, '');
      var twinMax = parseFloat(twinMatch[2]);
      handleFragranceTwin(text, twinRef, twinMax);
      return true;
    }

    // -----------------------------------------------------------------
    // SIMILAR TO X (typed) e.g. "similar to Baccarat Rouge"
    // -----------------------------------------------------------------
    if (/^similar to\s+.+/.test(t) ||
        /^something like\s+.+/.test(t) ||
        /^(more\s+)?like\s+.+/.test(t) ||
        /^smells like\s+.+/.test(t) ||
        /^reminds me of\s+.+/.test(t) ||
        /^in the same vein as\s+.+/.test(t) ||
        /^(a\s+)?(cheaper|budget|affordable)\s+version of\s+.+/.test(t) ||
        /^clones?\s+(of|for)\s+.+/.test(t) ||
        /^(any|got any|show me|got anything|anything)\s+(scents?|fragrances?|perfumes?|colognes?)\s+like\s+.+/.test(t) ||
        /^dupes?\s+(of|for)\s+.+/.test(t) ||
        /^alternative\s+to\s+.+/.test(t)) {
      var ref = t.replace(/^(similar to|something like|smells like|reminds me of|in the same vein as|(a )?(cheaper|budget|affordable) version of|clones? of|clones? for|more like|like|dupes? of|dupes? for|alternative to)\s+/, '')
                 .replace(/^(any|got any|show me|got anything|anything)\s+(scents?|fragrances?|perfumes?|colognes?)\s+like\s+/, '');
      handleSimilarChip(text, ref);
      return true;
    }

    // -----------------------------------------------------------------
    // COMPARE A and B / A vs B (typed)
    // -----------------------------------------------------------------
    if (/^compare\s+.+\s+(and|vs\.?|with|to|versus)\s+.+/.test(t) ||
        /^which\s+is\s+better\s+.+\s+(or|vs\.?|versus)\s+.+/.test(t) ||
        /^difference between\s+.+\s+and\s+.+/.test(t) ||
        /^.+\s+versus\s+.+/.test(t) ||
        /^.+\s+vs\.?\s+.+/.test(t) && /\s(vs\.?)\s/.test(t)) {
      handleCompareChip(text);
      return true;
    }

    return false;
  }

  function submit(text) {
    // Strip card numbers, phone numbers, bank/ID details before anything is
    // shown, stored, or sent. The redacted text is what flows on from here.
    var _red = tsvRedactSensitive(text);
    if (_red.redacted) {
      text = _red.clean;
      tsvFlashInput(T('cg_redacted_notice','For your security, sensitive details were removed.'));
    }
    if (tsvDetectProfanity(text)) {
      tsvFlashInput(T('cg_keep_respectful', 'Please keep it respectful.'));
      return;
    }
    // Feature 12: detect explicit language switch commands.
    var langCmd = tsvDetectLangCommand(text);
    if (langCmd) tsvSetSessionLanguage(langCmd);
    if (detectAndRouteIntent(text)) return;
    tsvDismissOnboarding();
    removeChips();
    appendUser(text);
    _tsvPendingQuery = text;
    appendTyping();
    if (sendBtn) sendBtn.disabled = true;

    var endpoint = CFG.endpoint;
    if (!endpoint) {
      setTimeout(function () {
        removeTyping();
        appendConcierge(T('cg_expert_offline', 'The Scent Expert is offline right now. Please try again shortly.'));
        if (sendBtn) sendBtn.disabled = false;
      }, 500);
      return;
    }

    // Streaming path: POST with stream:true, read Response.body as SSE,
    // progressively append tokens to a text bubble, then swap in the fully
    // structured messages (with products and chips) on the 'end' event.
    // Falls back to non-streaming JSON if the browser lacks streams support
    // or the server returns a non-SSE Content-Type.
    var streamingSupported = !!(window.fetch && window.ReadableStream && window.TextDecoder);
    // Streaming disabled: it split the reply into text-now / cards-later which
    // broke the text -> cards -> chips ordering. Non-streaming renders the
    // whole reply in the correct order, then types it out.
    var wantStreaming = false; // was: streamingSupported && !CFG.streamingDisabled && tsvFeatOn('streaming')

    // Await a fresh bag snapshot BEFORE building the body — the worker's
    // system prompt reads shopping_bag to decide whether to say "your bag
    // has X items" vs the empty-state block. If we build the body before
    // /cart.js has resolved (first open, or bag just mutated), the AI
    // wrongly refuses to reference the bag.
    // Refresh the bag on EVERY message, not only cart-shaped ones. The worker
    // can only distinguish "bag is empty" from "bag unknown" when the snapshot
    // is actually fresh, and gating on tsvIsCartQuery meant most turns shipped
    // a stale or never-populated bag. The 2s throttle above keeps this cheap,
    // and /cart.js is Shopify, so it costs nothing on Cloudflare.
    Promise.resolve(tsvRefreshShoppingBag()).catch(function(){ return null; }).then(function () {

    var body = JSON.stringify({
      message: text,
      session_id: sessionId,
      currency: CFG.currency,
      money_format: CFG.moneyFormat,
      shop: CFG.shop,
      locale: CFG.locale,
      session_language: _tsvSessionLang || null,
      page_url: window.location.href,
      customer_id: CFG.customer ? CFG.customer.id : null,
      customer_email: CFG.customer ? CFG.customer.email : null,
      customer_first_name: CFG.customer ? CFG.customer.first_name : null,
      recently_viewed: tsvGetRecentlyViewed(),
      shopping_bag: tsvGetShoppingBag(),
      stream: wantStreaming
    });

    if (wantStreaming) {
      tsvConsumeStream(endpoint, body)
        .then(function (data) { removeTyping(); if(data&&data.ok===false){tsvHandleChatError(new Error('body ok:false'),(data&&data.__res)||null).then(function(m){appendConcierge(m);try{saveSnapshot();}catch(_){}});return;} renderResponse(data); try { saveSnapshot(); } catch (_) {} })
        .catch(function (err) { removeTyping(); tsvHandleChatError(err, (err&&err.res)||null).then(function(msg){appendConcierge(msg); try { saveSnapshot(); } catch (_) {}}); })
        .then(function () { if (sendBtn) sendBtn.disabled = false; });
      return;
    }

    var _tsvLastRes = null;
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body
    })
      .then(function (res) {
        _tsvLastRes = res;
        if (!res.ok) throw new Error('bad status ' + res.status);
        return res.json();
      })
      .then(function (data) {
        removeTyping();
        // If the worker returned 200 but signalled an error in the body,
        // route through the smart error handler instead of feeding a bad
        // payload into renderResponse.
        if (data && data.ok === false) {
          tsvHandleChatError(new Error('body ok:false'), _tsvLastRes).then(function (msg) {
            appendConcierge(msg);
            try { saveSnapshot(); } catch (_) {}
          });
          return;
        }
        // Smoothness sequencer: if this was a streaming response (marked
        // by SSE end handler with __liveBubbleActive), wait for the
        // typewriter to catch up before mounting cards. Otherwise mount
        // immediately (non-streaming replies).
        var _tsvGate = (data && data.__liveBubbleActive && window._tsvTypewriterCatchup)
          ? window._tsvTypewriterCatchup
          : Promise.resolve();
        _tsvGate.then(function () {
          renderResponse(data);
          try { saveSnapshot(); } catch (_) {}
        });
      })
      .catch(function (err) {
        removeTyping();
        tsvHandleChatError(err, _tsvLastRes).then(function (msg) {
          appendConcierge(msg);
          try { saveSnapshot(); } catch (_) {}
        });
      })
      .then(function () {
        if (sendBtn) sendBtn.disabled = false;
      });
    }); // close: Promise.resolve(tsvRefreshShoppingBag()).then(...)
  }

  // SSE consumer for streaming replies. POSTs to /chat with stream:true,
  // reads the response body as an SSE stream, appends a streaming text
  // bubble that fills character-by-character as tokens arrive, then on
  // the 'end' event returns the structured messages so renderResponse
  // can add product cards and follow-up chips. Falls back to a normal
  // JSON response if the server returns non-SSE (e.g. streaming disabled).
  function tsvConsumeStream(endpoint, body) {
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'text/event-stream, application/json' },
      body: body
    }).then(function (res) {
      if (!res.ok) {
        // Attach the response to the error so the smart error handler can
        // read status and body. Otherwise the widget just shows "offline".
        var err = new Error('bad status ' + res.status);
        err.res = res;
        throw err;
      }
      var ct = String(res.headers.get('Content-Type') || '');
      // Not streaming — server refused SSE, fall back to JSON.
      if (ct.indexOf('text/event-stream') === -1) {
        return res.json();
      }
      // Do NOT remove the typing indicator yet. Keep the dots visible
      // for the whole "thinking" gap between the SSE headers arriving
      // and the first real token from Anthropic. The dots + live bubble
      // are swapped lazily inside the token handler below on the first
      // token event.
      var liveBubble = null;
      var streamOpen = true;
      // Smoothness sequencer: don't let renderResponse mount cards until
      // the typewriter has fully caught up to the final text. Expose a
      // promise that renderResponse awaits.
      var typewriterCatchupResolve = null;
      window._tsvTypewriterCatchup = new Promise(function (r) { typewriterCatchupResolve = r; });
      function ensureLiveBubble() {
        if (liveBubble) return liveBubble;
        removeTyping();
        liveBubble = document.createElement('div');
        liveBubble.className = 'tsv-msg tsv-msg--concierge';
        // Dedicated text child so the typewriter updates textContent
        // without wiping the sibling pulse-dot indicator.
        var textEl = document.createElement('span');
        textEl.className = 'tsv-msg__text';
        liveBubble.appendChild(textEl);
        liveBubble._textEl = textEl;
        messagesEl.appendChild(liveBubble);
        try { messagesEl.scrollTop = messagesEl.scrollHeight; } catch (_) {}
        return liveBubble;
      }
      function showPulse() {
        if (!liveBubble || !streamOpen) return;
        if (liveBubble._pulseEl && liveBubble._pulseEl.parentNode === liveBubble) return;
        var pulse = document.createElement('span');
        pulse.className = 'tsv-msg__pulse';
        pulse.innerHTML = '<span></span><span></span><span></span>';
        liveBubble.appendChild(pulse);
        liveBubble._pulseEl = pulse;
      }
      function hidePulse() {
        if (liveBubble && liveBubble._pulseEl && liveBubble._pulseEl.parentNode === liveBubble) {
          liveBubble.removeChild(liveBubble._pulseEl);
        }
        if (liveBubble) liveBubble._pulseEl = null;
      }

      // Typewriter reveal state. Tokens come in chunks from Anthropic
      // (often a word or phrase at a time) which reads janky in a chat
      // UI. We buffer the raw tokens and reveal characters at a smooth
      // fixed cadence for a proper typing feel. We also filter out the
      // [REC:...] and [CHIP:...] structured tags in real time so they
      // never appear as raw text; the product cards and follow-up chips
      // are added by renderResponse on the 'end' event.
      var rawBuffer = '';       // every token received so far, unfiltered
      var displayIndex = 0;     // chars of filtered text currently shown
      var typingTimer = null;
      // Mobile / touch devices get a slightly slower cadence so each
      // rAF paint carries less work and the animation stays smooth
      // instead of accumulating multiple characters per frame (which
      // reads as "words sliding in").
      var _tsvIsTouch = (typeof window.matchMedia === 'function')
        ? window.matchMedia('(pointer: coarse)').matches
        : ('ontouchstart' in window);
      var CHARS_PER_TICK = _tsvIsTouch ? 1 : 2;
      var TICK_MS = _tsvIsTouch ? 22 : 18;
      // Live-format the reveal so paragraph breaks show up as they type.
      // Without this, textContent hides \n\n so paragraphs only appear
      // when the end event swaps to innerHTML — causing a jarring layout
      // jump. Using innerHTML with basic escape + <br> keeps the visual
      // paragraph breaks flowing character by character.
      function _tsvLiveFormat(raw) {
        var safe = String(raw)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');
        return safe.replace(/\n{2,}/g, '<span class="tsv-msg__break"></span>')
                   .replace(/\n/g, '<br>');
      }
      function computeSafeDisplay(text) {
        // Strip complete [REC:...] and [CHIP:...] tags AND the
        // whitespace around them so we don't leave a big empty gap
        // where the tags used to be. Then collapse any run of 3+
        // newlines to just 2 (single blank line max) so paragraphs
        // stay tight.
        var filtered = String(text || '')
          .replace(/[ \t]*\[(REC|CHIP)[^\]]*\][ \t]*\n?/g, '')
          .replace(/\n{3,}/g, '\n\n');
        // If we see an unresolved '[', don't reveal past it because it
        // might be the start of another [REC/CHIP tag we haven't finished
        // receiving. Once the ']' arrives we strip the whole tag.
        var lastOpen = filtered.lastIndexOf('[');
        if (lastOpen !== -1) return filtered.slice(0, lastOpen);
        return filtered;
      }
      function scheduleTick() {
        if (typingTimer || !liveBubble || !liveBubble.parentNode) return;
        typingTimer = setTimeout(function () {
          typingTimer = null;
          if (!liveBubble || !liveBubble.parentNode) return;
          var safeText = computeSafeDisplay(rawBuffer);
          if (displayIndex < safeText.length) {
            // More characters to reveal — hide the pulse and paint.
            hidePulse();
            displayIndex = Math.min(displayIndex + CHARS_PER_TICK, safeText.length);
            var chunk = safeText.slice(0, displayIndex);
            if (liveBubble._textEl) {
              liveBubble._textEl.innerHTML = _tsvLiveFormat(chunk);
            } else {
              liveBubble.innerHTML = _tsvLiveFormat(chunk);
            }
            // rAF-throttled + user-position-aware scroll. Only auto-scroll
            // if the customer is already near the bottom (within 80px). If
            // they scrolled up to re-read, do not fight them. Batched via
            // requestAnimationFrame so iOS Safari does not layout-thrash on
            // every character tick, which is what causes the "words
            // sliding in" mobile jank.
            tsvMaybeStickBottom();
            scheduleTick();
          } else if (streamOpen) {
            // Caught up but stream is still live — show pulse dots so the
            // customer knows more is coming during the between-paragraph gap.
            showPulse();
            tsvMaybeStickBottom();
          } else {
            // Stream is closed AND display has caught up to the full
            // rawBuffer — the typewriter is done. Hide the pulse and
            // resolve the smoothness sequencer so renderResponse can
            // start mounting cards behind us with proper stagger.
            hidePulse();
            // Swap the live-formatted display (which only escapes HTML
            // and adds <br>) for the fully-parsed markdown output. This
            // turns `**Character:** ...` into a proper heading + body
            // instead of leaving raw asterisks in the final bubble.
            try {
              var finalSafe = computeSafeDisplay(rawBuffer);
              if (liveBubble && liveBubble._textEl) {
                liveBubble._textEl.innerHTML = renderMessageText(finalSafe);
              } else if (liveBubble) {
                liveBubble.innerHTML = renderMessageText(finalSafe);
              }
            } catch (_) {}
            // Clear the force-scroll flag now that the typewriter is
            // finished. Card mounts revert to "only stick if near
            // bottom" so a customer who scrolled up to re-read is not
            // yanked back down by every card that lands.
            _tsvTypewriterActive = false;
            if (typewriterCatchupResolve) {
              // Longer settle beat between "text done" and "cards begin
              // arriving" — makes the whole thing feel more considered.
              setTimeout(typewriterCatchupResolve, 900);
              typewriterCatchupResolve = null;
            }
          }
        }, TICK_MS);
      }

      var reader = res.body.getReader();
      var decoder = new TextDecoder();
      var buffer = '';
      var lastEvent = 'message';
      var finalPayload = null;
      function pump() {
        return reader.read().then(function (chunk) {
          if (chunk.done) return finalPayload;
          buffer += decoder.decode(chunk.value, { stream: true });
          var lines = buffer.split('\n');
          buffer = lines.pop() || '';
          for (var i = 0; i < lines.length; i++) {
            var line = lines[i];
            if (!line) { lastEvent = 'message'; continue; }
            if (line.indexOf('event: ') === 0) { lastEvent = line.slice(7).trim(); continue; }
            if (line.indexOf('data: ') !== 0) continue;
            var raw = line.slice(6);
            var data = null;
            try { data = JSON.parse(raw); } catch (_) { continue; }
            if (lastEvent === 'token' && data && typeof data.text === 'string') {
              // First token: swap the dots for the live typing bubble.
              // Every subsequent token just appends to the buffer.
              ensureLiveBubble();
              // Mark the typewriter as actively revealing so
              // tsvMaybeStickBottom force-scrolls on every tick,
              // bypassing the 80px threshold that stops mid-response.
              _tsvTypewriterActive = true;
              rawBuffer += data.text;
              scheduleTick();
            } else if (lastEvent === 'end' && data && Array.isArray(data.messages)) {
              // SMOOTHNESS FIX: do NOT slam the final text into the bubble
              // immediately — that killed the in-progress typewriter, which
              // is why the last paragraph "jumped in fast" while cards
              // arrived on top of it. Instead:
              //   1. Update rawBuffer with the full sanitised final text so
              //      any missed tokens get included as the typewriter
              //      continues to reveal characters at natural cadence.
              //   2. Mark the stream as complete so scheduleTick knows to
              //      hide the pulse when it catches up.
              //   3. Store the non-text messages on finalPayload but do NOT
              //      mount them yet — they'll be mounted only after the
              //      typewriter has fully caught up (see waitForTypewriter
              //      helper below).
              streamOpen = false;
              try {
                var finalText = data.messages
                  .filter(function (m) { return m && m.type === 'text' && m.text; })
                  .map(function (m) { return String(m.text); })
                  .join('\n\n');
                if (finalText && finalText.length > rawBuffer.length) {
                  // Extend rawBuffer so scheduleTick keeps typing to the
                  // real target rather than stopping short.
                  rawBuffer = finalText;
                }
                // ALWAYS ensure a tick is pending so the catchup promise
                // gets a chance to resolve. If display had already caught
                // up during streaming (typingTimer was cleared), we need
                // to trigger one more tick to run the "streamOpen is now
                // false → resolve" branch.
                ensureLiveBubble();
                if (!typingTimer) scheduleTick();
              } catch (_) {}
              var nonText = data.messages.filter(function (m) { return m && m.type !== 'text'; });
              finalPayload = { ok: true, messages: nonText, __liveBubbleActive: true };
              // Persist as soon as we know the final text so a refresh
              // during the typewriter reveal still preserves the reply.
              try { saveSnapshot(); } catch (_) {}
            } else if (lastEvent === 'error' && data && data.error) {
              if (typingTimer) { clearTimeout(typingTimer); typingTimer = null; }
              streamOpen = false;
              _tsvTypewriterActive = false;
              try {
                if (liveBubble && liveBubble.parentNode) {
                  liveBubble.parentNode.removeChild(liveBubble);
                }
              } catch (_) {}
              throw new Error(String(data.error));
            }
          }
          return pump();
        });
      }
      return pump().then(function () { return finalPayload || { ok: false }; });
    });
  }

  try {
    if (window.sessionStorage.getItem('tsv_concierge_reopen') === '1') {
      window.sessionStorage.removeItem('tsv_concierge_reopen');
      setTimeout(function () { open(); }, 250);
    }
  } catch (_) {}

  // T('cg_describe_moment',"Describe a Moment") cross-page hand-off: if the menu stashed a memory
  // prompt before navigating here, open the widget and send it automatically.
  try {
    var _tsvMoment = window.sessionStorage.getItem('tsv_moment_prompt');
    if (_tsvMoment) {
      window.sessionStorage.removeItem('tsv_moment_prompt');
      setTimeout(function () {
        try { open(); } catch (_) {}
        var _inp = document.getElementById('tsvInput');
        var _form = widget && widget.querySelector('[data-tsv-form]');
        if (_inp && _form) {
          _inp.value = _tsvMoment;
          _inp.dispatchEvent(new Event('input', { bubbles: true }));
          _form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      }, 600);
    }
  } catch (_) {}

  try { tsvSetupVoiceInput(); } catch (_) {}
  try { tsvSetupVoiceOutput(); } catch (_) {}

  if (CFG.showHint) {
    var HINT_KEY = 'tsv_concierge_hint_seen';
    var hintSeen = false;
    try { hintSeen = window.sessionStorage.getItem(HINT_KEY) === '1'; } catch (e) {}
    if (!hintSeen) {
      setTimeout(function () {
        if (!widget.classList.contains('is-open')) {
          widget.classList.add('is-hinted');
          setTimeout(function () { widget.classList.remove('is-hinted'); }, 5000);
        }
        try { window.sessionStorage.setItem(HINT_KEY, '1'); } catch (_) {}
      }, 1500);
    }
  }
})();